webpackJsonp([1],{

/***/ "+19q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/hGJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/info-ADVANTAGES-experiential-learning.8968e29.png";

/***/ }),

/***/ "/idB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/vas":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-comms.a4296d2.png";

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0MXf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-WBB.35e83d5.png";

/***/ }),

/***/ "0RC3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "298c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_BUAD_R5.f2ca460.png";

/***/ }),

/***/ "2JNa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Symphony.e353515.jpg";

/***/ }),

/***/ "3V1/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-entrepreneurshipinnov.c820563.png";

/***/ }),

/***/ "3yjQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4BQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Idp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4JDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5lM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "64tm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "70cR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_Visiting_Speakers_4.3592a98.jpg";

/***/ }),

/***/ "859I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "95qn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Ljg4IDI1LjIxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzIzMWYyMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnNjcm9sbF9hcnJvdzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05LjczLDE5LjcxYS40OC40OCwwLDAsMC0uNywwTDUuNDQsMjMuMjlWMGgtMVYyMy4yOUwuODUsMTkuNzFhLjQ4LjQ4LDAsMCwwLS43LDAsLjQ4LjQ4LDAsMCwwLDAsLjdsNC43OSw0LjgsNC43OS00LjhBLjQ4LjQ4LDAsMCwwLDkuNzMsMTkuNzFaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "9DST":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9JiT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Afi4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Movie_Theaters.2256be4.jpg";

/***/ }),

/***/ "B71C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-finance.7cafcf9.png";

/***/ }),

/***/ "BUaY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXew":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BoYu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC-Village_thumbnail.93cfd6a.jpg";

/***/ }),

/***/ "CWaY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DOA7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-real-estate-finance.18b94e6.png";

/***/ }),

/***/ "ESLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CL-get-involved-24.a874fce.png";

/***/ }),

/***/ "EcSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fi60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HQx/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HnTt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ADV-faculty-24.a4ca08b.png";

/***/ }),

/***/ "IKUb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-business-cinematic.5cc49be.png";

/***/ }),

/***/ "IQm2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ImoO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-leadershipinn.726ac1b.png";

/***/ }),

/***/ "J1z8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/info-ADVANTAGES-global-opps.b2abc84.png";

/***/ }),

/***/ "J9A8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JhfJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_ACCT_R3.a10dec6.png";

/***/ }),

/***/ "KCF5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidenav/SidenavSection.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var SidenavSection = ({
  name: 'usc-sidenav-section',
  props: ['title', 'route', 'class-suffix'],
  data: function data() {
    return {
      collapsed: true,
      hidden: true
    };
  },

  methods: {
    checkRoute: function checkRoute() {
      var childRoutes = this.$children.map(function (c) {
        return c.route;
      });
      if (childRoutes.indexOf(this.$route.name) >= 0) {
        this.collapsed = false;
        this.hidden = false;
      }
    },
    collapseSection: function collapseSection(event) {
      var _this = this;

      event.preventDefault();
      var newState = !this.collapsed;
      if (newState) {
        // Collapsed
        this.collapsed = newState;
        // HACK: Wait for the transition to finish (events weren't working)
        setTimeout(function () {
          _this.hidden = newState;
        }, 400);
      } else {
        this.hidden = newState;
        /* HACK: When the hidden state is removed, the item
        immediately becomes visible and doesn't give the transition time to apply
        so wait 10ms before uncollapsing after unhiding to make sure the transition
        applies after the element is unhidden */
        setTimeout(function () {
          _this.collapsed = newState;
        }, 10);
      }
      return false;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.checkRoute();
    }
  },
  mounted: function mounted() {
    this.checkRoute();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae883a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidenav/SidenavSection.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[
    'usc-sidenav--section',
    'usc-sidenav--section_' + _vm.classSuffix,
    { 'usc-sidenav--section_collapsed': _vm.collapsed }
  ]},[(_vm.route)?_c('li',[_c('router-link',{staticClass:"usc-sidenav--section-title usc-sidenav--section-title__linked",attrs:{"to":{ name: _vm.route }}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])],1):_c('li',[_c('button',{staticClass:"usc-sidenav--section-title",attrs:{"aria-expanded":(!_vm.collapsed).toString(),"aria-controls":_vm._uid},on:{"click":_vm.collapseSection}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"caret",attrs:{"aria-hidden":"true"}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1)])]),_vm._v(" "),(_vm.$slots.default)?_c('li',[_c('ul',{staticClass:"usc-sidenav--items",attrs:{"id":_vm._uid,"hidden":_vm.collapsed}},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var Sidenav_SidenavSection = (esExports);
// CONCATENATED MODULE: ./src/components/Sidenav/SidenavSection.vue
function injectStyle (ssrContext) {
  __webpack_require__("/idB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ae883a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SidenavSection,
  Sidenav_SidenavSection,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_Sidenav_SidenavSection = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidenav/SidenavItem.vue
//
//
//
//
//
//

/* harmony default export */ var SidenavItem = ({
  name: 'usc-sidenav-item',
  props: ['route']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3d3459","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidenav/SidenavItem.vue
var SidenavItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"role":"listitem"}},[_c('router-link',{staticClass:"usc-sidenav--item",attrs:{"to":{name: _vm.route},"exact-active-class":"usc-sidenav--item__active"}},[_vm._t("default")],2)],1)}
var SidenavItem_staticRenderFns = []
var SidenavItem_esExports = { render: SidenavItem_render, staticRenderFns: SidenavItem_staticRenderFns }
/* harmony default export */ var Sidenav_SidenavItem = (SidenavItem_esExports);
// CONCATENATED MODULE: ./src/components/Sidenav/SidenavItem.vue
function SidenavItem_injectStyle (ssrContext) {
  __webpack_require__("9DST")
}
var SidenavItem_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SidenavItem___vue_template_functional__ = false
/* styles */
var SidenavItem___vue_styles__ = SidenavItem_injectStyle
/* scopeId */
var SidenavItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidenavItem___vue_module_identifier__ = null
var SidenavItem_Component = SidenavItem_normalizeComponent(
  SidenavItem,
  Sidenav_SidenavItem,
  SidenavItem___vue_template_functional__,
  SidenavItem___vue_styles__,
  SidenavItem___vue_scopeId__,
  SidenavItem___vue_module_identifier__
)

/* harmony default export */ var components_Sidenav_SidenavItem = (SidenavItem_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SectionNav = ({
  name: 'usc-section-nav',
  data: function data() {
    return {
      prevRoute: null,
      nextRoute: null
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.updateRoute(to);
    }
  },
  methods: {
    updateRoute: function updateRoute(to) {
      // Find our route in the sidenav route list
      var routes = lodash_default()(this.$root.sidenav).chain().map(function (n) {
        return n.items || n;
      }) // Account for nav items that have no children
      .flatten().pull(undefined).value();

      var currentRouteIdx = lodash_default()(routes).findIndex(function (r) {
        return r.route === to.name;
      });
      this.prevRoute = currentRouteIdx >= 0 ? routes[currentRouteIdx - 1] : null;
      this.nextRoute = currentRouteIdx < routes.length ? routes[currentRouteIdx + 1] : null;

      this.findRouteParent(routes[currentRouteIdx]);
    },
    findRouteParent: function findRouteParent(route) {
      // Only works if the nav tree is never more than 2 deep
      /*
      debugger
      for (let i = 0; i < this.$root.sidenav.length; i++) {
        if (this.$root.sidenav[i].indexOf(route)) {
          return this.$root.sidenav[i]
        }
        if (this.$root.sidenav[i].items) {
          for(let j = 0; j < this.$root.sidenav[i].items.length; j++) {
            if (this.$root.sidenav[i].items[j].indexOf(route)) {
              return this.$root.sidenav[i].items[j]
            }
          }
        }
      }
      */
      return undefined;

      // Why is this so hard? :(
      /*
      if(root.items) {
        for(const i = 0; i < root.items.length; i++) {
          return findRouteParent(root.items[i], route);
        }
      }
      */
      /*
      debugger
      let parent = undefined
      if(root.indexOf(route) >= 0) {
        parent = root
      } else if(root.items) {
        for (let i = 0; i < root.items && !parent; i++) {
          if(root.items[i].items) {
            parent = this.findRouteParent(root.items[i], route)
          }
        }
      }
      return parent
      */
      /*
      if (root.items && root.items.indexOf(route)) {
        return root
      } else if (root.items) {
        for (let i = 0; i < root.items.length; i++) {
          return this.findRouteParent(root.items[i], route)
        }
      }
      return undefined
      */
    }
  },
  mounted: function mounted() {
    this.updateRoute(this.$route);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ead1cee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionNav.vue
var SectionNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-section-nav"},[(_vm.prevRoute)?_c('router-link',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"usc-section-nav--button usc-section-nav--prev",class:[_vm.nextRoute === undefined ? 'usc-section-nav--fullwidth' : ''],attrs:{"to":{name: _vm.prevRoute.route}}},[_c('div',{staticClass:"usc-section-nav--arrow",attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":__webpack_require__("WYVp"),"alt":"Large arrow pointing left"}})]),_vm._v(" "),_c('div',{staticClass:"usc-section-nav--text"},[_c('span',{staticClass:"usc-section-nav--direction"},[_vm._v("Prev")]),_vm._v(" "),_c('span',{class:['usc-section-nav--title', _vm.prevRoute.classSuffix]},[_vm._v(_vm._s(_vm.prevRoute.title))])])]):_vm._e(),_vm._v(" "),(_vm.nextRoute)?_c('router-link',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"usc-section-nav--button usc-section-nav--next",class:[_vm.prevRoute === undefined ? 'usc-section-nav--fullwidth' : ''],attrs:{"to":{name: _vm.nextRoute.route}}},[_c('div',{staticClass:"usc-section-nav--text"},[_c('span',{staticClass:"usc-section-nav--direction"},[_vm._v("Next")]),_vm._v(" "),_c('span',{class:['usc-section-nav--title', _vm.nextRoute.classSuffix]},[_vm._v(_vm._s(_vm.nextRoute.title))])]),_vm._v(" "),_c('div',{staticClass:"usc-section-nav--arrow",attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":__webpack_require__("WYVp"),"alt":"Large arrow pointing right"}})])]):_vm._e()],1)}
var SectionNav_staticRenderFns = []
var SectionNav_esExports = { render: SectionNav_render, staticRenderFns: SectionNav_staticRenderFns }
/* harmony default export */ var components_SectionNav = (SectionNav_esExports);
// CONCATENATED MODULE: ./src/components/SectionNav.vue
function SectionNav_injectStyle (ssrContext) {
  __webpack_require__("hLXr")
}
var SectionNav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SectionNav___vue_template_functional__ = false
/* styles */
var SectionNav___vue_styles__ = SectionNav_injectStyle
/* scopeId */
var SectionNav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SectionNav___vue_module_identifier__ = null
var SectionNav_Component = SectionNav_normalizeComponent(
  SectionNav,
  components_SectionNav,
  SectionNav___vue_template_functional__,
  SectionNav___vue_styles__,
  SectionNav___vue_scopeId__,
  SectionNav___vue_module_identifier__
)

/* harmony default export */ var src_components_SectionNav = (SectionNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageHeader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PageHeader = ({
  name: 'PageHeader',
  props: ['section', 'page', 'hidemenubutton', 'isMenuExpanded'],
  data: function data() {
    return {
      internalMenuExpanded: this.isMenuExpanded
    };
  },

  watch: {
    isMenuExpanded: function isMenuExpanded(newVal) {
      this.internalMenuExpanded = newVal;
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.internalMenuExpanded = !this.internalMenuExpanded;
      this.$emit('menuclicked');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db26344","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
var PageHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"usc-page-header"},[_c('a',{staticClass:"usc-page-header--hamburger",attrs:{"role":"button","aria-expanded":_vm.isMenuExpanded.toString(),"aria-label":"Menu","tabindex":"0"},on:{"click":_vm.toggleMenu,"keypress":_vm.toggleMenu}},[_c('v-icon',{class:{hidden: _vm.hidemenubutton},attrs:{"large":"","dark":""}},[_vm._v("menu")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/","aria-label":"USC Marshall School of Business - Home","title":"Go to Home","tabindex":"0"}},[_c('div',{staticClass:"usc-page-header--uscm-logo"},[_c('img',{attrs:{"src":__webpack_require__("IQm2"),"alt":"USC Marshall School of Business logo - Home","title":"Go to Home page"}}),_vm._v(" "),_c('span',{staticClass:"uscm-logotext"},[_vm._v("USC Marshall School of Business")])])]),_vm._v(" "),_c('div',{staticClass:"usc-page-header--title"},[(_vm.$root.pageHeader.section)?_c('span',{staticClass:"usc-page-header--section"},[_vm._v(_vm._s(_vm.$root.pageHeader.section))]):_vm._e(),_vm._v(" "),(_vm.$root.pageHeader.title)?_c('span',{staticClass:"usc-page-header--page"},[_vm._v(" - "+_vm._s(_vm.$root.pageHeader.title))]):_vm._e()]),_vm._v(" "),_vm._m(0)],1)}
var PageHeader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-page-header--usc-logo"},[_c('a',{attrs:{"href":"https://www.usc.edu/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("VPos"),"alt":"USC logo"}})])])}]
var PageHeader_esExports = { render: PageHeader_render, staticRenderFns: PageHeader_staticRenderFns }
/* harmony default export */ var components_PageHeader = (PageHeader_esExports);
// CONCATENATED MODULE: ./src/components/PageHeader.vue
function PageHeader_injectStyle (ssrContext) {
  __webpack_require__("yclz")
}
var PageHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageHeader___vue_template_functional__ = false
/* styles */
var PageHeader___vue_styles__ = PageHeader_injectStyle
/* scopeId */
var PageHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageHeader___vue_module_identifier__ = null
var PageHeader_Component = PageHeader_normalizeComponent(
  PageHeader,
  components_PageHeader,
  PageHeader___vue_template_functional__,
  PageHeader___vue_styles__,
  PageHeader___vue_scopeId__,
  PageHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_PageHeader = (PageHeader_Component.exports);

// EXTERNAL MODULE: ./node_modules/gsap/TweenMax.js
var TweenMax = __webpack_require__("+Uzz");
var TweenMax_default = /*#__PURE__*/__webpack_require__.n(TweenMax);

// EXTERNAL MODULE: ./node_modules/gsap/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__("aykR");
var ScrollToPlugin_default = /*#__PURE__*/__webpack_require__.n(ScrollToPlugin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BackToTop.vue
//
//
//
//
//
//
//
//


// eslint-disable-next-line


/* harmony default export */ var BackToTop = ({
  name: 'BackToTop',
  props: [],
  data: function data() {
    return {};
  },

  methods: {
    smoothScroll: function smoothScroll() {
      // Scroll to the top
      TweenMax["TweenMax"].to(window, 0.75, {
        scrollTo: 0,
        ease: 'linear',
        onComplete: this.resetFocus
      });
    },
    resetFocus: function resetFocus() {
      // Set focus to the first focusable element at the top
      var focusableElement = document.querySelector('a, button, input, [tabindex="0"]');
      if (focusableElement) {
        focusableElement.focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2373383a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackToTop.vue
var BackToTop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-backToTop mb"},[_c('button',{attrs:{"aria-label":"back to top"},on:{"click":_vm.smoothScroll}},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("WYVp"),"alt":"Right Arrow"}})])])}
var BackToTop_staticRenderFns = []
var BackToTop_esExports = { render: BackToTop_render, staticRenderFns: BackToTop_staticRenderFns }
/* harmony default export */ var components_BackToTop = (BackToTop_esExports);
// CONCATENATED MODULE: ./src/components/BackToTop.vue
function BackToTop_injectStyle (ssrContext) {
  __webpack_require__("hodW")
}
var BackToTop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BackToTop___vue_template_functional__ = false
/* styles */
var BackToTop___vue_styles__ = BackToTop_injectStyle
/* scopeId */
var BackToTop___vue_scopeId__ = "data-v-2373383a"
/* moduleIdentifier (server only) */
var BackToTop___vue_module_identifier__ = null
var BackToTop_Component = BackToTop_normalizeComponent(
  BackToTop,
  components_BackToTop,
  BackToTop___vue_template_functional__,
  BackToTop___vue_styles__,
  BackToTop___vue_scopeId__,
  BackToTop___vue_module_identifier__
)

/* harmony default export */ var src_components_BackToTop = (BackToTop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Footer = ({
  name: 'Footer',
  props: [],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6337a494","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"usc-footer",attrs:{"role":"contentinfo"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("mHj9"),"alt":"USC Marshall School of Business logo"}}),_vm._v(" "),_c('p',[_vm._v("University of Southern California Marshall School of Business | Copyright 2001 - "+_vm._s(new Date().getFullYear()))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/sitemap","aria-label":"Link to Sitemap"}},[_vm._v("Sitemap")]),_vm._v(" "),_c('a',{attrs:{"href":"http://policy.usc.edu/info-privacy/","target":"_blank"}},[_vm._v("Privacy Policy")])],1)}
var Footer_staticRenderFns = []
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var components_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("4Idp")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = "data-v-6337a494"
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  components_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = (Footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var App = ({
  methods: {
    toggleDrawer: function toggleDrawer(event) {
      this.drawer = !this.drawer;
      if (event) event.preventDefault();
    },
    updateAriaCurrent: function updateAriaCurrent() {
      // Remove aria-current from all links
      var allLinks = document.querySelectorAll('a[aria-current="true"]');
      allLinks.forEach(function (link) {
        link.removeAttribute('aria-current');
      });

      // Add aria-current to the active links
      var activeLinks = document.querySelectorAll('a.router-link-active');
      activeLinks.forEach(function (link) {
        link.setAttribute('aria-current', 'true');
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.updateAriaCurrent();
    this.$router.afterEach(function () {
      _this.updateAriaCurrent();
    });
  },

  components: {
    'usc-sidenav-section': components_Sidenav_SidenavSection,
    'usc-sidenav-item': components_Sidenav_SidenavItem,
    'usc-section-nav': src_components_SectionNav,
    'usc-page-header': src_components_PageHeader,
    'usc-backToTop': src_components_BackToTop,
    'usc-footer': src_components_Footer
  },
  data: function data() {
    return {
      drawer: window.innerWidth >= 1024
    };
  },

  watch: {
    '$route': function $route() {
      // Check screen size, don't close the nav on desktops
      if (window.innerWidth < 1024) {
        this.drawer = false;
      }
    },
    drawer: function drawer(newValue) {
      if (newValue) {
        // Focus the close button
        this.$el.querySelector('.usc-navdrawer--close-button').focus();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68757478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"c5-wrapper"}},[_c('usc-page-header',{attrs:{"isMenuExpanded":_vm.drawer},on:{"menuclicked":_vm.toggleDrawer}}),_vm._v(" "),_c('div',[_c('v-navigation-drawer',{staticClass:"usc-navdrawer",attrs:{"fixed":"","width":"320","mobile-break-point":"1024","disable-route-watcher":"","dark":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('a',{class:['usc-navdrawer--close-button', { hidden: !_vm.drawer }],attrs:{"tabindex":"0","role":"button","href":"#","aria-label":"Close menu"},on:{"click":_vm.toggleDrawer,"keypress":_vm.toggleDrawer}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('div',{staticClass:"usc-navdrawer--logo"},[_c('router-link',{attrs:{"to":"/","aria-label":"USC Marshall School of Business - Home","title":"Go to Home","tabindex":"0"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__("qumo"),"alt":"USC Marshall School of Business logo - Home","title":"Go to Home page"}}),_vm._v(" "),_c('span',{staticClass:"uscm-logotext"},[_vm._v("USC Marshall School of Business")])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.$root.sidenav),function(section){return _c('usc-sidenav-section',{key:section.title,attrs:{"title":section.title,"class-suffix":section.classSuffix,"route":section.route}},_vm._l((section.items),function(item){return _c('usc-sidenav-item',{key:item.route,attrs:{"route":item.route}},[_vm._v(_vm._s(item.title))])}))})],2),_vm._v(" "),_c('v-content',{attrs:{"aria-live":"polite"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('router-view'),_vm._v(" "),_c('usc-backToTop'),_vm._v(" "),_c('usc-section-nav')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('usc-footer')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("fYaB")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Hero.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Hero = ({
  name: 'Hero',
  props: ['title', 'color', 'loResSrc', 'hiResSrc'],
  data: function data() {
    return {
      currentSrc: null
    };
  },
  mounted: function mounted() {
    var loResImg;
    var hiResImg;
    var that;
    var context;
    loResImg = new Image();
    hiResImg = new Image();
    that = this;
    context = this.$el.getElementsByTagName('canvas')[0].getContext('2d');

    loResImg.onload = function () {
      context.drawImage(loResImg, 0, 0);
      if (that.currentSrc === null) {
        that.currentSrc = that.loResSrc;
      }
    };
    hiResImg.onload = function () {
      that.currentSrc = that.hiResSrc;
    };
    loResImg.src = that.loResSrc;
    hiResImg.src = that.hiResSrc;

    document.getElementsByTagName('h1')[0].focus();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1907eb95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
var Hero_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"hero-container",attrs:{"name":"blur","tag":"div"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSrc === null),expression:"currentSrc === null"}],key:0,staticClass:"placeholder blur-transition",attrs:{"key":"placeholder"}}),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSrc === _vm.loResSrc),expression:"currentSrc === loResSrc"}],key:1,staticClass:"blur-transition",attrs:{"height":"17","width":"27","key":"canvas"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSrc === _vm.hiResSrc),expression:"currentSrc === hiResSrc"}],key:2,staticClass:"hero blur-transition",style:({ 'background-image': 'url(' + _vm.hiResSrc + ')' })},[_c('div',{staticClass:"overlay"})]),_vm._v(" "),_c('div',{key:_vm.title,staticClass:"hero__text"},[_c('h1',{attrs:{"tabindex":"-1"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"underline",style:({ backgroundColor: _vm.color })})])])}
var Hero_staticRenderFns = []
var Hero_esExports = { render: Hero_render, staticRenderFns: Hero_staticRenderFns }
/* harmony default export */ var components_Hero = (Hero_esExports);
// CONCATENATED MODULE: ./src/components/Hero.vue
function Hero_injectStyle (ssrContext) {
  __webpack_require__("T8k0")
}
var Hero_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Hero___vue_template_functional__ = false
/* styles */
var Hero___vue_styles__ = Hero_injectStyle
/* scopeId */
var Hero___vue_scopeId__ = "data-v-1907eb95"
/* moduleIdentifier (server only) */
var Hero___vue_module_identifier__ = null
var Hero_Component = Hero_normalizeComponent(
  Hero,
  components_Hero,
  Hero___vue_template_functional__,
  Hero___vue_styles__,
  Hero___vue_scopeId__,
  Hero___vue_module_identifier__
)

/* harmony default export */ var src_components_Hero = (Hero_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Intro.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Intro = ({
  name: 'Intro',
  props: ['copy'],
  data: function data() {
    return {
      // 'copy': copy
      // title: 'Header 1: Title',
      // imgSrc: 'http://via.placeholder.com/1900x1080'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1523fb68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
var Intro_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro mb"},[_vm._m(0),_vm._v(" "),_vm._t("title"),_vm._v(" "),_vm._t("cta"),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("p"),_vm._v(" "),_vm._l((_vm.copy),function(p,index){return _c('p',{staticClass:"body"},[_vm._v(_vm._s(p))])}),_vm._v(" "),_vm._t("cta-bottom"),_vm._v(" "),_vm._t("list"),_vm._v(" "),_vm._t("twoColumns")],2)}
var Intro_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"instructions"},[_c('span',{staticClass:"text"},[_vm._v("Scroll  ")]),_vm._v(" "),_c('img',{attrs:{"aria-hidden":"true","alt":"down arrow","src":__webpack_require__("95qn")}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("  Down")])])}]
var Intro_esExports = { render: Intro_render, staticRenderFns: Intro_staticRenderFns }
/* harmony default export */ var components_Intro = (Intro_esExports);
// CONCATENATED MODULE: ./src/components/Intro.vue
function Intro_injectStyle (ssrContext) {
  __webpack_require__("QbaH")
}
var Intro_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Intro___vue_template_functional__ = false
/* styles */
var Intro___vue_styles__ = Intro_injectStyle
/* scopeId */
var Intro___vue_scopeId__ = "data-v-1523fb68"
/* moduleIdentifier (server only) */
var Intro___vue_module_identifier__ = null
var Intro_Component = Intro_normalizeComponent(
  Intro,
  components_Intro,
  Intro___vue_template_functional__,
  Intro___vue_styles__,
  Intro___vue_scopeId__,
  Intro___vue_module_identifier__
)

/* harmony default export */ var src_components_Intro = (Intro_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/videoEmbed.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var videoEmbed = ({
  name: 'videoEmbed',
  props: ['caption', 'videoSource', 'frameTitle'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345f8b80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoEmbed.vue
var videoEmbed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video gutter-md mb"},[_c('div',{staticClass:"padding"},[_c('iframe',{attrs:{"title":_vm.frameTitle,"src":_vm.videoSource,"width":"640","height":"360","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})]),_vm._v(" "),_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))])])}
var videoEmbed_staticRenderFns = []
var videoEmbed_esExports = { render: videoEmbed_render, staticRenderFns: videoEmbed_staticRenderFns }
/* harmony default export */ var components_videoEmbed = (videoEmbed_esExports);
// CONCATENATED MODULE: ./src/components/videoEmbed.vue
function videoEmbed_injectStyle (ssrContext) {
  __webpack_require__("hW/J")
}
var videoEmbed_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var videoEmbed___vue_template_functional__ = false
/* styles */
var videoEmbed___vue_styles__ = videoEmbed_injectStyle
/* scopeId */
var videoEmbed___vue_scopeId__ = "data-v-345f8b80"
/* moduleIdentifier (server only) */
var videoEmbed___vue_module_identifier__ = null
var videoEmbed_Component = videoEmbed_normalizeComponent(
  videoEmbed,
  components_videoEmbed,
  videoEmbed___vue_template_functional__,
  videoEmbed___vue_styles__,
  videoEmbed___vue_scopeId__,
  videoEmbed___vue_module_identifier__
)

/* harmony default export */ var src_components_videoEmbed = (videoEmbed_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CalloutLink.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var CalloutLink = ({
  name: 'CalloutLink',
  props: ['title', 'urltext', 'url'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7980317d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalloutLink.vue
var CalloutLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-calloutLink gutter-md mb"},[_c('div',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.urltext))])])])}
var CalloutLink_staticRenderFns = []
var CalloutLink_esExports = { render: CalloutLink_render, staticRenderFns: CalloutLink_staticRenderFns }
/* harmony default export */ var components_CalloutLink = (CalloutLink_esExports);
// CONCATENATED MODULE: ./src/components/CalloutLink.vue
function CalloutLink_injectStyle (ssrContext) {
  __webpack_require__("sG2v")
}
var CalloutLink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CalloutLink___vue_template_functional__ = false
/* styles */
var CalloutLink___vue_styles__ = CalloutLink_injectStyle
/* scopeId */
var CalloutLink___vue_scopeId__ = "data-v-7980317d"
/* moduleIdentifier (server only) */
var CalloutLink___vue_module_identifier__ = null
var CalloutLink_Component = CalloutLink_normalizeComponent(
  CalloutLink,
  components_CalloutLink,
  CalloutLink___vue_template_functional__,
  CalloutLink___vue_styles__,
  CalloutLink___vue_scopeId__,
  CalloutLink___vue_module_identifier__
)

/* harmony default export */ var src_components_CalloutLink = (CalloutLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Welcome.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Welcome = ({
  name: 'Welcome',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-calloutLink': src_components_CalloutLink
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Welcome',
        loResSrc: '../../static/blur/Welcome-Marshall147.jpg',
        hiResSrc: '../../static/HeroImages/Marshall147.jpg'
      },
      intro: ['Welcome to the Trojan Family! Being admitted to USC Marshall, one of the world’s top comprehensive business schools, is a recognition of your academic skill, personal achievement and potential for leadership. Congratulations on your admission. You’ve earned this!'],
      video: {
        caption: 'Dean Geoffrey Garrett',
        src: 'https://player.vimeo.com/video/746951106',
        frameTitle: 'Video: Undergraduate Innovation'
      },
      calloutLink: {
        title: 'Accept my offer',
        url: 'https://applyto.usc.edu/apply/status',
        urlText: 'Count me in!'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Welcome', 'Congratulations');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0099279f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Welcome.vue
var Welcome_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"introduction"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('h2',[_vm._v("Congratulations on Your Admission")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-calloutLink',{attrs:{"url":this.calloutLink.url,"urltext":this.calloutLink.urlText}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}})],1)}
var Welcome_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("We’ve developed this site with resources and information that will help you get to know Marshall better — and introduce you to the life-changing and career-shaping opportunities that are only available here.")]),_vm._v(" "),_c('p',[_c('i',{},[_vm._v("As a Marshall undergraduate, you will be able to take four full years of business classes, building foundational knowledge and in-demand skills sought by employers. All Marshall programs are STEM-designated — a recognition of the technology and quantitative focus of our curriculum and a signal to employers that our graduates will be well-prepared for tomorrow’s demanding careers. Our nine emphases — optional, industry-driven specializations — let you personalize your degree and will help set you apart in the marketplace. Taking advantage of USC’s status as a world-class private research university, Marshall also gives you ample opportunity to explore your interests across disciplines in USC’s other top-ranked schools.")])]),_vm._v(" "),_c('p',[_vm._v("Double major or select one of our joint degrees — including the groundbreaking Artificial Intelligence for Business program, the renowned John H. Mitchell Business of Cinematic Arts program and the brand-new Real Estate Finance + Development program. You can also pick a minor — or multiple minors — or choose from a huge range of electives across the university to customize your education and meet your professional aspirations.")]),_vm._v(" "),_c('p',[_vm._v("All of this and more is why Poets&Quants ranks Marshall the world’s top undergraduate business school.")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("hGbN"),"alt":"Infographic: 16k Degree Combinations, 200+ Majors, and 250+ Minors.","title":"Infographic: 16k Degree Combinations, 200 Majors, and 220+ Minors."}}),_vm._v(" "),_c('p',[_vm._v("As you map out your unique educational path, you will gain a world of opportunity, literally. The vast major of Marshall freshmen participate in one of our innovative global offerings, obtaining an international perspective and invaluable skill set.")]),_vm._v(" "),_c('p',[_vm._v("Our home in Los Angeles is another distinct advantage. This international financial hub and creative capital of the world is known for its pioneering spirit and leadership in entertainment, business startups, real estate and technology — but it also offers countless ways to enjoy your downtime. With the USC campus just a few miles from legendary beaches and a booming downtown, you will never want for activities or fun in the sun. And yes, some of our best beach days are in February.")]),_vm._v(" "),_c('p',[_vm._v("You’ll make lifelong friends and mentors at Marshall. The minute you enroll, you’re a Trojan. And that’s a big deal. You join an unparalleled alumni network that will hire you, promote you, connect you and celebrate with you for the rest of your life.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Lifelong, Worldwide")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("X+KW"),"alt":"Infographic: 478k+ Global Alumni, 91k+ Marshall Alumni, 145 Countries, 1/3 Marshall alumni under the age of 35","title":"Infographic: 463k+ Global Alumni, 91k+ Marshall Alumni, 145 Countries, 1/3 Marshall alumni under the age of 35"}}),_vm._v(" "),_c('p',[_vm._v("We look forward to getting to know you better, learning about your passions and goals — and helping you on your path to fulfilling your dreams. This guide is just the beginning of the collaborative process of your journey at USC Marshall. We hope to have many conversations with you and your family as you finalize your college decision. Reach out to us directly at any time at "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:busadm@marshall.usc.edu"}},[_vm._v("busadm@marshall.usc.edu")]),_vm._v(".")])])}]
var Welcome_esExports = { render: Welcome_render, staticRenderFns: Welcome_staticRenderFns }
/* harmony default export */ var pages_Welcome = (Welcome_esExports);
// CONCATENATED MODULE: ./src/pages/Welcome.vue
function Welcome_injectStyle (ssrContext) {
  __webpack_require__("REfZ")
}
var Welcome_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Welcome___vue_template_functional__ = false
/* styles */
var Welcome___vue_styles__ = Welcome_injectStyle
/* scopeId */
var Welcome___vue_scopeId__ = "data-v-0099279f"
/* moduleIdentifier (server only) */
var Welcome___vue_module_identifier__ = null
var Welcome_Component = Welcome_normalizeComponent(
  Welcome,
  pages_Welcome,
  Welcome___vue_template_functional__,
  Welcome___vue_styles__,
  Welcome___vue_scopeId__,
  Welcome___vue_module_identifier__
)

/* harmony default export */ var src_pages_Welcome = (Welcome_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Table = ({
  name: 'Table',
  props: ['title', 'data', 'disclaimer'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00859230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
var Table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-table gutter-lg mb"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('table',_vm._l((_vm.data),function(d,index){return _c('tr',[_c('td',[_vm._v(_vm._s(d.left))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(d.right))])])})),_vm._v(" "),_c('p',{staticClass:"disclaimer"},[_vm._v(_vm._s(_vm.disclaimer))])],2)}
var Table_staticRenderFns = []
var Table_esExports = { render: Table_render, staticRenderFns: Table_staticRenderFns }
/* harmony default export */ var components_Table = (Table_esExports);
// CONCATENATED MODULE: ./src/components/Table.vue
function Table_injectStyle (ssrContext) {
  __webpack_require__("mFQ1")
}
var Table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Table___vue_template_functional__ = false
/* styles */
var Table___vue_styles__ = Table_injectStyle
/* scopeId */
var Table___vue_scopeId__ = "data-v-00859230"
/* moduleIdentifier (server only) */
var Table___vue_module_identifier__ = null
var Table_Component = Table_normalizeComponent(
  Table,
  components_Table,
  Table___vue_template_functional__,
  Table___vue_styles__,
  Table___vue_scopeId__,
  Table___vue_module_identifier__
)

/* harmony default export */ var src_components_Table = (Table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Cta.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Cta = ({
  name: 'Cta',
  props: ['text', 'url'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c3dcbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cta.vue
var Cta_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cta-link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"cta-flex"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('img',{staticClass:"cta-icon",attrs:{"src":__webpack_require__("RkOG"),"alt":"Click arrow","aria-hidden":"true"}})])])}
var Cta_staticRenderFns = []
var Cta_esExports = { render: Cta_render, staticRenderFns: Cta_staticRenderFns }
/* harmony default export */ var components_Cta = (Cta_esExports);
// CONCATENATED MODULE: ./src/components/Cta.vue
function Cta_injectStyle (ssrContext) {
  __webpack_require__("b3wA")
}
var Cta_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Cta___vue_template_functional__ = false
/* styles */
var Cta___vue_styles__ = Cta_injectStyle
/* scopeId */
var Cta___vue_scopeId__ = "data-v-35c3dcbe"
/* moduleIdentifier (server only) */
var Cta___vue_module_identifier__ = null
var Cta_Component = Cta_normalizeComponent(
  Cta,
  components_Cta,
  Cta___vue_template_functional__,
  Cta___vue_styles__,
  Cta___vue_scopeId__,
  Cta___vue_module_identifier__
)

/* harmony default export */ var src_components_Cta = (Cta_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataViz.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DataViz = ({
  name: 'DataViz',
  props: ['data'],
  data: function data() {
    return {};
  },

  computed: {
    hasSVG: function hasSVG() {
      return this.$slots.svg;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b75dd12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataViz.vue
var DataViz_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-data gutter-lg mb body"},[_c('div',{staticClass:"usc-data__col usc-data__col--left"},[_vm._t("title"),_vm._v(" "),_vm._l((_vm.data),function(item,index){return _c('div',{staticClass:"usc-data__key"},[_c('div',{staticClass:"usc-data__key-block",style:({ backgroundColor: item.color })}),_vm._v(" "),_c('div',{staticClass:"usc-data__key-label"},[_c('div',{staticClass:"usc-data__label-bold"},[_vm._v("\n          "+_vm._s(item.labelBold)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"usc-data__label-small"},[_vm._v("\n          "+_vm._s(item.labelSmall)+"\n        ")])])])})],2),_vm._v(" "),_c('div',{staticClass:"usc-data__col usc-data__col--svg"},[(_vm.hasSVG)?_c('div',{staticClass:"scaling-svg-container"},[_vm._t("svg")],2):_vm._e(),_vm._v(" "),_vm._t("label")],2)])}
var DataViz_staticRenderFns = []
var DataViz_esExports = { render: DataViz_render, staticRenderFns: DataViz_staticRenderFns }
/* harmony default export */ var components_DataViz = (DataViz_esExports);
// CONCATENATED MODULE: ./src/components/DataViz.vue
function DataViz_injectStyle (ssrContext) {
  __webpack_require__("yzTS")
}
var DataViz_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataViz___vue_template_functional__ = false
/* styles */
var DataViz___vue_styles__ = DataViz_injectStyle
/* scopeId */
var DataViz___vue_scopeId__ = "data-v-7b75dd12"
/* moduleIdentifier (server only) */
var DataViz___vue_module_identifier__ = null
var DataViz_Component = DataViz_normalizeComponent(
  DataViz,
  components_DataViz,
  DataViz___vue_template_functional__,
  DataViz___vue_styles__,
  DataViz___vue_scopeId__,
  DataViz___vue_module_identifier__
)

/* harmony default export */ var src_components_DataViz = (DataViz_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/Overview.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Overview = ({
  name: 'Overview',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-cta': src_components_Cta,
    'usc-dataviz': src_components_DataViz,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-calloutLink': src_components_CalloutLink
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      calloutLink: {
        title: 'Your Future, Your Way',
        url: 'https://curriculum.marshall.usc.edu/',
        urlText: 'Your Future, Your Way'
      },
      hero: {
        title: 'Academics',
        loResSrc: '../../../static/HeroImages/Academics6.jpg',
        hiResSrc: '../../../static/HeroImages/Academics6.jpg'
      },
      video: {
        caption: 'Raman Randhawa - Vice Dean, Undergraduate Programs',
        src: 'https://player.vimeo.com/video/743203385',
        frameTitle: 'Video: Raman Randhawa - Vice Dean, Undergraduate Programs'
      },
      video2: {
        caption: 'AI: Seed for Change or Existential Threat? Vishal Gupta - Associate Professor of Data Science and Operations',
        src: 'https://player.vimeo.com/video/642794506',
        frameTitle: 'AI: Seed for Change or Existential Threat? Video: Vishal Gupta - Associate Professor of Data Science and Operations'
      },
      table: {
        title: 'Curriculum Structure',
        data: [{
          left: 'USC Required Courses',
          right: '40'
        }, {
          left: 'Marshall Core',
          right: '48'
        }, {
          left: 'Marshall Upper-Division Electives',
          right: '12'
        }, {
          left: 'Free Electives/Minor',
          right: '32*'
        }],
        disclaimer: '*Subject to course selection and examination credit policy.'
      },
      dataViz: [{
        color: '#ffcc00',
        labelBold: '3,750',
        labelSmall: 'Business Administration'
      }, {
        color: '#990000',
        labelBold: '300',
        labelSmall: 'Accounting'
      }, {
        color: '#f15929',
        labelBold: '200',
        labelSmall: 'World Bachelor in Business'
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Overview');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b2349de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/Overview.vue
var Overview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_overview"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('p',[_vm._v("Today’s business leaders must possess a global mindset that allows them to cross borders effortlessly, whether those boundaries are international, cultural or disciplinary. The USC Marshall undergraduate curriculum is tailored toward that objective.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-calloutLink',{attrs:{"url":this.calloutLink.url,"urltext":this.calloutLink.urlText}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('usc-dataviz',{attrs:{"data":_vm.dataViz}},[_c('svg',{staticClass:"scaling-svg",attrs:{"slot":"svg","xmlns":"http://www.w3.org/2000/svg","width":"322","height":"322","viewBox":"0 0 322 322"},slot:"svg"},[_c('path',{attrs:{"fill":"#f15929","d":"M161 161L116.898 7.198C131.593 2.984 145.713 1 161 1v160z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#900","d":"M161 161L17.193 90.861c20.414-41.856 54.94-70.826 99.705-83.662L161 161z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FC0","d":"M161 161V1c88.366 0 160 71.634 160 160s-71.634 160-160 160S1 249.366 1 161c0-26.421 4.611-46.392 16.193-70.139L161 161z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"161","y1":"301","x2":"161","y2":"21"}},[_c('stop',{attrs:{"offset":".5","stop-color":"#f7f7f5"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#fff"}})],1),_vm._v(" "),_c('circle',{attrs:{"fill":"url(#a)","cx":"161","cy":"161","r":"140"}})],1),_vm._v(" "),_c('h3',{staticClass:"chartTitle",attrs:{"slot":"title"},slot:"title"},[_vm._v("Marshall Student  "),_c('br'),_vm._v(" Breakdown by Major")]),_vm._v(" "),_c('div',{staticClass:"usc-data__label-container",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"usc-data__label-number"},[_vm._v("\n        4,250\n      ")]),_vm._v(" "),_c('div',{staticClass:"usc-data__label-sub"},[_vm._v("\n        Marshall Students\n      ")])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video2.frameTitle,"caption":this.video2.caption,"videoSource":this.video2.src}}),_vm._v(" "),_vm._m(7)],1)}
var Overview_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('i',{},[_vm._v("Every student has distinctive interests and career goals. Marshall gives you the freedom to create an education experience that is unique to your needs and that builds your global and interdisciplinary perspective while maintaining a rigorous core business program. You can take a mix of business and non-business subjects every semester.")])]),_vm._v(" "),_c('p',[_vm._v("The Marshall curriculum blends skills and knowledge in a primary area of expertise with focused experiences outside that arena through minors, double majors, joint degrees, co-curricular activities and experiential learning opportunities. You can customize your academic program, pursue your passions and build the skills to succeed in the classroom and in your dream role in the business world.")]),_vm._v(" "),_c('p',[_vm._v("As a comprehensive business school, we also offer nine one-year specialized master programs that let you earn an advanced degree along with your undergraduate degree.")]),_vm._v(" "),_c('p',[_vm._v("As you explore the endless combinations available to you at Marshall, we’ll be here to guide you through the process. Our academic advisors can help you design the curriculum path and variety of elective-course combinations best suited to your career goals.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('img',{attrs:{"src":__webpack_require__("qv8h"),"alt":"36 USC Required Courses, 48 Marshall Core, 12 Mrshall Upper-Division Election, 32 Free Electives/Minors"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Marshall Degrees")]),_vm._v(" "),_c('p',[_vm._v("Each of our dynamic degree programs offers you outstanding academic preparation, rewarding internship and international experiences, unique hands-on learning opportunities, career-building tools and resources, meaningful mentorships and membership in our unparalleled Trojan Family global alumni network. And no matter which degree program you choose, you’ll be able to customize your education to fit your personal goals and interests.")]),_vm._v(" "),_c('div',{staticClass:"gridbox mb"},[_c('div',{staticClass:"gridbox-items"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("PeyX"),"alt":"Business Administration Icon"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-items"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("feuz"),"alt":"Accounting Icon"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-items"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("0MXf"),"alt":"World Bachelor In Business Icon"}})])])]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("BUSINESS ADMINISTRATION "),_c('br'),_vm._v("Breadth with depth")])]),_vm._v(" "),_c('p',[_vm._v("Our flagship Business Administration program gives you thorough preparation in the cornerstones of business, with a focus on leadership development and the acquisition of managerial skills. The core curriculum emphasizes experiential learning that nurtures entrepreneurial talent and fosters critical thinking while ensuring plentiful elective options.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("ACCOUNTING "),_c('br'),_vm._v("Innovative, immersive, international")])]),_vm._v(" "),_c('p',[_vm._v("Graduate from the program as both a qualified accountant and well-rounded professional. The Leventhal School of Accounting within the Marshall School of Business offers a rigorous curriculum designed to ensure your technical proficiency, research and analytical skills, ethical decision-making mindset and leadership development. You’ll learn from top faculty and mentors as you build skills for your successful career.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("WORLD BACHELOR IN BUSINESS "),_c('br'),_vm._v("Fluency in international commerce")])]),_vm._v(" "),_c('p',[_vm._v("The only undergraduate program of its kind, the World Bachelor in Business offers you degrees from three leading research universities and access to three global alumni networks. You’ll benefit from cultural immersion and real-world experiences in Los Angeles, Hong Kong and Milan, and become well-versed in how to conduct business in Asia, Europe and the Americas.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('div',{staticClass:"cardinal-line mt",staticStyle:{"margin-bottom":"1em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Emphases for Business Administration Students")]),_vm._v(" "),_c('p',[_vm._v("Our emphases are optional specializations for students in our Business Administration degree program that allow you to further customize your education to suit your interests and career goals.")]),_vm._v(" "),_c('p',[_c('i',{},[_vm._v("Marshall’s emphases give you an opportunity to gain broad or deep expertise in one of nine areas that are in high demand among employers. No matter what career path you pursue, the knowledge and skills you gain through your chosen emphasis will give you a thorough preparation in some of the most relevant and impactful areas for the future of global business. Adding an emphasis to your résumé will increase your competitiveness on the job market.")])]),_vm._v(" "),_c('p',[_vm._v("To be eligible to declare an emphasis, you must have sophomore standing and have spent one semester in residence at USC. You must also complete the gateway course for the emphasis. You may only declare one of the nine emphases offered, but you can combine your emphasis with one of our renowned joint or dual-degree programs, interdisciplinary offerings, one or more minors, and any of our other signature Marshall experiences. You can declare an emphasis up until the last day of class of your final semester as long as you meet the other requirements.")]),_vm._v(" "),_c('div',{staticClass:"gridbox mb"},[_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("yG8X"),"alt":"Business Analytics"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("/vas"),"alt":"Communication"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("3V1/"),"alt":"Entrepreneurship and Innovation"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("B71C"),"alt":"Finance"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("ImoO"),"alt":"Leadership and Innovation"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("kZP/"),"alt":"Marketing"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("NZJK"),"alt":"Real Estate Finance"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("Uqfa"),"alt":"Risk Management"}})])])]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("BUSINESS ANALYTICS "),_c('br'),_vm._v("Data-driven decision making")])]),_vm._v(" "),_c('p',[_vm._v("Big data drives most industries today, as well as the global economy. Through the emphasis in Business Analytics, you have a choice of pursuing a broad perspective — gaining such knowledge and skills as exploratory data analysis, data visualization and computer programming that support multiple business fields — or depth of knowledge and skills, such as machine learning, forecasting and optimization techniques that focus on specific business fields (e.g., operations-related or market-related analytics).")]),_vm._v(" "),_c('p',[_vm._v("Whichever path you select within the emphasis, you will learn how to turn data into meaningful business insights as you support organizations in analyzing and delivering data-driven decision-making, implementation and evaluation. Data-savvy leaders are needed across a wide range of industries, including healthcare, entertainment, energy, retail, technology, interactive gaming, media, sports, hospitality, automotive, consumer goods, transportation, logistics, manufacturing and financial services.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("COMMUNICATION "),_c('br'),_vm._v("Versatile, in-demand skills across industries")])]),_vm._v(" "),_c('p',[_vm._v("No matter what field of business or what industry you work in, exemplary communication skills are among the most prized by employers. Students in this emphasis will learn how to effectively engage and persuade organizational stakeholders to achieve results as well as lead and motivate diverse teams, in-person, virtually and in disperse locations globally. You’ll build skills in developing communication strategies, navigating complex communications situations and handling crisis communications.")]),_vm._v(" "),_c('p',[_vm._v("This emphasis will benefit students pursuing careers across all industries and fields. Particularly, anyone pursuing roles in consulting, marketing, sales, consumer products, media, entrepreneurship, healthcare and human resources that rely heavily on communication strategy and persuasion will greatly benefit from the Communication emphasis.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("ENTREPRENEURSHIP AND INNOVATION "),_c('br'),_vm._v("Capable problem-solving in a dynamic world")])]),_vm._v(" "),_c('p',[_vm._v("Developing an entrepreneurial mindset and the ability to identify, evaluate and pursue new and innovative opportunities will serve you well, whether your career takes you into the startup realm or employment in an existing organization. The Entrepreneurship and Innovation emphasis will help build your skills in problem-solving, creativity, adaptability, flexibility and decision-making in dynamic business situations in which calculated risk may lead to major reward. The emphasis signals to potential employers that you are a capable problem-solver who understands how to build, launch and grow new initiatives.")]),_vm._v(" "),_c('p',[_vm._v("Students in this emphasis will interact with founders and leaders from a wide range of organizations, who will share their experiences from idea through launch and growth. Experiential learning is a significant component of this emphasis, so you will be able to apply your learnings to diverse business opportunities.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("FINANCE "),_c('br'),_vm._v("Analysis skills for decision making and value creation")])]),_vm._v(" "),_c('p',[_vm._v("Choose classes that provide a breadth of knowledge and skills as a finance generalist — or those that provide deep knowledge and skills aligned with a specific subfield or career path. The latter include financial modeling and valuation, institutional and market knowledge, financial strategy — including risk management and capital raising — and investment and wealth-management strategies and techniques.")]),_vm._v(" "),_c('p',[_vm._v("Whichever focus you choose, you will learn the tools and frameworks that guide financial decisions and strategies, as well as how financial markets function and the roles of various institutions. You’ll gain essential analytical and critical-thinking skills as well as preparation to work in various capacities within the financial services industry, including corporations, government and nonprofits. The range of positions across corporate finance, financial services, investment management, and financial and economic consulting is vast. The emphasis also provides a strong foundation for graduate study in business, economics and law.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("INTERNATIONAL RELATIONS "),_c('br'),_vm._v("Engaging a world of opportunities")])]),_vm._v(" "),_c('p',[_vm._v("Bringing business acumen to the perspective of diplomatic engagement, this emphasis combines the strengths of USC Marshall and the USC School of International Relations. The wide-ranging course offerings include multinational enterprises and world politics, conflict mediation and negotiation, gender and global issues, ethnicity and nationalism, as well as region-specific topics relating to China, Russia, Latin America, Africa, the Middle East and more.")]),_vm._v(" "),_c('p',[_vm._v("You’ll gain expertise at the intersection of commercial, civic and political exchanges as well as a thorough grounding in issues relating to international security and how to succeed in the complex and dynamic global economy.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("LEADERSHIP AND INNOVATION "),_c('br'),_vm._v("Vision and strategy for competitive advantage")])]),_vm._v(" "),_c('p',[_vm._v("Students who choose this emphasis will learn how to create an inspiring vision and strategy for innovation in their organization, effectively lead high-performing innovative teams, create a culture of agility and innovation, and effectively identify and solve critical problems to build sustainable competitive advantage and satisfy a diverse set of stakeholders.")]),_vm._v(" "),_c('p',[_vm._v("Focus on either obtaining a breadth of knowledge and skills through diverse management and organization classes — or deeper knowledge and skills in a specific subfield such as global strategy and global leadership. Whichever you choose, you will be well-prepared to lead in a wide range of industries and organizations — from small entrepreneurial firms to large corporations.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("MARKETING "),_c('br'),_vm._v("Strategies to address diverse consumer needs")])]),_vm._v(" "),_c('p',[_vm._v("Marketing is key to every organization’s success, and students in the Marketing emphasis will develop the knowledge and skills to meet diverse consumer needs through innovative products and services, compelling messages, competitive pricing and effective distribution. You will choose to focus on general insight into this essential business function or build specific expertise in a subfield, such as digital marketing or sales. Either way, you will gain creative and analytical skills to help organizations across multiple industries develop, implement and evaluate effective marketing strategies.")]),_vm._v(" "),_c('p',[_vm._v("The Marketing emphasis prepares you for careers in brand management, advertising, public relations, digital marketing, sales, marketing research and analytics, and many other fields.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("REAL ESTATE FINANCE "),_c('br'),_vm._v("Dynamic growth in an ever-changing market")])]),_vm._v(" "),_c('p',[_vm._v("Real estate finance is a dynamic and competitive industry, and plays a major role in the global economy. Marshall has longstanding strengths in the field, and students in the Real Estate Finance emphasis will benefit from a particularly strong network of alumni working in this arena.")]),_vm._v(" "),_c('p',[_vm._v("Gain knowledge and skills that will help you perform complex tasks involving real estate finance and development, economics and state-of-the-art computer modeling. You’ll become well-versed in valuation and analysis, raising capital for real estate investment projects, the mortgage markets, financial modeling and more.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("RISK MANAGEMENT "),_c('br'),_vm._v("Mitigation to maximize opportunity")])]),_vm._v(" "),_c('p',[_vm._v("All careers and industries involve risk management. Given the growing complexity and interconnectedness of the global economy, more and more employers are seeking talent with risk management skills. Few colleges and universities offer an emphasis or program in risk management, so your selection of this emphasis will help you stand out in the marketplace.You will gain critical skills in how to identify, assess, control, finance and report risk. In addition, students in the Risk Management emphasis will have the opportunity to be paired with a mentor from the risk management profession as well as the chance to attend numerous networking and recruiting events. These events typically attract 40 employers a year, including banks, consulting firms and insurance companies.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('div',{staticClass:"cardinal-line mt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Joint Programs")]),_vm._v(" "),_c('p',[_vm._v("Building on USC’s interdisciplinary strengths and status as a leading research university, our joint degree programs offer the best of two worlds to students who want to pursue a business degree in combination with another leading USC academic program in one of four in-demand fields.")]),_vm._v(" "),_c('div',{staticClass:"gridbox mb"},[_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("eNHY"),"alt":"AI for Business"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("IKUb"),"alt":"Business of Cinematic Arts"}})])]),_vm._v(" "),_c('div',{staticClass:"gridbox-itemsB"},[_c('div',{staticClass:"gridbox-items--img"},[_c('img',{attrs:{"src":__webpack_require__("DOA7"),"alt":"Real Estate Finance + Development"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h3',[_c('strong',[_vm._v("ARTIFICIAL INTELLIGENCE FOR BUSINESS (BUAI) "),_c('br'),_vm._v("\n    Harnessing technology to build opportunity")])]),_vm._v(" "),_c('p',[_vm._v("From blockchain to self-driving vehicles to personalized medicine, AI is changing how we live and transforming every industry. Offered in partnership with the top-ranked USC Viterbi School of Engineering, the small-cohort Artificial Intelligence for Business degree (BUAI) prepares students to excel in this exciting field at the intersection of business and computer science. This first-of-its-kind program blends core business concepts with big data knowledge to foster the skills essential for leadership in an ever-evolving technological landscape.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("CINEMATIC ARTS (BCA) "),_c('br'),_vm._v("\n    Real-world creative leadership")])]),_vm._v(" "),_c('p',[_vm._v("Taking advantage of our location in the world’s entertainment capital, the John H. Mitchell Business of Cinematic Arts (BCA) program pairs Marshall exceptional business curriculum with the top-ranked School of Cinematic Arts for interdisciplinary coursework and coveted internship experiences. You’ll gain unparalleled, specialized expertise that will distinguish you in the marketplace for both business and entertainment career opportunities.")]),_vm._v(" "),_c('h3',[_c('strong',[_vm._v("REAL ESTATE FINANCE + DEVELOPMENT (REFD) "),_c('br'),_vm._v("\n    Building communities")])]),_vm._v(" "),_c('p',[_vm._v("Combining the strengths of the renowned Wilbur H. Smith III Department of Real Estate Development at USC Price and Marshall’s longstanding real estate finance curriculum, this brand-new joint degree focuses on integrated courses, cohort building and industry engagement. You’ll benefit from both schools’ strong ties with local, national and international real estate development and investment firms.")])])}]
var Overview_esExports = { render: Overview_render, staticRenderFns: Overview_staticRenderFns }
/* harmony default export */ var academics_Overview = (Overview_esExports);
// CONCATENATED MODULE: ./src/pages/academics/Overview.vue
function Overview_injectStyle (ssrContext) {
  __webpack_require__("BXew")
}
var Overview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Overview___vue_template_functional__ = false
/* styles */
var Overview___vue_styles__ = Overview_injectStyle
/* scopeId */
var Overview___vue_scopeId__ = "data-v-7b2349de"
/* moduleIdentifier (server only) */
var Overview___vue_module_identifier__ = null
var Overview_Component = Overview_normalizeComponent(
  Overview,
  academics_Overview,
  Overview___vue_template_functional__,
  Overview___vue_styles__,
  Overview___vue_scopeId__,
  Overview___vue_module_identifier__
)

/* harmony default export */ var pages_academics_Overview = (Overview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CourseChart/CourseChartKey.vue
//
//
//
//
//
//
//

/* harmony default export */ var CourseChartKey = ({
  name: 'CourseKey',
  props: ['color', 'label'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fc92295","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseChart/CourseChartKey.vue
var CourseChartKey_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key-item"},[_c('div',{staticClass:"key-item__square",class:'key-item__square--' + _vm.color}),_vm._v(" "),_c('div',{staticClass:"key-item__label"},[_vm._v(_vm._s(_vm.label))])])}
var CourseChartKey_staticRenderFns = []
var CourseChartKey_esExports = { render: CourseChartKey_render, staticRenderFns: CourseChartKey_staticRenderFns }
/* harmony default export */ var CourseChart_CourseChartKey = (CourseChartKey_esExports);
// CONCATENATED MODULE: ./src/components/CourseChart/CourseChartKey.vue
function CourseChartKey_injectStyle (ssrContext) {
  __webpack_require__("EcSO")
}
var CourseChartKey_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CourseChartKey___vue_template_functional__ = false
/* styles */
var CourseChartKey___vue_styles__ = CourseChartKey_injectStyle
/* scopeId */
var CourseChartKey___vue_scopeId__ = "data-v-7fc92295"
/* moduleIdentifier (server only) */
var CourseChartKey___vue_module_identifier__ = null
var CourseChartKey_Component = CourseChartKey_normalizeComponent(
  CourseChartKey,
  CourseChart_CourseChartKey,
  CourseChartKey___vue_template_functional__,
  CourseChartKey___vue_styles__,
  CourseChartKey___vue_scopeId__,
  CourseChartKey___vue_module_identifier__
)

/* harmony default export */ var components_CourseChart_CourseChartKey = (CourseChartKey_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CourseChart/CourseCard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CourseCard = ({
  name: 'CourseCard',
  props: ['course'],
  data: function data() {
    return {
      bgc: {
        backgroundColor: this.course.courseColor
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e50fa1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseChart/CourseCard.vue
var CourseCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-card",class:'course-card--' + _vm.course.courseColor},[_c('div',{staticClass:"course-card__box"},[_c('span',{staticClass:"course-card__id"},[_vm._v("\n    "+_vm._s(_vm.course.courseID)+":\n  ")]),_vm._v(" "),_c('span',{staticClass:"course-card__credits"},[_vm._v(_vm._s(_vm.course.courseName))]),_vm._v(" "),(_vm.course.hasMin && _vm.course.courseCredits !== '')?_c('span',{staticClass:"course-card__credits"},[_vm._v("("+_vm._s(_vm.course.min)+"-"+_vm._s(_vm.course.courseCredits)+")")]):_vm._e(),_vm._v(" "),(!_vm.course.hasMin && _vm.course.courseCredits !== '')?_c('span',{staticClass:"course-card__credits"},[_vm._v("("+_vm._s(_vm.course.courseCredits)+")")]):_vm._e()])])}
var CourseCard_staticRenderFns = []
var CourseCard_esExports = { render: CourseCard_render, staticRenderFns: CourseCard_staticRenderFns }
/* harmony default export */ var CourseChart_CourseCard = (CourseCard_esExports);
// CONCATENATED MODULE: ./src/components/CourseChart/CourseCard.vue
function CourseCard_injectStyle (ssrContext) {
  __webpack_require__("Ti9A")
}
var CourseCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CourseCard___vue_template_functional__ = false
/* styles */
var CourseCard___vue_styles__ = CourseCard_injectStyle
/* scopeId */
var CourseCard___vue_scopeId__ = "data-v-0e50fa1f"
/* moduleIdentifier (server only) */
var CourseCard___vue_module_identifier__ = null
var CourseCard_Component = CourseCard_normalizeComponent(
  CourseCard,
  CourseChart_CourseCard,
  CourseCard___vue_template_functional__,
  CourseCard___vue_styles__,
  CourseCard___vue_scopeId__,
  CourseCard___vue_module_identifier__
)

/* harmony default export */ var components_CourseChart_CourseCard = (CourseCard_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CourseChart/CourseSemester.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CourseSemester = ({
  name: 'CourseSemester',
  components: {
    'usc-course-card': components_CourseChart_CourseCard
  },
  props: ['semester', 'name'],
  data: function data() {
    return {};
  },

  computed: {
    minDetected: function minDetected() {
      var i = 0;
      var min = false;
      for (i = 0; i < this.semester.length; i++) {
        if (this.semester[i].hasMin === true) {
          min = true;
          break;
        }
      }
      return min;
    },
    minCredits: function minCredits() {
      var i = 0;
      var sum = 0;
      for (i = 0; i < this.semester.length; i++) {
        sum += this.semester[i].min;
      }
      return sum;
    },
    totalCredits: function totalCredits() {
      return this.semester.reduce(function (sum, credits) {
        sum += credits.courseCredits;
        return sum;
      }, 0);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7bc057","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseChart/CourseSemester.vue
var CourseSemester_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.minDetected)?_c('div',{staticClass:"semester-totals"},[_vm._v("\n    "+_vm._s(_vm.name)+" ")]):_c('div',{staticClass:"semester-totals"},[_vm._v("\n    "+_vm._s(_vm.name)+" ")]),_vm._v(" "),_vm._l((_vm.semester),function(course,index){return _c('usc-course-card',{key:index,attrs:{"course":course}})}),_vm._v(" "),(_vm.minDetected)?_c('div',{staticClass:"semester-totals"},[_vm._v("\n      ")]):_c('div',{staticClass:"semester-totals"},[_vm._v("\n      ")])],2)}
var CourseSemester_staticRenderFns = []
var CourseSemester_esExports = { render: CourseSemester_render, staticRenderFns: CourseSemester_staticRenderFns }
/* harmony default export */ var CourseChart_CourseSemester = (CourseSemester_esExports);
// CONCATENATED MODULE: ./src/components/CourseChart/CourseSemester.vue
function CourseSemester_injectStyle (ssrContext) {
  __webpack_require__("XBFn")
}
var CourseSemester_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CourseSemester___vue_template_functional__ = false
/* styles */
var CourseSemester___vue_styles__ = CourseSemester_injectStyle
/* scopeId */
var CourseSemester___vue_scopeId__ = "data-v-3c7bc057"
/* moduleIdentifier (server only) */
var CourseSemester___vue_module_identifier__ = null
var CourseSemester_Component = CourseSemester_normalizeComponent(
  CourseSemester,
  CourseChart_CourseSemester,
  CourseSemester___vue_template_functional__,
  CourseSemester___vue_styles__,
  CourseSemester___vue_scopeId__,
  CourseSemester___vue_module_identifier__
)

/* harmony default export */ var components_CourseChart_CourseSemester = (CourseSemester_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CourseChart/CourseChart.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CourseChart = ({
  name: 'CourseChart',
  components: {
    'usc-course-key': components_CourseChart_CourseChartKey,
    'usc-course-semester': components_CourseChart_CourseSemester
  },
  props: ['dataSet'],
  data: function data() {
    return {};
  },

  computed: {
    totalUnits: function totalUnits() {
      var totalUnits = {
        min: 0,
        max: 0
      };
      var i = 0;
      if (this.dataSet.years.freshman !== undefined) {
        var freshman = this.dataSet.years.freshman;

        if (freshman.semesters.Fall !== undefined) {
          for (i = 0; i < freshman.semesters.Fall.length; i++) {
            var fall = freshman.semesters.Fall[i];
            if (fall.hasMin) {
              totalUnits.min += fall.min;
            } else {
              totalUnits.min += fall.courseCredits;
            }
            totalUnits.max += fall.courseCredits;
          }
        }

        if (freshman.semesters.Spring !== undefined) {
          for (i = 0; i < freshman.semesters.Spring.length; i++) {
            var winter = freshman.semesters.Spring[i];
            if (winter.hasMin) {
              totalUnits.min += winter.min;
            } else {
              totalUnits.min += winter.courseCredits;
            }
            totalUnits.max += winter.courseCredits;
          }
        }
      }

      if (this.dataSet.years.sophmore !== undefined) {
        var sophmore = this.dataSet.years.sophmore;

        if (sophmore.semesters.Fall !== undefined) {
          for (i = 0; i < sophmore.semesters.Fall.length; i++) {
            var _fall = sophmore.semesters.Fall[i];
            if (_fall.hasMin) {
              totalUnits.min += _fall.min;
            } else {
              totalUnits.min += _fall.courseCredits;
            }
            totalUnits.max += _fall.courseCredits;
          }
        }

        if (sophmore.semesters.Spring !== undefined) {
          for (i = 0; i < sophmore.semesters.Spring.length; i++) {
            var _winter = sophmore.semesters.Spring[i];
            if (_winter.hasMin) {
              totalUnits.min += _winter.min;
            } else {
              totalUnits.min += _winter.courseCredits;
            }
            totalUnits.max += _winter.courseCredits;
          }
        }
      }

      if (this.dataSet.years.junior !== undefined) {
        var junior = this.dataSet.years.junior;

        if (junior.semesters.Fall !== undefined) {
          for (i = 0; i < junior.semesters.Fall.length; i++) {
            var _fall2 = junior.semesters.Fall[i];
            if (_fall2.hasMin) {
              totalUnits.min += _fall2.min;
            } else {
              totalUnits.min += _fall2.courseCredits;
            }
            totalUnits.max += _fall2.courseCredits;
          }
        }

        if (junior.semesters.Spring !== undefined) {
          for (i = 0; i < junior.semesters.Spring.length; i++) {
            var _winter2 = junior.semesters.Spring[i];
            if (_winter2.hasMin) {
              totalUnits.min += _winter2.min;
            } else {
              totalUnits.min += _winter2.courseCredits;
            }
            totalUnits.max += _winter2.courseCredits;
          }
        }
      }

      if (this.dataSet.years.senior !== undefined) {
        var senior = this.dataSet.years.senior;

        if (senior.semesters.Fall !== undefined) {
          for (i = 0; i < senior.semesters.Fall.length; i++) {
            var _fall3 = senior.semesters.Fall[i];
            if (_fall3.hasMin) {
              totalUnits.min += _fall3.min;
            } else {
              totalUnits.min += _fall3.courseCredits;
            }
            totalUnits.max += _fall3.courseCredits;
          }
        }

        if (senior.semesters.Spring !== undefined) {
          for (i = 0; i < senior.semesters.Spring.length; i++) {
            var _winter3 = senior.semesters.Spring[i];
            if (_winter3.hasMin) {
              totalUnits.min += _winter3.min;
            } else {
              totalUnits.min += _winter3.courseCredits;
            }
            totalUnits.max += _winter3.courseCredits;
          }
        }
      }
      return totalUnits;
    },
    unitsHasRange: function unitsHasRange() {
      if (this.totalUnits.min === this.totalUnits.max) {
        return false;
      } else {
        return true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54614761","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseChart/CourseChart.vue
var CourseChart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-course gutter-md mb"},[_c('div',{staticClass:"usc-course__blocks"},[_vm._t("image")],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('details',[_c('summary',[_vm._v("Click here to view the accessible version of the curriculum")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.dataSet.title))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.dataSet.subtitle))]),_vm._v(" "),_c('div',{staticClass:"usc-course__key"},_vm._l((_vm.dataSet.key),function(key,index){return _c('usc-course-key',{key:key.id,attrs:{"color":key.courseColor,"label":key.courseLabel}})})),_vm._v(" "),_vm._l((_vm.dataSet.years),function(year,index){return _c('div',{key:year.id,staticClass:"usc-course__year"},[_c('h4',{staticClass:"usc-course__year-title"},[_vm._v(_vm._s(year.yearTitle))]),_vm._v(" "),_c('div',{staticClass:"usc-course__semesters-container"},_vm._l((year.semesters),function(semester,index){return _c('usc-course-semester',{key:semester.id,staticClass:"usc-course__semester",attrs:{"semester":semester,"name":index}})}))])})],2),_vm._v(" "),_c('hr')])}
var CourseChart_staticRenderFns = []
var CourseChart_esExports = { render: CourseChart_render, staticRenderFns: CourseChart_staticRenderFns }
/* harmony default export */ var CourseChart_CourseChart = (CourseChart_esExports);
// CONCATENATED MODULE: ./src/components/CourseChart/CourseChart.vue
function CourseChart_injectStyle (ssrContext) {
  __webpack_require__("J9A8")
}
var CourseChart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CourseChart___vue_template_functional__ = false
/* styles */
var CourseChart___vue_styles__ = CourseChart_injectStyle
/* scopeId */
var CourseChart___vue_scopeId__ = "data-v-54614761"
/* moduleIdentifier (server only) */
var CourseChart___vue_module_identifier__ = null
var CourseChart_Component = CourseChart_normalizeComponent(
  CourseChart,
  CourseChart_CourseChart,
  CourseChart___vue_template_functional__,
  CourseChart___vue_styles__,
  CourseChart___vue_scopeId__,
  CourseChart___vue_module_identifier__
)

/* harmony default export */ var components_CourseChart_CourseChart = (CourseChart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/UndergradBA.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var UndergradBA = ({
  name: 'UndergradBA',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-calloutLink': src_components_CalloutLink,
    'usc-course-chart': components_CourseChart_CourseChart,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Undergraduate Business Administration',
        loResSrc: '../../../static/HeroImages/Academics3.jpg',
        hiResSrc: '../../../static/HeroImages/Academics3.jpg'
      },
      intro: ['Marshall’s Business Administration degree consists of three sets of courses: general education requirements taken by all undergraduates to fulfill the university’s liberal arts requirements; gateway courses toward the business curriculum; and free electives. The business core curriculum provides a broad understanding of business fundamentals and lays the foundation for upper-division Marshall electives.'],
      table: {
        title: 'Core Classes',
        data: [{
          left: 'Introduction to Financial Accounting',
          right: 'BUAD 280'
        }, {
          left: 'Introduction to Managerial Accounting',
          right: 'BUAD 281'
        }, {
          left: 'Communication Strategy in Business',
          right: 'BUAD 302'
        }, {
          left: 'Organizational Behavior and Leadership',
          right: 'BUAD 304'
        }, {
          left: 'Business Finance or Advanced Business Finance',
          right: 'BUAD 306 or BUAD 308'
        }, {
          left: 'Marketing Fundamentals',
          right: 'BUAD 307'
        }, {
          left: 'Applied Business Statistics or Statistics and Data Science for Business',
          right: 'BUAD 310 or BUAD 312'
        }, {
          left: 'Operations Management or Advanced Operations Management and Analytics',
          right: 'BUAD 311 or BUAD 313'
        }, {
          left: 'Economic Analysis for Business Decisions or Microeconomics for Business',
          right: ''
        }, {
          left: 'Macroeconomic Analysis for Business Decisions or Macroeconomics for Business',
          right: ''
        }, {
          left: 'Strategic Management',
          right: 'BUAD 497'
        }, {
          left: 'Fundamental Principles of Calculus or Calculus I',
          right: ''
        }],
        disclaimer: ''
      },
      calloutLink: {
        title: 'Consult the current USC Catalogue online for detailed course descriptions',
        url: 'http://catalogue.usc.edu/',
        urlText: 'The USC catalogue for fine prints'
      },
      courseData: {
        title: 'USC Marshall Undergraduate Business Administration Program',
        subtitle: 'Four-Year Sample Course Sequence',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'marshall-elective',
          courseLabel: 'Marshall Elective'
        }, {
          courseColor: 'usc-elective',
          courseLabel: 'USC Elective/Minor'
        }],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [{
                courseID: 'Math 118',
                courseName: 'Fundamental Principles of Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 304',
                courseName: 'Organizational Behavior and Leadership',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 310 or 312',
                courseName: 'Applied Business Stats or Stats & Data Science for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '4',
                courseCredits: 4
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 104',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [{
                courseID: 'BUAD 280',
                courseName: 'Introduction to Financial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'BUAD 302',
                courseName: 'Communication Strategy in Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 252',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'BUAD 281',
                courseName: 'Introduction to Managerial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ECON 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [{
                courseID: 'BUAD 306 or 308',
                courseName: 'Business Finance or Advanced Business Finance',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 311 or 313',
                courseName: 'Operations Mgmt or Advanced operations Mgmt & Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [{
                courseID: 'BUAD 425',
                courseName: 'Introduction to Business Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 497',
                courseName: 'Strategic Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Elective/Minor',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          }
        }
      },
      video: {
        caption: 'How marketing and advertising students helped the L.A. Kings pull off their Stanley Cup win.',
        src: 'https://player.vimeo.com/video/249449491?title=0&byline=0&portrait=0',
        frameTitle: 'Video: How marketing and advertising students helped the L.A. Kings pull off their Stanley Cup win.'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Undergraduate Business Administration Program');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5381da10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/UndergradBA.vue
var UndergradBA_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_undergrad_ba"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_c('usc-table',{attrs:{"title":this.table.title,"data":this.table.data,"disclaimer":this.table.disclaimer}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("298c"),"alt":"USC Marshall Undergraduate Business Administration Program Four-Year Sample Course Sequence"},slot:"image"})])],1)}
var UndergradBA_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("The "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://catalogue.usc.edu/","target":"_blank"}},[_vm._v("USC Catalogue")]),_vm._v(" provides a complete list of the university’s courses, as well as other information on curriculum, admissions, policies and academics.")])])}]
var UndergradBA_esExports = { render: UndergradBA_render, staticRenderFns: UndergradBA_staticRenderFns }
/* harmony default export */ var academics_UndergradBA = (UndergradBA_esExports);
// CONCATENATED MODULE: ./src/pages/academics/UndergradBA.vue
function UndergradBA_injectStyle (ssrContext) {
  __webpack_require__("jOvh")
}
var UndergradBA_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UndergradBA___vue_template_functional__ = false
/* styles */
var UndergradBA___vue_styles__ = UndergradBA_injectStyle
/* scopeId */
var UndergradBA___vue_scopeId__ = "data-v-5381da10"
/* moduleIdentifier (server only) */
var UndergradBA___vue_module_identifier__ = null
var UndergradBA_Component = UndergradBA_normalizeComponent(
  UndergradBA,
  academics_UndergradBA,
  UndergradBA___vue_template_functional__,
  UndergradBA___vue_styles__,
  UndergradBA___vue_scopeId__,
  UndergradBA___vue_module_identifier__
)

/* harmony default export */ var pages_academics_UndergradBA = (UndergradBA_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/UndergradAccounting.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var UndergradAccounting = ({
  name: 'UndergradAccounting',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-cta': src_components_Cta,
    'usc-course-chart': components_CourseChart_CourseChart,
    'usc-calloutLink': src_components_CalloutLink
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Undergraduate Accounting',
        loResSrc: '../../../static/HeroImages/Marshall99.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall99.jpg'
      },
      calloutLink: {
        title: 'Your Future, Your Way',
        url: 'https://curriculum.marshall.usc.edu',
        urlText: 'Your Future, Your Way'
      },
      table: {
        title: 'Required Courses:',
        data: [{
          left: 'External Financial Reporting Issues',
          right: ''
        }, {
          left: 'Introduction to Accounting Systems',
          right: ''
        }, {
          left: 'Accounting Ethics',
          right: ''
        }, {
          left: 'Tax Analysis with Data Analytics',
          right: ''
        }, {
          left: 'Auditing with Data Analytics',
          right: ''
        }],
        disclaimer: ''
      },
      courseData: {
        title: 'Leventhal School of Accounting Undergraduate Program',
        subtitle: 'Four-Year Sample Course Sequence',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'usc-elective',
          courseLabel: 'USC Elective/Minor'
        }, {
          courseColor: 'marshall-elective',
          courseLabel: 'Accounting'
        }],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [{
                courseID: 'Math 118',
                courseName: 'Fundamental Principles of the Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 304',
                courseName: 'Organizational Behavior and Leadership',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 280',
                courseName: 'Introduction to Financial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 104',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 0,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [{
                courseID: 'BUAD 281',
                courseName: 'Introduction to Managerial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'BUAD 306 or 308',
                courseName: 'Business Finance or Advanced Business Finance',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 302',
                courseName: 'Communication Strategy in Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: true,
                min: 1,
                courseCredits: 3
              }],
              Spring: [{
                courseID: 'BUAD 310 or 312',
                courseName: 'Applied Business Stats or Stats & Data Science for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ACCT 370',
                courseName: 'External Financial Reporting Issue',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ACCT 371',
                courseName: 'Introduction to Accounting Systems',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [{
                courseID: 'ECON 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ACCT 456',
                courseName: 'Audit with Data Analytics',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ACCT 451',
                courseName: 'Tax with Data Analytics',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 311 or 313',
                courseName: 'Operations Mgmt or Advanced Operations Mgmt & Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ACCT Upper Division Elective',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Ethnics Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [{
                courseID: 'ACCT Upper Division Elective',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing',
                courseColor: 'usc-requirement',
                hasMin: true,
                min: 3,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 497',
                courseName: 'Strategic Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'ACCT 430',
                courseName: 'Accounting Ethnics',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Undergraduate Accounting Program');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53998d6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/UndergradAccounting.vue
var UndergradAccounting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_undergrad_accounting"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Overview")]),_vm._v(" "),_c('p',[_vm._v("The USC Leventhal School of Accounting, an integral part of the Marshall School of Business, offers undergraduate and graduate degrees in accounting.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-table',{attrs:{"title":this.table.title,"data":this.table.data,"disclaimer":this.table.disclaimer}}),_vm._v(" "),_c('usc-calloutLink',{attrs:{"url":this.calloutLink.url,"urltext":this.calloutLink.urlText}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("JhfJ"),"alt":"Course chart for Accounting"},slot:"image"})])],1)}
var UndergradAccounting_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg"},[_c('p',[_c('i',{},[_vm._v("The accounting profession is dynamic, challenging and evolving. In today’s global economy, accountants require a wider knowledge base than ever before. Now that accounting firms have evolved into broad-based professional services firms, accountants need to understand systems operations, be technologically savvy, and possess good business sense and excellent communication skills.")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("Nxd/"),"alt":"USC Leventhal - Ranked #4 by the U.S. News & World Report"}}),_vm._v(" "),_c('p',[_vm._v("The Leventhal School of Accounting emphasizes the importance of ethical behavior and principles throughout the curriculum, ensuring accounting majors develop these essential competencies for the profession.")]),_vm._v(" "),_c('p',[_vm._v("Pursuing an accounting degree at USC sets you on a path to be part of a close-knit community of students, faculty, staff and alumni. Leventhal’s strong ties with the global business community connect students to a broad array of job opportunities and internships that provide invaluable firsthand business experiences throughout the nation as well as in Europe, Asia and Latin America. In increasingly high demand, Leventhal graduates are equipped for successful careers ranging from public and forensic accounting to financial services and investment banking.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Progressive Degree Programs")]),_vm._v(" "),_c('p',[_vm._v("Select USC students have the option of simplified early admission to our Master of Accounting (MAcc) or Master of Business Taxation (MBT) programs. The curriculum is identical to our full-time master’s programs and provides an opportunity for outstanding USC undergrads to apply to our graduate programs without going through the regular application process. The Progressive Degree also provides an opportunity for a select group of students to earn their MAcc or MBT degree in only nine to 12 months.")])])}]
var UndergradAccounting_esExports = { render: UndergradAccounting_render, staticRenderFns: UndergradAccounting_staticRenderFns }
/* harmony default export */ var academics_UndergradAccounting = (UndergradAccounting_esExports);
// CONCATENATED MODULE: ./src/pages/academics/UndergradAccounting.vue
function UndergradAccounting_injectStyle (ssrContext) {
  __webpack_require__("Sf/X")
}
var UndergradAccounting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UndergradAccounting___vue_template_functional__ = false
/* styles */
var UndergradAccounting___vue_styles__ = UndergradAccounting_injectStyle
/* scopeId */
var UndergradAccounting___vue_scopeId__ = "data-v-53998d6c"
/* moduleIdentifier (server only) */
var UndergradAccounting___vue_module_identifier__ = null
var UndergradAccounting_Component = UndergradAccounting_normalizeComponent(
  UndergradAccounting,
  academics_UndergradAccounting,
  UndergradAccounting___vue_template_functional__,
  UndergradAccounting___vue_styles__,
  UndergradAccounting___vue_scopeId__,
  UndergradAccounting___vue_module_identifier__
)

/* harmony default export */ var pages_academics_UndergradAccounting = (UndergradAccounting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/Wbb.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Wbb = ({
  name: 'UndergradBA',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-course-chart': components_CourseChart_CourseChart,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'World Bachelor in Business',
        loResSrc: '../../../static/HeroImages/Academics4.jpg',
        hiResSrc: '../../../static/HeroImages/Academics4.jpg'
      },
      intro: ['Learn from business leaders in at least three countries and earn three degrees on three continents from three prestigious universities through our one-of-a-kind World Bachelor in Business (WBB). WBB is the first-ever four-year, three-continent, three-degree undergraduate business program in the world. Students in the program study at Marshall, Hong Kong University of Science and Technology and Milan’s Universita Commerciale Luigi Bocconi.'],
      courseData: {
        title: 'World Bachelor in Business Program',
        subtitle: '',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'marshall-elective',
          courseLabel: 'Marshall Elective'
        }],
        years: {
          freshman: {
            yearTitle: 'FIRST YEAR: USC',
            semesters: {
              Fall: [{
                courseID: 'MATH 118',
                courseName: 'Fundamental Principles of Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE-D',
                courseName: 'Life Sciences',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 101',
                courseName: 'Freshman Leadership Seminar',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing for Business',
                courseColor: 'usc-requirement',
                hasMin: true,
                min: 3,
                courseCredits: 4
              }, {
                courseID: 'GE-E',
                courseName: 'Physical Science w/Lab',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Global Social Impact',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SECOND YEAR: HKUST',
            semesters: {
              Fall: [{
                courseID: 'ECON 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'MGMT 2030',
                courseName: 'Business Communication',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'CC3/GE-A',
                courseName: 'The Arts',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'MGMT 2110',
                courseName: 'Organizational Behavior',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ACCT 2010',
                courseName: 'Principles of Accounting I',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }],
              Spring: [{
                courseID: 'WBBA 2010 & 2020',
                courseName: 'Understanding Business in Asia',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ISOM 2010 GE-F',
                courseName: 'Intro to Information Systems',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ISOM 2500 GE-F',
                courseName: 'Business Statistics',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ISOM 2700',
                courseName: 'Chinese Communication',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'CC2/GE-B',
                courseName: 'Humanistic Inquiry',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }]
            }
          },
          junior: {
            yearTitle: 'THIRD YEAR: BOCCONI',
            semesters: {
              Fall: [{
                courseID: '30367',
                courseName: 'Finance I (Financial Markets)',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30047',
                courseName: 'Introduction to the Legal System',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30364',
                courseName: 'Accounting (Managerial Acct)',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30372 GE-C/H',
                courseName: 'Global History',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'Financial Mathematics',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }],
              Spring: [{
                courseID: '30366',
                courseName: 'Finance II (Corporate Finance)',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30048',
                courseName: 'Introduction to the Legal System II',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30056 GE-C/G',
                courseName: 'European Economic Policy',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30152',
                courseName: 'Public Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'European Language',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: '30361',
                courseName: 'European Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 1,
                courseCredits: 1
              }]
            }
          },
          senior: {
            yearTitle: 'FINAL YEAR',
            semesters: {
              Fall: [{
                courseID: 'Operations Management',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Business Strategy',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Social and Ethical Issues',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: '',
                courseCredits: ''
              }],
              Spring: [{
                courseID: 'Final Report, Analysis, Research',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Business Law',
                courseName: '',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: '',
                courseCredits: ''
              }, {
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: '',
                courseCredits: ''
              }]
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'World Bachelor in Business');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a22090","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/Wbb.vue
var Wbb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_wbb"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('img',{staticClass:"wbb-logos mb",attrs:{"src":"static/WBB.jpg","alt":"World Bachelor in Business partnership logos"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("eHl1"),"alt":"Course chart for World Bachelor in Business"},slot:"image"})])],1)}
var Wbb_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_vm._v("Much more than a study-abroad program, each university was chosen based on both academic excellence and geography. Studying and working in Los Angeles, Hong Kong and Milan offers students a unique international business growth experience. Los Angeles is a hub for global trade, Hong Kong’s multilateral trading system offers interesting insight into free trade and Milan is seen as the gateway city into the European market.")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("YMuF"),"alt":"Infographic: Top 3 Universities, Continents, Degrees, Languages. 5+ Countries visited","title":"Infographic: Top 3 Universities, Continents, Degrees, Languages. 5+ Countries visited"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("FIRST YEAR: USC Marshall, Los Angeles, California")]),_vm._v(" "),_c('p',[_vm._v("At Marshall, students will be immersed in business from day one. The first year includes foundational business courses like Microeconomics for Business, along with classes designed to build essential business skills like Writing and Critical Reasoning. In Leading Organizations, which focuses on leadership and management skills, students participate in hands-on projects at the Experiential Learning Center, one of the top business training facilities at any institution of higher education.")]),_vm._v(" "),_c('p',[_vm._v("Through business simulations, students put theory into practice and develop leadership, negotiation and communication skills. The WBB cohort travels to an additional international market outside of the three zones included in the degree for exposure to another commercial hub with a range of industries and companies represented. Here, students will receive their first collegiate foray into consulting as they work with an international NGO client, ultimately proposing solutions to a real-world business problem.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("SECOND YEAR: Hong Kong University of Science and Technology (HKUST), Hong Kong, China")]),_vm._v(" "),_c('p',[_vm._v("Leveraging HKUST’s strengths as a school of science and technology, students will gain professional and technical knowledge while developing a strong entrepreneurial spirit and innovative thinking — the necessary foundation and skills for an evolving world. Courses will offer unique insights into the way business works in China and Asia and provide an introduction to the Chinese languages. Other courses such as Mathematics for Economists, Business Statistics and Introduction to Information Systems emphasize mathematical and analytical skills. Students will take their first accounting class and develop critical-thinking skills studying science and technology and other subjects.")]),_vm._v(" "),_c('p',[_vm._v("In both the first and second years, students can select from a variety of humanities courses (literature, music, philosophy, art, anthropology, religion, history, etc.) designed to encourage an appreciation of Western and/or Chinese cultures and to develop analytical and communication skills.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("THIRD YEAR: Università Commerciale Luigi Bocconi, Milan, Italy")]),_vm._v(" "),_c('p',[_vm._v("The Bocconi curriculum focuses on finance, economics and law. Courses include Corporate Finance, Financial Markets and Institutions, and European Economic Policy. Students examine the fundamentals of Italian civil law within the broader framework of European legal culture in Introduction to the Legal System, and analyze economic developments in Western nations in Economic History. The course in public management will explore the complex relations between private businesses and the government bodies for whom they supply products, services and management know-how at the national and local levels.")]),_vm._v(" "),_c('p',[_vm._v("In additional classes, students learn about the specifics of doing business in the European Union and build introductory Italian language skills.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("FINAL YEAR: Choose What’s Next")]),_vm._v(" "),_c('p',[_vm._v("The fourth and final year reinforces an integrated view of business with courses in business communications, ethics and strategy. WBB students entering their fourth year have the choice of completing their final year in Los Angeles, Hong Kong or Milan, with a focus on the discipline they would like to pursue after graduation. Year four also allows students to emphasize specific interests and objectives, not only in the choice of which school to attend, but also through the selection of elective courses.")])])}]
var Wbb_esExports = { render: Wbb_render, staticRenderFns: Wbb_staticRenderFns }
/* harmony default export */ var academics_Wbb = (Wbb_esExports);
// CONCATENATED MODULE: ./src/pages/academics/Wbb.vue
function Wbb_injectStyle (ssrContext) {
  __webpack_require__("HQx/")
}
var Wbb_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Wbb___vue_template_functional__ = false
/* styles */
var Wbb___vue_styles__ = Wbb_injectStyle
/* scopeId */
var Wbb___vue_scopeId__ = "data-v-07a22090"
/* moduleIdentifier (server only) */
var Wbb___vue_module_identifier__ = null
var Wbb_Component = Wbb_normalizeComponent(
  Wbb,
  academics_Wbb,
  Wbb___vue_template_functional__,
  Wbb___vue_styles__,
  Wbb___vue_scopeId__,
  Wbb___vue_module_identifier__
)

/* harmony default export */ var pages_academics_Wbb = (Wbb_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/BusinessCinematicArts.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var BusinessCinematicArts = ({
  name: 'BusinessCincematicArts',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-cta': src_components_Cta,
    'usc-course-chart': components_CourseChart_CourseChart
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Business Cinematic Arts',
        loResSrc: '../../../static/HeroImages/Academics7.jpg',
        hiResSrc: '../../../static/HeroImages/Academics7.jpg'
      },
      intro: ['Leveraging our location in the world’s entertainment capital, the John H. Mitchell Business of Cinematic Arts (BCA) degree program pairs Marshall’s exceptional business curriculum with the world’s leading School of Cinematic Arts. This prestigious program is available to entering freshmen only, with space limited to 50 students per year.'],
      table1: {
        title: 'BCA internships include:',
        data: [{
          left: '20th Century Fox',
          right: 'ABC Comedy Development'
        }, {
          left: 'ABC/Jimmy Kimmel Live',
          right: 'Bravo'
        }, {
          left: 'Fox Sports Networks',
          right: 'Paramount Pictures'
        }, {
          left: 'United Talent Agency (UTA)',
          right: ''
        }]
      },
      table2: {
        title: 'Full-Time Employment:',
        data: [{
          left: 'Creative Arts Agency (CAA)',
          right: 'William Morris Endeavor (WME)'
        }, {
          left: 'United Talent Agency (UTA)',
          right: '20th Century Fox'
        }, {
          left: 'Warner Bros.',
          right: 'Sony Music Entertainment'
        }, {
          left: 'Google',
          right: 'Paramount Pictures'
        }],
        disclaimer: ''
      },
      courseData: {
        title: 'USC Marshall Undergraduate Business Program',
        subtitle: 'Business Administration Cinematic Arts Emphasis—BCA Four-Year Sample Course Sequence',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-elective',
          courseLabel: 'USC Elective/Minor'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'marshall-elective',
          courseLabel: 'Marshall Elective'
        }, {
          courseColor: 'cinematic-arts',
          courseLabel: 'Cinematic Arts'
        }],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [{
                courseID: 'Math 118',
                courseName: 'Fundamental Principles of the Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 304',
                courseName: 'Organizational Behavior and Leadership',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CTCS 190',
                courseName: 'Introduction to Cinema',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 310 or 312',
                courseName: 'Applied Business Statistics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-elective',
                hasMin: true,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 385',
                courseName: 'Colloquium: Motion Picture Production Techniques',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 104',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [{
                courseID: 'BUAD 280',
                courseName: 'Introduction to Financial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'BUAD 302',
                courseName: 'Communication Strategy in Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 306 or 308',
                courseName: 'Business Finance or Advanced Business Finance',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CTPR 410',
                courseName: 'The Entertainment Industry: From Idea to Audience',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'BUAD 281',
                courseName: 'Introduction to Managerial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ECON 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CNTV 441',
                courseName: 'Entertainment Practicum',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Optional Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: true,
                min: 2,
                courseCredits: 4
              }]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [{
                courseID: 'BUAD 311 or 313',
                courseName: 'Operations Management or Advanced Operations Management & Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 497',
                courseName: 'Strategi Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CNTV 463',
                courseName: 'Television: Integrating Creative and Business Objectives',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: true,
                min: 2,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 425',
                courseName: 'Introduction to Business Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Marshall Upper Division Elective / Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CTIN 428',
                courseName: 'ET Law and Dealmaking',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'CTIN 458',
                courseName: 'Business and Management of Games',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [{
                courseID: 'Marshall Upper Division Elective/Empahsis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing',
                courseColor: 'usc-requirement',
                hasMin: true,
                min: 3,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CNTV',
                courseName: 'Producing and Marketing Feature-Length Films',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: true,
                min: 2,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'Marshall Upper Division Elective/Emphasis',
                courseName: '',
                courseColor: 'marshall-elective',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CNTV 481',
                courseName: 'Hollywood Launchpad',
                courseColor: 'cinematic-arts',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Business Cinematic Arts');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a0f7bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/BusinessCinematicArts.vue
var BusinessCinematicArts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_interdisciplinary"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-table',{attrs:{"title":this.table1.title,"data":this.table1.data,"disclaimer":this.table1.disclaimer}}),_vm._v(" "),_c('usc-table',{attrs:{"title":this.table2.title,"data":this.table2.data,"disclaimer":this.table2.disclaimer}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("YrMk"),"alt":"Course chart for cinematic arts"},slot:"image"})])],1)}
var BusinessCinematicArts_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("Internship courses allow students to gain real-world experience with companies such as 20th Century Fox, April Webster Casting, Columbia and Paramount Pictures, Fox Sports Networks, ICM and UTA Talent Agencies, New Line Cinema and Sony Music Entertainment.")])]),_vm._v(" "),_c('p',[_vm._v("The BCA program provides you with specialized expertise that will distinguish you as a competitive leader in both the business and entertainment industries. BCA also offers extensive professional networking opportunities with distinguished guest speakers from the entertainment industry. Speakers discuss current trends and issues in the industry that give students insights into the future of cinema, television, the internet and other forms of media.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Core Courses")]),_vm._v(" "),_c('p',[_vm._v("In addition to Marshall core classes, BCA students take 24 units at the School of Cinematic Arts. Two lower-division courses cover the history of cinema and television, and additional courses include specialized business/entertainment topics such as entertainment marketing, agenting and film procedures and distribution.")]),_vm._v(" "),_c('p',[_vm._v("In addition to the Marshall core classes and elective courses, students complete the following:")]),_vm._v(" "),_c('h4',[_vm._v("CTCS 190: INTRODUCTION TO CINEMA (4 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("This comprehensive course analyzes the power and responsibility of American and international film and television.")]),_vm._v(" "),_c('h4',[_vm._v("CTCS 191: INTRODUCTION TO TELEVISION AND VIDEO (4 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("This class involves understanding film and television texts in relation to the world they represent, and studying not only the meaning of these texts but also the processes by which these meanings are constructed.")]),_vm._v(" "),_c('h4',[_vm._v("CTPR 410: THE MOVIE BUSINESS (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("This course offers a broad overview of the entertainment industry and an examination of the motion picture business from the screenwriter’s treatment through production, marketing and exhibition in theaters. Students learn about the roles played by writers, agents, studio executives and directors, as well as marketing and distribution channels.")]),_vm._v(" "),_c('h4',[_vm._v("CTPR 495: INTERNSHIP IN CINEMA-TELEVISION (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("Students secure an internship with a company of their choice. The company is given a USC internship contract and is required to meet specific standards that ensure an educational opportunity and beneficial work environment for the student. Class sessions focus on how to find and keep your first job and use it to your advantage, including tips on troubleshooting and how to be an assistant. Students share work-related situations and experiences.")]),_vm._v(" "),_c('h4',[_vm._v("CNTV 463 TELEVISION: INTEGRATING CREATIVE AND BUSINESS OBJECTIVES (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("An investigation of the creative and business sides of television and how they connect, including changes caused by fractionalization and digital technology. This course is open only to BCA students.")]),_vm._v(" "),_c('h4',[_vm._v("CNTV 467: THE FUTURE OF DIGITAL MEDIA & THE ENTERTAINMENT INDUSTRY (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("This course examines how digital media will affect the future of the television, motion picture, game, music and interactive industries.")]),_vm._v(" "),_c('h4',[_vm._v("CTIN 458: BUSINESS & MANAGEMENT OF GAMES (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("Providing a solid preparation for successful careers in interactive entertainment, this course covers a range of business and legal issues, including an overview of current business models for games and interactive media, methods of pitching and funding products, legal issues pertaining to copyright and intellectual property and production management techniques. Also included are business start-up basics for aspiring entrepreneurs.")]),_vm._v(" "),_c('h4',[_vm._v("CTPR 460: FILM BUSINESS PROCEDURES & DISTRIBUTION (2 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("Taught by a former head of marketing at Universal who is now an independent marketing consultant, this course covers such topics as theatrical marketing, corporate partnership, television marketing and advertising.")]),_vm._v(" "),_c('h4',[_vm._v("CTPR 385: MOTION PICTURE PRODUCTION TECHNIQUES (4 UNITS)")]),_vm._v(" "),_c('p',[_vm._v("This class covers motion picture production from scriptwriting to planning, shooting and editing. The class writes, directs and shoots a digital video.")])])}]
var BusinessCinematicArts_esExports = { render: BusinessCinematicArts_render, staticRenderFns: BusinessCinematicArts_staticRenderFns }
/* harmony default export */ var academics_BusinessCinematicArts = (BusinessCinematicArts_esExports);
// CONCATENATED MODULE: ./src/pages/academics/BusinessCinematicArts.vue
function BusinessCinematicArts_injectStyle (ssrContext) {
  __webpack_require__("KCF5")
}
var BusinessCinematicArts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BusinessCinematicArts___vue_template_functional__ = false
/* styles */
var BusinessCinematicArts___vue_styles__ = BusinessCinematicArts_injectStyle
/* scopeId */
var BusinessCinematicArts___vue_scopeId__ = "data-v-11a0f7bc"
/* moduleIdentifier (server only) */
var BusinessCinematicArts___vue_module_identifier__ = null
var BusinessCinematicArts_Component = BusinessCinematicArts_normalizeComponent(
  BusinessCinematicArts,
  academics_BusinessCinematicArts,
  BusinessCinematicArts___vue_template_functional__,
  BusinessCinematicArts___vue_styles__,
  BusinessCinematicArts___vue_scopeId__,
  BusinessCinematicArts___vue_module_identifier__
)

/* harmony default export */ var pages_academics_BusinessCinematicArts = (BusinessCinematicArts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/RealEstate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var RealEstate = ({
  name: 'UndergradAccounting',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-cta': src_components_Cta,
    'usc-course-chart': components_CourseChart_CourseChart
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Real Estate Finance + Development (REFD)',
        loResSrc: '../../../static/HeroImages/Marshall137-High.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall137-High.jpg'
      },
      table: {
        title: 'Core Courses',
        data: [{
          left: 'Writing and Critical Reasoning',
          right: 'WRIT 150'
        }, {
          left: 'Advanced Writing',
          right: 'WRIT 340'
        }, {
          left: 'Introduction to Programming',
          right: 'CSCI 103L'
        }, {
          left: 'Data Structures and Object-Oriented Design',
          right: 'CSCI 104L'
        }, {
          left: 'Introduction to Computing',
          right: 'CSCI 109'
        }, {
          left: 'Discrete Methods in Computer Science',
          right: 'CSCI 170'
        }, {
          left: 'Principles of Software Development',
          right: 'CSCI 201L'
        }, {
          left: 'Introduction to Algorithms and Theory of Computing',
          right: 'CSCI 270'
        }, {
          left: 'Design and Construction of Large Software Systems',
          right: 'CSCI 477ab'
        }, {
          left: 'Introduction to Digital Logic',
          right: 'EE 101'
        }, {
          left: 'Introduction to Digital Circuits',
          right: 'EE 201L'
        }, {
          left: 'Freshmen Academy Seminar',
          right: 'ENGR 102'
        }, {
          left: 'Calculus I',
          right: 'MATH 125'
        }, {
          left: 'Calculus II',
          right: 'MATH 126'
        }, {
          left: 'Linear Algebra and Linear Differential Equations',
          right: 'MATH 225'
        }, {
          left: 'Applied Linear Algebra for Engineering',
          right: 'EE 241'
        }, {
          left: 'Fundamentals of Physics II: Electricity and Magnetism',
          right: 'PHYS 151L'
        }, {
          left: 'Accounting for Non-Business Majors',
          right: 'ACCT 410x'
        }, {
          left: 'Communication Strategy in Business',
          right: 'BUAD 302'
        }, {
          left: 'Organizational Behavior',
          right: 'BUAD 304'
        }, {
          left: 'Business Finance',
          right: 'BUAD 306'
        }, {
          left: 'Marketing Fundamentals',
          right: 'BUAD 307'
        }, {
          left: 'Applied Business Statistics or BUAD 364',
          right: 'BUAD 310'
        }, {
          left: 'Operations Management',
          right: 'BUAD 311'
        }, {
          left: 'Strategic Management',
          right: 'BUAD 497'
        }, {
          left: 'Microeconomics for Business',
          right: 'ECON 351x'
        }, {
          left: 'Macroeconomics for Business',
          right: 'ECON 352x'
        }, {
          left: 'Introduction to Probability and Statistics for Electrical Engineering',
          right: 'EE 364'
        }],
        disclaimer: ''
      },
      courseData: {
        title: 'Real Estate Finance and Development Program',
        subtitle: 'FOUR-YEAR SAMPLE COURSE SEQUENCE',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'realestate',
          courseLabel: 'Real Estate Finance & Dev'
        }],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [{
                courseID: 'MATH 118',
                courseName: 'Fundatmental Principles of Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 304',
                courseName: 'Organizational Behavior and Leadership',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 200',
                courseName: 'Introduction to Real Estate',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 310 or 312',
                courseName: 'Applied Business Stats or Stats & Data Science for BUsiness',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'PPD 245',
                courseName: 'The Urban Context',
                courseColor: 'realestate',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 104',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [{
                courseID: 'BUAD 280',
                courseName: 'Introduction to Financial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'BUAD 302',
                courseName: 'Communication Strategy in Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Buad 306 or 308',
                courseName: 'Business Finace or Advanced Business Finance',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 362',
                courseName: 'Real Estate Development Fundamentals',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 201',
                courseName: 'Real Estate Career Seminar',
                courseColor: 'realestate',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'BUAD 281',
                courseName: 'Introduction to Managerial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'ECON 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'FBE 391',
                courseName: 'Real Estate Finance and Investement',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'FBE 495',
                courseName: 'Practicum in Business Issue',
                courseColor: 'realestate',
                hasMin: false,
                min: 1,
                courseCredits: 1
              }]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [{
                courseID: 'BUAD 311 or 313',
                courseName: 'Operations Management or Advanced Operations Management & Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 497',
                courseName: 'Strategic Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 435',
                courseName: 'Analyzing Real Estate Markets',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 417',
                courseName: 'History of Planning & Development',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 425',
                courseName: 'Introduction to Business Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'RED 437',
                courseName: 'Advanced Finance and Investment for Real Estate Development',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'FBE 466 or 489',
                courseName: 'Management of Real Estate Dev or Real Estate Capital Market',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'RED 301',
                courseName: 'Real Estate Internship Seminar',
                courseColor: 'realestate',
                hasMin: false,
                min: 1,
                courseCredits: 1
              }]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [{
                courseID: 'FBE 427',
                courseName: 'Real Estate law',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'RED 425',
                courseName: 'Designing Livable Communities',
                courseColor: 'realestate',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing',
                courseColor: 'usc-requirement',
                hasMin: true,
                min: 3,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'FBE 467 or RED 469',
                courseName: 'Real Estate Investment Trust (REIT) or Mixed Use Dev Process',
                courseColor: 'realestate',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Combined Computer Science/Business Administration');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97eee68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/RealEstate.vue
var RealEstate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_interdisciplinary"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',[_vm._v("The brand-new joint bachelor of science in Real Estate Finance and Development (REFD) combines Marshall’s\n      expertise in financial valuation and capital markets with the USC Price School of Public Policy’s strengths in\n      development and urban land use. ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("goj5"),"alt":"Course chart for Real Estate Finance and Development Program"},slot:"image"})])],1)}
var RealEstate_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("You will master skills and knowledge through numerous experiential-learning courses that emphasize\n        real-world opportunities in securities trading, real estate development and valuation. You’ll also benefit\n        from both schools’ longstanding ties with local, national and international real estate development and\n        investment firms and opportunities for summer internships.")])]),_vm._v(" "),_c('p',[_vm._v("All students will gain access to career services in both schools and be eligible for Marshall’s signature\n      international experiences, including our Learning about International Commerce (open to all first-year students)\n      and Global Leadership Program (invitation only). With intimate class sizes, you’ll engage in integrated\n      training, gain real-world experience and connect with industry leaders.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_c('strong',[_vm._v("Core Courses")])]),_vm._v(" "),_c('h3',[_vm._v("Marshall courses (48 units) will build skills in:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Accounting")]),_vm._v(" "),_c('li',[_vm._v("Economics")]),_vm._v(" "),_c('li',[_vm._v("Marketing")]),_vm._v(" "),_c('li',[_vm._v("Analytics")]),_vm._v(" "),_c('li',[_vm._v("Leadership and organizational behavior")]),_vm._v(" "),_c('li',[_vm._v("Strategy")]),_vm._v(" "),_c('li',[_vm._v("Operations management")]),_vm._v(" "),_c('li',[_vm._v("Communications")]),_vm._v(" "),_c('li',[_vm._v("Real estate finance and investment")])]),_vm._v(" "),_c('h3',[_vm._v("Price courses (42 units) will develop firm foundations in:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Development")]),_vm._v(" "),_c('li',[_vm._v("Urban planning")]),_vm._v(" "),_c('li',[_vm._v("Community design")]),_vm._v(" "),_c('li',[_vm._v("Real estate law and policy")]),_vm._v(" "),_c('li',[_vm._v("Real estate market analysis")])]),_vm._v(" "),_c('h2',[_vm._v("The program requires completion of at least one of the following experiential learning courses:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Real estate investment trust (REIT), including hands-on management of an actual REIT")]),_vm._v(" "),_c('li',[_vm._v("Mixed-use development, in which you will apply and grow your knowledge in design, finance, real estate policy and management through a field project")])])])}]
var RealEstate_esExports = { render: RealEstate_render, staticRenderFns: RealEstate_staticRenderFns }
/* harmony default export */ var academics_RealEstate = (RealEstate_esExports);
// CONCATENATED MODULE: ./src/pages/academics/RealEstate.vue
function RealEstate_injectStyle (ssrContext) {
  __webpack_require__("YrLr")
}
var RealEstate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RealEstate___vue_template_functional__ = false
/* styles */
var RealEstate___vue_styles__ = RealEstate_injectStyle
/* scopeId */
var RealEstate___vue_scopeId__ = "data-v-d97eee68"
/* moduleIdentifier (server only) */
var RealEstate___vue_module_identifier__ = null
var RealEstate_Component = RealEstate_normalizeComponent(
  RealEstate,
  academics_RealEstate,
  RealEstate___vue_template_functional__,
  RealEstate___vue_styles__,
  RealEstate___vue_scopeId__,
  RealEstate___vue_module_identifier__
)

/* harmony default export */ var pages_academics_RealEstate = (RealEstate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/AiForBusiness.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var AiForBusiness = ({
  name: 'AIB',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-table': src_components_Table,
    'usc-cta': src_components_Cta,
    'usc-course-chart': components_CourseChart_CourseChart
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Artificial Intelligence for Business',
        loResSrc: '../../../static/HeroImages/Marshall111.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall111.jpg'
      },
      intro: ['Offered in partnership with the top-ranked USC Viterbi School of Engineering, our newest joint degree program, the Bachelor of Science in Artificial Intelligence for Business, prepares you to bridge business with computing to open up a range of world-changing prospects. You’ll engage in this dynamic field with hands-on, real project learning and interact with some of the top minds from Silicon Beach.'],
      table1: {
        title: 'BCA internships include:',
        data: [{
          left: '20th Century Fox',
          right: 'ABC Comedy Development'
        }, {
          left: 'ABC/Jimmy Kimmel Live',
          right: 'Bravo'
        }, {
          left: 'Fox Sports Networks',
          right: 'Paramount Pictures'
        }, {
          left: 'United Talent Agency (UTA)',
          right: ''
        }]
      },
      table2: {
        title: 'Full-Time Employment:',
        data: [{
          left: 'Creative Arts Agency (CAA)',
          right: 'William Morris Endeavor (WME)'
        }, {
          left: 'United Talent Agency (UTA)',
          right: '20th Century Fox'
        }, {
          left: 'Warner Bros.',
          right: 'Sony Music Entertainment'
        }, {
          left: 'Google',
          right: 'Paramount Pictures'
        }],
        disclaimer: ''
      },
      courseData: {
        title: 'USC Marshall Artificial Intelligence for Business Program',
        subtitle: 'Four-Year Sample Course Sequence',
        key: [{
          courseColor: 'marshall-core',
          courseLabel: 'Marshall Core'
        }, {
          courseColor: 'usc-elective',
          courseLabel: 'USC Elective/Minor'
        }, {
          courseColor: 'usc-requirement',
          courseLabel: 'USC Requirement'
        }, {
          courseColor: 'ai',
          courseLabel: 'AI Core'
        }],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [{
                courseID: 'Math 125',
                courseName: 'Calculus',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 312',
                courseName: 'Stats & Data Science for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 150',
                courseName: 'Writing and Critical Reasoning',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CSCI 102',
                courseName: 'Fundamentals of Computation',
                courseColor: 'ai',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }, {
                courseID: 'BUAD 112',
                courseName: 'AI for Business Freshman Academy',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'ECON 351x',
                courseName: 'Microeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 304',
                courseName: 'Organizational Behavior and Leadership',
                courseColor: 'marshall-core',
                hasMin: false,
                min: '4',
                courseCredits: '4'
              }, {
                courseID: 'GESM',
                courseName: 'General Education Seminar',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CSCI 103',
                courseName: 'Introduction to Programming',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Optional Elective',
                courseName: 'BUAD 104',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [{
                courseID: 'BUAD 280',
                courseName: 'Introduction to Financial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'BUAD 302',
                courseName: 'Communication Strategy in Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'DSCI 281',
                courseName: 'Foundations of AI & Machine Learning',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CSCI 170',
                courseName: 'Discrete Meethods in Computer Science',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ITP 115 or 116',
                courseName: 'Programming in Python',
                courseColor: 'ai',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }],
              Spring: [{
                courseID: 'BUAD 307',
                courseName: 'Marketing Fundamentals',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 313',
                courseName: 'Advanced Operations Management & Analytics',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 306 or 308',
                courseName: 'Business Finance or Advanced Business Finance',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CSCI 104',
                courseName: 'Data Structures and Object Oriented Design',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [{
                courseID: 'BUAD 352x',
                courseName: 'Macroeconomics for Business',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'BUAD 281',
                courseName: 'Introduction to Managerial Accounting',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 3,
                courseCredits: 3
              }, {
                courseID: 'CSCI 360',
                courseName: 'Introduction to Artificial Intelligence',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'DSO 429',
                courseName: 'Digital Transformation of Business AI and Smart Contracts',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'MOR 458',
                courseName: 'Technology Strategy: The Case of AI',
                courseColor: 'ai',
                hasMin: true,
                min: 2,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'BUAD 497',
                courseName: 'Strategic Management',
                courseColor: 'marshall-core',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'CSCI 445',
                courseName: 'Intro to Robotics',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'WRIT 340',
                courseName: 'Advanced Writing for Business',
                courseColor: 'usc-requirement',
                hasMin: true,
                min: 3,
                courseCredits: 4
              }, {
                courseID: 'DSO 488',
                courseName: 'Hands on AI for Business',
                courseColor: 'ai',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [{
                courseID: 'EIS 370',
                courseName: 'Ethnical Issues in Artificial Intelligence',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'ITP 459',
                courseName: 'Applied Machine Learning for Natural Language Processing',
                courseColor: 'ai',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }],
              Spring: [{
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'GE',
                courseName: '',
                courseColor: 'usc-requirement',
                hasMin: false,
                min: 4,
                courseCredits: 4
              }, {
                courseID: 'Free Elective',
                courseName: '',
                courseColor: 'usc-elective',
                hasMin: false,
                min: 2,
                courseCredits: 2
              }]
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'AI For Business');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a98b5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/AiForBusiness.vue
var AiForBusiness_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_interdisciplinary"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-course-chart',{attrs:{"dataSet":_vm.courseData}},[_c('img',{attrs:{"slot":"image","src":__webpack_require__("eApo"),"alt":"Course chart for cinematic arts artificial intelligence for business"},slot:"image"})])],1)}
var AiForBusiness_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("From Siri to smart bots and beyond, artificial intelligence (AI) is not only increasingly part of our lives but is also revolutionizing commerce. The pioneering AI program blends core business concepts with big data knowledge to foster the strategic, communication and programming skills necessary for continued leadership in an ever-evolving technological landscape. BUAI students will graduate able to turn complicated concepts into success for industries spanning healthcare, finance, manufacturing, marketing, entertainment, public policy and more.")])]),_vm._v(" "),_c('p',[_vm._v("The program only enrolls 50 students a year to ensure collaboration and close mentorship from USC’s expert faculty. Each cohort is led by Professor Kimon Drakopoulos, a globally renowned authority in complex networked systems, game theory, financial modeling, information economics and other AI-related disciplines. He is committed to helping students explore their industry interests to find the ideal starting point for their careers.")]),_vm._v(" "),_c('p',[_vm._v("Whether you want to lead a consulting team, become a chief data officer or launch your own startup, if you love quantitative problem solving, the BUAI program could be right for you.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Core Courses")]),_vm._v(" "),_c('p',{staticClass:"p-heading"},[_c('strong',[_vm._v("Marshall courses (42 units) build solid foundations in:")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Accounting")]),_vm._v(" "),_c('li',[_vm._v("Economics")]),_vm._v(" "),_c('li',[_vm._v("Marketing")]),_vm._v(" "),_c('li',[_vm._v("Leadership and organizational behavior")]),_vm._v(" "),_c('li',[_vm._v("Strategy")]),_vm._v(" "),_c('li',[_vm._v("Communications\n")])]),_vm._v(" "),_c('p',{staticClass:"p-heading"},[_c('strong',[_vm._v("Viterbi courses (36 units) focus on:")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Machine learning")]),_vm._v(" "),_c('li',[_vm._v("Human-AI interactions")]),_vm._v(" "),_c('li',[_vm._v("Robotics")]),_vm._v(" "),_c('li',[_vm._v("Data science")]),_vm._v(" "),_c('li',[_vm._v("Programming")]),_vm._v(" "),_c('li',[_vm._v("Ethics in technology\n")])]),_vm._v(" "),_c('p',{staticClass:"p-heading"},[_vm._v("Meanwhile, the joint degree’s four integrative classes bring it all together to provide full context for making business decisions in the AI age. These courses, specifically created by Marshall for this degree cover:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Foundation in AI and business principles")]),_vm._v(" "),_c('li',[_vm._v("Digital transformation")]),_vm._v(" "),_c('li',[_vm._v("AI and smart contracts")]),_vm._v(" "),_c('li',[_vm._v("Technology strategy")])])])}]
var AiForBusiness_esExports = { render: AiForBusiness_render, staticRenderFns: AiForBusiness_staticRenderFns }
/* harmony default export */ var academics_AiForBusiness = (AiForBusiness_esExports);
// CONCATENATED MODULE: ./src/pages/academics/AiForBusiness.vue
function AiForBusiness_injectStyle (ssrContext) {
  __webpack_require__("+19q")
}
var AiForBusiness_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AiForBusiness___vue_template_functional__ = false
/* styles */
var AiForBusiness___vue_styles__ = AiForBusiness_injectStyle
/* scopeId */
var AiForBusiness___vue_scopeId__ = "data-v-33a98b5f"
/* moduleIdentifier (server only) */
var AiForBusiness___vue_module_identifier__ = null
var AiForBusiness_Component = AiForBusiness_normalizeComponent(
  AiForBusiness,
  academics_AiForBusiness,
  AiForBusiness___vue_template_functional__,
  AiForBusiness___vue_styles__,
  AiForBusiness___vue_scopeId__,
  AiForBusiness___vue_module_identifier__
)

/* harmony default export */ var pages_academics_AiForBusiness = (AiForBusiness_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ListImage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ListImage = ({
  name: 'ListImage',
  props: [],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4e2f2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListImage.vue
var ListImage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-listImg gutter-lg mb body"},[_c('div',{staticClass:"usc-listImg__col"},[_vm._t("title"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('ul',[_vm._t("item")],2)],2),_vm._v(" "),_c('div',{staticClass:"usc-listImg__col usc-listImg__col--pd"},[_vm._t("img")],2)])}
var ListImage_staticRenderFns = []
var ListImage_esExports = { render: ListImage_render, staticRenderFns: ListImage_staticRenderFns }
/* harmony default export */ var components_ListImage = (ListImage_esExports);
// CONCATENATED MODULE: ./src/components/ListImage.vue
function ListImage_injectStyle (ssrContext) {
  __webpack_require__("lpJo")
}
var ListImage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ListImage___vue_template_functional__ = false
/* styles */
var ListImage___vue_styles__ = ListImage_injectStyle
/* scopeId */
var ListImage___vue_scopeId__ = "data-v-6d4e2f2e"
/* moduleIdentifier (server only) */
var ListImage___vue_module_identifier__ = null
var ListImage_Component = ListImage_normalizeComponent(
  ListImage,
  components_ListImage,
  ListImage___vue_template_functional__,
  ListImage___vue_styles__,
  ListImage___vue_scopeId__,
  ListImage___vue_module_identifier__
)

/* harmony default export */ var src_components_ListImage = (ListImage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/DoubleMajors.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var DoubleMajors = ({
  name: 'UndergradAccounting',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-listImage': src_components_ListImage,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Double Majors and Minors',
        loResSrc: '../../../static/HeroImages/Academics5.jpg',
        hiResSrc: '../../../static/HeroImages/Academics5.jpg'
      },
      intro: ['USC offers 200+ majors and 250+ minors that can be combined with the Business Administration or Accounting degree to create a unique program tailored to your personal interests and professional aspirations.'],
      video1: {
        caption: 'Double Minors',
        src: 'https://player.vimeo.com/video/249450045?title=0&byline=0&portrait=0',
        frameTitle: 'Double Minors'
      },
      video2: {
        caption: 'Choosing a minor to become an expert in any industry',
        src: 'https://player.vimeo.com/video/249450045?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Customize your education with a minor'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Double Majors and Minors');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c79b5ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/DoubleMajors.vue
var DoubleMajors_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_doubleMajors"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Double Majors and Dual Degrees")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Many Marshall students pursue a double major. Among the most common are:")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Accounting")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Economics")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Psychology")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Political Science")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Biological Sciences (B.A.)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("East Asian Languages and Cultures")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("International Relations")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Music Industry")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Neuroscience")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Philosophy")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Public Policy, Management and Planning")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","alt":"","src":"/static/Academics_Double_Major-listimg.jpg"},slot:"img"})]),_vm._v(" "),_c('div',{staticClass:"body gutter-lg mb"},[_c('usc-cta',{attrs:{"text":"Explore double majors","url":"https://academics.usc.edu/"}})],1),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Minors")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("Frequent minors completed by Marshall students include:")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Cinematic Arts")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Psychology")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Economics")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("International Relations")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Music Industry")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Spanish")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Communication & the Entertainment Industry")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Real Estate Development")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Communications Design")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("East Asian Languages and Cultures")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Natural Sciences")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Sports Media Studies")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","alt":"","src":"/static/Academics_Minors.jpg"},slot:"img"})]),_vm._v(" "),_c('div',{staticClass:"body gutter-lg mb"},[_c('usc-videoEmbed',{attrs:{"frameTitle":this.video1.frameTitle,"caption":this.video1.caption,"videoSource":this.video1.src}}),_vm._v(" "),_c('usc-cta',{attrs:{"text":"Find your minor","url":"https://undergrad.usc.edu/programs/minor/list/"}})],1)],1)}
var DoubleMajors_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("Whether you are simply interested in learning more about a particular subject or have a specific career goal in mind, pursuing a minor or double major can enrich your educational experience and set you up for lifelong learning as well as professional success.")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("Z6vt"),"alt":"Infographic: 33% Marshall students who pursue a double major or minor. 200+ Majors. 250 Minors","title":"Infographic: 33% Marshall students who pursue a double major or minor. 200 Majors. 200+ Minors"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Examples of Minors and Double Majors for Business and Accounting Students:")]),_vm._v(" "),_c('h4',[_vm._v("Minor or double major in Psychology")]),_vm._v(" "),_c('p',[_vm._v("Students interested in marketing need to understand what attracts customers to certain products, ad campaigns or marketing strategies. A background in psychology will help you understand how to influence consumers’ decisions and give you an edge in the marketplace.")]),_vm._v(" "),_c('h4',[_vm._v("Minor in Natural Sciences")]),_vm._v(" "),_c('p',[_vm._v("If you’re considering attending medical school after graduation, you can satisfy all of the science requirements for admission to medical school by completing the Natural Sciences minor. The combination of an undergraduate business degree and medical degree can position you for success in opening your own medical practice or working in hospital administration.")]),_vm._v(" "),_c('h4',[_vm._v("Minor in a Foreign Language")]),_vm._v(" "),_c('p',[_vm._v("Anyone interested in working overseas or for a global company with international offices or clients will benefit from becoming bilingual or conversant in another language.")]),_vm._v(" "),_c('h4',[_vm._v("Minor in Professional and Managerial Communication")]),_vm._v(" "),_c('p',[_vm._v("Hone your communication skills—an advantage in any business venture, especially in leadership positions.")]),_vm._v(" "),_c('h4',[_vm._v("Minor or Double Major in International Relations")]),_vm._v(" "),_c('p',[_vm._v("Gain an advantage toward a career in international business, public diplomacy, government position overseas or any role that requires global and negotiation skills.")])])}]
var DoubleMajors_esExports = { render: DoubleMajors_render, staticRenderFns: DoubleMajors_staticRenderFns }
/* harmony default export */ var academics_DoubleMajors = (DoubleMajors_esExports);
// CONCATENATED MODULE: ./src/pages/academics/DoubleMajors.vue
function DoubleMajors_injectStyle (ssrContext) {
  __webpack_require__("dFWp")
}
var DoubleMajors_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DoubleMajors___vue_template_functional__ = false
/* styles */
var DoubleMajors___vue_styles__ = DoubleMajors_injectStyle
/* scopeId */
var DoubleMajors___vue_scopeId__ = "data-v-6c79b5ee"
/* moduleIdentifier (server only) */
var DoubleMajors___vue_module_identifier__ = null
var DoubleMajors_Component = DoubleMajors_normalizeComponent(
  DoubleMajors,
  academics_DoubleMajors,
  DoubleMajors___vue_template_functional__,
  DoubleMajors___vue_styles__,
  DoubleMajors___vue_scopeId__,
  DoubleMajors___vue_module_identifier__
)

/* harmony default export */ var pages_academics_DoubleMajors = (DoubleMajors_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/Electives.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Electives = ({
  name: 'Electives',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-course-chart': components_CourseChart_CourseChart,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Electives',
        loResSrc: '../../../static/HeroImages/Marshall116-High.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall116-High.jpg'
      },
      intro: ['Marshall students may take half of all undergraduate units outside of the school. This provides you access to the many benefits of being at a world-class university — such as exposure to innovative research, internationally acclaimed faculty and cutting-edge programs across a wide range of fields. You’ll learn beside budding filmmakers, engineers, regulatory scientists, urban planners, journalists and other future leaders.'],
      video: {
        caption: 'The Marshall Difference: Human-Centric Problem-Solving - AJ Ogilvie, Assistant Professor of Clinical Business Communication',
        src: 'https://player.vimeo.com/video/642795234',
        frameTitle: 'The Marshall Difference: Human-Centric Problem-Solving - AJ Ogilvie, Assistant Professor of Clinical Business Communication'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Electives');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e0f6bb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/Electives.vue
var Electives_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_wbb"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}})],1)}
var Electives_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("Marshall’s 32 free electives can be used throughout the university, including toward a minor or a double major. These are in addition to 12 upper-level business units that can be taken across all business departments to allow you to delve into a specific area of interest such as entrepreneurship or consulting. This is equivalent to eight courses — a full year of free electives — that can be spread over four years of study. We also offer meaningful certificate programs that demonstrate your skills in a particular area.")])]),_vm._v(" "),_c('p',[_vm._v("At Marshall, you call the shots. But you don’t have to go it alone. You’ll be supported by dedicated academic advisors, faculty and alumni mentors along the journey.")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("q0eN"),"title":"32 Free Electives, 12 Upper-Level Business Electives, and 250+ business electives to choose from","alt":"32 Free Electives and 12 Upper-Level Business Electives"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Sample Marshall Electives")]),_vm._v(" "),_c('h4',[_vm._v("BAEP 460: Seminar in Entrepreneurship: The Entrepreneur’s Digital Toolkit")]),_vm._v(" "),_c('p',[_vm._v("This course equips you with the necessary technology skills to build a startup in the digital space. You’ll be exposed to cloud technology, mobile architecture, social media, digital marketing and presentation skills for pitching investors. At the end, product videos are created and pitches are ready for submission to Kickstarter.")]),_vm._v(" "),_c('h4',[_vm._v("FBE 453a/b: Advanced Practicum in Investment Management")]),_vm._v(" "),_c('p',[_vm._v("Sixteen Marshall undergraduate students gain hands-on experience in managing a portion of the university’s equity endowment. The course is designed to give you rigorous exposure to contemporary investment and portfolio theory and practice as well as an understanding of the money management business.")]),_vm._v(" "),_c('h4',[_vm._v("MOR 462: Management Consulting")]),_vm._v(" "),_c('p',[_vm._v("In this course, you have the opportunity to go behind the scenes of the management consulting profession and some of its top firms. Consulting skills are fostered through written case analysis and discussion. Teams are assigned real-time consulting projects, which provide a unique learning experience in the business world.")]),_vm._v(" "),_c('h4',[_vm._v("MKT 446: Practicum in New Product Development and Branding")]),_vm._v(" "),_c('p',[_vm._v("In this experiential learning course, students step into the shoes of a product manager and lead the development of an actual product. You will research, create, design and develop prototypes and marketing plans for a successful new product introduction for a brand. The course is collaboratively taught by faculty from Marshall and the Viterbi School of Engineering and Roski School of Fine Arts.")]),_vm._v(" "),_c('h4',[_vm._v("MOR 558: Technology Strategy in the Age of AI")]),_vm._v(" "),_c('p',[_vm._v("Artificial intelligence is becoming ubiquitous across all industries. As a result, it is likely that, regardless of your chosen path, you will encounter situations where decisions about involvement with AI technologies need to be made. Technology strategy provides the tools necessary to make such decisions. Rather than looking at the role of past technological changes in shaping societal and business outcomes, this class takes a forward-looking approach and focuses on emerging technologies and their likely role in shaping the technology strategy of modern businesses.")])])}]
var Electives_esExports = { render: Electives_render, staticRenderFns: Electives_staticRenderFns }
/* harmony default export */ var academics_Electives = (Electives_esExports);
// CONCATENATED MODULE: ./src/pages/academics/Electives.vue
function Electives_injectStyle (ssrContext) {
  __webpack_require__("Fi60")
}
var Electives_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Electives___vue_template_functional__ = false
/* styles */
var Electives___vue_styles__ = Electives_injectStyle
/* scopeId */
var Electives___vue_scopeId__ = "data-v-1e0f6bb5"
/* moduleIdentifier (server only) */
var Electives___vue_module_identifier__ = null
var Electives_Component = Electives_normalizeComponent(
  Electives,
  academics_Electives,
  Electives___vue_template_functional__,
  Electives___vue_styles__,
  Electives___vue_scopeId__,
  Electives___vue_module_identifier__
)

/* harmony default export */ var pages_academics_Electives = (Electives_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/Faculty.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Faculty = ({
  name: 'UndergradAccounting',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-calloutLink': src_components_CalloutLink
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Faculty',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall2.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall2.jpg'
      },
      intro: ['A leading business school is founded on its thought leadership and its commitment to producing information and ideas that have the potential to change the world. Leaders in all professions want to be close to the source of those ideas, many of which emanate from Marshall.'],
      video: {
        caption: 'AJ Ogilvie, Assistant Professor of Clinical Business Communication - The Marshall Difference: Human-Centric Problem-Solving',
        src: 'https://player.vimeo.com/video/642795234?title=0&byline=0&portrait=0',
        frameTitle: 'AJ Ogilvie, Assistant Professor of Clinical Business Communication - The Marshall Difference: Human-Centric Problem-Solving'
      },
      CalloutLink: {
        title: 'Meet your future mentors',
        urltext: 'Meet your future mentors',
        url: 'https://www.marshall.usc.edu/faculty-research/faculty-directory'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Faculty');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac3aa90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/Faculty.vue
var Faculty_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_faculty"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-calloutLink',{attrs:{"urltext":"Meet your future mentors","url":"https://www.marshall.usc.edu/faculty-research/faculty-directory"}}),_vm._v(" "),_c('div',{staticClass:"body gutter-lg mb"},[_vm._m(1),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("HnTt"),"alt":"240 Full-Time Faculty, 39 Endowed Chairs, and 7 Centers of Excellence.","title":"240 Full-Time Faculty, 39 Endowed Chairs, and 7 Centers of Excellence."}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10)],1)}
var Faculty_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("Marshall is home to some of the nation’s most sought-after researchers and educators. Our tenured faculty include an advisor to five U.S. presidents, a former chief economist of the Securities and Exchange Commission and a renowned scholar who recently received the most coveted honor in marketing for an article recognized as having made the best contribution to the science of marketing in the past decade.")])]),_vm._v(" "),_c('p',[_vm._v("At Marshall, close faculty-student partnerships are the norm. Over the course of their time here, our undergraduates get to know their professors as teachers, mentors and friends. It’s collaborative learning at its finest, creating incredible opportunities for personal development, professional growth and groundbreaking discovery.")]),_vm._v(" "),_c('p',[_vm._v("Outside of the classroom, faculty also serve as student-organization advisors and case coaches, as well as travel on service-learning and international educational trips.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Learn about the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.marshall.usc.edu/faculty-research/research-usc-marshall"}},[_vm._v("Marshall faculty’s latest and most exciting research")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Student-Faculty Partnerships")]),_c('br'),_c('i',[_vm._v("Marshall students have the opportunity to work one-on-one\n        with faculty in research and supplemental-learning opportunities.")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("BUAD 490: Directed Research.")]),_vm._v(" Driven students may approach a faculty member of their choosing\n      to discuss possible research topics and become a “student colleague” with that faculty member on a research\n      project. Offering up to eight units, the course can be spread over multiple semesters. Students will work with\n      the faculty member to design the project, develop a meeting schedule, identify course deliverables and conduct\n      the research throughout the course of the project.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("BUAD 499: Special Topics.")]),_vm._v(" Another student-driven course, BUAD 499 allows students to work with\n      faculty to gain additional expertise on a subject of the student’s choosing (for instance, how business\n      intertwines with the student’s minor). Students will discuss their plan and expectations with a faculty member\n      of their choosing, who will then work with the student to design a learning plan, coursework and deliverables,\n      then meet with the student throughout the course to discuss topics and gauge progress. This class can also be\n      spread over semesters with up to eight units possible.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Research")]),_c('br'),_vm._v("Marshall’s research reputation is strong and growing. Faculty members have\n      expertise across all major business disciplines. They publish consistently in prominent professional journals\n      and hold editorial positions in leading journals. In addition to their broad-ranging interests, our faculty\n      share a common bond—they are drawn to Marshall by a unique community that presents opportunities for\n      professional growth, groundbreaking discovery and sharing the lessons they learn from their research with\n      students.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Centers for Excellence")]),_c('br'),_vm._v("Our institutes, Centers of Excellence and inititives are another area where our faculty’s knowledge and experience provide students with unique opportunities beyond the classroom."),_c('br'),_vm._v("They include:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Peter Arkley Institute for Risk Management")]),_vm._v(" "),_c('li',[_vm._v("Brittingham Social Enterprise Lab")]),_vm._v(" "),_c('li',[_vm._v("Randall R. Kendrick Global Supply Chain Institute")]),_vm._v(" "),_c('li',[_vm._v("Institute for Outlier Research in Business")]),_vm._v(" "),_c('li',[_vm._v("Center for Effective Organizations")]),_vm._v(" "),_c('li',[_vm._v("Center for Global Innovation")]),_vm._v(" "),_c('li',[_vm._v("Center for Investment Studies")]),_vm._v(" "),_c('li',[_vm._v("Lloyd Greif Center for Entrepreneurial Studies")]),_vm._v(" "),_c('li',[_vm._v("Neely Center for Ethical Leadership and Decision Making")]),_vm._v(" "),_c('li',[_vm._v("Initiative on Digital Competition")]),_vm._v(" "),_c('li',[_vm._v("Vaneck Digital Assets Initiative")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('div',{staticClass:"cardinal-line mt",staticStyle:{"margin-bottom":"1em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Thought Leaders")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Distinguished researchers fill the halls in every department at Marshall. Some of the thought leaders with\n        whom you will work and learn include the following:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Communication: Robyn Walker")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      Communication and decision making in teams")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      American Communication Journal; International Journal of Diversity in Organizations, Communities and Nations;\n      International Journal of Knowledge, Culture and Change Management; and Business Communication Quarterly")]),_vm._v(" "),_c('p',[_vm._v("\n      Editor, Journal of Business Communication; Mellon Fellow, USC; Peer Achievement Faculty Award, USC Student\n      Senate Leadership Council; three-time recipient of both the USC Marshall School of Business Summer Research\n      Grant and USC Undergraduate Research Grant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Economics: Kevin Murphy")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      Executive compensation")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      Journal of Accounting & Economics, Journal of Financial Economics, American Economic Review Papers and\n      Proceedings and the University of Chicago Law Review")]),_vm._v(" "),_c('p',[_vm._v("Select honors/experience: Associate Editor, Journal of Financial Economics and Journal of Corporate Finance\n      (current); expert, U.S. Department of Treasury, Office of the Special Master for Executive Compensation (2009);\n      Chairman, Academic Research Committee, American Compensation Association (1997-99)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Marketing: Valerie Folkes")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      Consumers’ responses to negative information and attributions for service and product performance")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      Journal of Consumer Research, Psychology and Marketing and Journal of the Academy of Marketing Science")]),_vm._v(" "),_c('p',[_vm._v("Select honors:\n      Best Article on Services Award, American Marketing Association Services SIG; USC Mellon Award for Excellence in\n      Marketing; Outstanding Reviewer Award, Journal of Consumer Research; President, Association for Consumer\n      Research (2001)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Organizational Behavior: Nathanael Fast")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      The influence of power on people and their leadership effectiveness; the facilitation of the spread of culture\n    ")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      Journal of Experimental Social Psychology and Psychological Science")]),_vm._v(" "),_c('p',[_vm._v("Select honors:\n      Best Papers Proceedings, Academy of Management; State Farm Doctoral Dissertation Award; All-American Scholar\n      Athlete, Baseball; Graduate Dean’s Medal, College of Science and Mathematics, CSU-Fresno; Poets & Quants “best\n      40 B-school profs under the age of 40”")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Statistics: Yingying Fan")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      High-dimensional statistical inference, classification and variable selection, nonparametric statistics and\n      financial econometrics")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      The Annals of Statistics, Journal of Econometrics and Journal of the American Statistical Association")]),_vm._v(" "),_c('p',[_vm._v("Select honors:\n      National Science Foundation Grant; Fellowship, Princeton University; Chair, IOM Department Statistics Seminar,\n      USC Marshall School of Business (current); Zumberge Individual Award, USC James H. Zumberge Faculty Research and\n      Innovation Fund")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Strategy: Peer Fiss")]),_vm._v(" "),_c('p',[_vm._v("Expertise:\n      Diffusion of practices, framing and decoupling, symbolic management, corporate governance, strategic management,\n      configurational theory, fuzzy set qualitative comparative analysis (fsQCA), set-theoretic methods in management\n      and the social sciences")]),_vm._v(" "),_c('p',[_vm._v("Select publications:\n      Academy of Management Journal, Academy of Management Review and Strategic Management Journal")]),_vm._v(" "),_c('p',[_vm._v("Select honors:\n      Ascendant Scholar Award, Western Academy of Management; Award for Excellence in Research, USC Marshall School of\n      Business; Fellow, Judge Business School, University of Cambridge")])])}]
var Faculty_esExports = { render: Faculty_render, staticRenderFns: Faculty_staticRenderFns }
/* harmony default export */ var advantages_Faculty = (Faculty_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/Faculty.vue
function Faculty_injectStyle (ssrContext) {
  __webpack_require__("nSxd")
}
var Faculty_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Faculty___vue_template_functional__ = false
/* styles */
var Faculty___vue_styles__ = Faculty_injectStyle
/* scopeId */
var Faculty___vue_scopeId__ = "data-v-3ac3aa90"
/* moduleIdentifier (server only) */
var Faculty___vue_module_identifier__ = null
var Faculty_Component = Faculty_normalizeComponent(
  Faculty,
  advantages_Faculty,
  Faculty___vue_template_functional__,
  Faculty___vue_styles__,
  Faculty___vue_scopeId__,
  Faculty___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_Faculty = (Faculty_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-tiny-slider/dist/index.js
var dist = __webpack_require__("O/CO");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/academics/ThoughtLeaders.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ThoughtLeaders = ({
  name: 'UndergradAccounting',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'tiny-slider': dist_default.a
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Thought Leaders',
        loResSrc: './static/blur/Academics_ThoughtLeaders.jpg',
        hiResSrc: './static/Academics_ThoughtLeaders.jpg'
      },
      intro: ['Distinguished researchers fill the halls in every department at Marshall. Some of the thought leaders with whom you will work and learn include the following:'],
      slideIndex: 1,
      vueTinySlider: dist_default.a,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Academics_Thought_Leaders_2.jpg',
        alt: 'Woman speaking in front of a class',
        id: 0
      }, {
        image: '/static/Academics_Thought_Leaders_3.jpg',
        alt: 'Man writing on whiteboard',
        id: 1
      }],
      slideIndex2: 1,
      prevDisabled2: true,
      nextDisabled2: false,
      slides2: [{
        image: '/static/Academics_Thought_Leaders_5.jpg',
        alt: 'Woman sitting at a desk speaking to two younger people',
        id: 0
      }, {
        image: '/static/Academics_Thought_Leaders_6.jpg',
        alt: 'Woman speaking in front of a class',
        id: 1
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Academics', 'Thought Leaders');
  },


  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    },
    prevSlide2: function prevSlide2() {
      if (this.slideIndex2 > 1) {
        this.slideIndex2--;
      } else {
        this.prevDisabled2 = true;
      }
    },
    nextSlide2: function nextSlide2() {
      if (this.slideIndex2 < this.totalSlides2) {
        this.slideIndex2++;
      } else {
        this.nextDisabled2 = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    },
    totalSlides2: function totalSlides2() {
      return this.slides2.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08917830","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/academics/ThoughtLeaders.vue
var ThoughtLeaders_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"academic_thought_leaders"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('usc-cta',{attrs:{"slot":"cta","text":"Meet your future mentors","url":"https://www.marshall.usc.edu/faculty-research/faculty-directory"},slot:"cta"})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"gutter-md"},[_c('div',{staticClass:"usc-carousel__header"},[_c('div',{staticClass:"usc-carousel__title"},[_vm._v("Our Thought Leaders")]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__nav"},[_c('div',{staticClass:"usc-carousel__controls",attrs:{"id":"customize-controls"}},[_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Previous Image","disabled":_vm.prevDisabled,"type":"button"},on:{"click":_vm.prevSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"}})])]),_vm._v(" "),_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Next Image","disabled":_vm.nextDisabled,"type":"button"},on:{"click":_vm.nextSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__counter"},[_vm._v("\n          "+_vm._s(this.slideIndex)+" / "+_vm._s(this.totalSlides)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb"},[_c('tiny-slider',{staticClass:"usc-carousel",attrs:{"mouse-drag":false,"loop":false,"items":"1","responsive":true,"controlsContainer":"#customize-controls"}},_vm._l((this.slides),function(slide,index){return _c('div',{staticClass:"usc-carousel__slide"},[_c('div',{staticClass:"usc-carousel__outer"},[_c('img',{staticClass:"usc-carousel__inner",attrs:{"src":slide.image,"alt":slide.alt || ''}})])])}))],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"gutter-md"},[_c('div',{staticClass:"usc-carousel__header"},[_c('div',{staticClass:"usc-carousel__title"},[_vm._v("Our Thought Leaders")]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__nav"},[_c('div',{staticClass:"usc-carousel__controls",attrs:{"id":"customize-controls2"}},[_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Previous Image","disabled":_vm.prevDisabled,"type":"button"},on:{"click":_vm.prevSlide2}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"}})])]),_vm._v(" "),_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Next Image","disabled":_vm.nextDisabled,"type":"button"},on:{"click":_vm.nextSlide2}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__counter"},[_vm._v("\n          "+_vm._s(this.slideIndex2)+" / "+_vm._s(this.totalSlides2)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb"},[_c('tiny-slider',{staticClass:"usc-carousel",attrs:{"mouse-drag":false,"loop":false,"items":"1","responsive":true,"controlsContainer":"#customize-controls2"}},_vm._l((this.slides2),function(slide,index){return _c('div',{staticClass:"usc-carousel__slide"},[_c('div',{staticClass:"usc-carousel__outer"},[_c('img',{staticClass:"usc-carousel__inner",attrs:{"src":slide.image,"alt":slide.alt || ''}})])])}))],1)],1)}
var ThoughtLeaders_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Accounting: Mingyi Hung")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("The role of accounting information in global markets")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Accounting and Economics, Journal of Accounting Research and Review of Accounting Studies")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Best Paper Award, European Accounting Association; Best Paper Prize, Journal of Accounting and Economics; USC Marshall Golden Apple Award; two research grants from Hong Kong University")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Communication: Robyn Walker")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Communication and decision making in teams")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("American Communication Journal; International Journal of Diversity in Organizations, Communities and Nations; International Journal of Knowledge, Culture and Change Management; and Business Communication Quarterly")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Editor, Journal of Business Communication; Mellon Fellow, USC; Peer Achievement Faculty Award, USC Student Senate Leadership Council; three-time recipient of both the USC Marshall School of Business Summer Research Grant and USC Undergraduate Research Grant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Economics: Kevin Murphy")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Executive compensation")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Accounting & Economics, Journal of Financial Economics, American Economic Review Papers and Proceedings and the University of Chicago Law Review")]),_vm._v(" "),_c('h4',[_vm._v("Additional professional service/experience")]),_vm._v(" "),_c('p',[_vm._v("Associate Editor, Journal of Financial Economics and Journal of Corporate Finance (current); expert, U.S. Department of Treasury, Office of the Special Master for Executive Compensation (2009); Chairman, Academic Research Committee, American Compensation Association (1997-99)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Entrepreneurship: Helena Yli-Renko")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Growth and performance of young, technology-based firms; internationalization; and knowledge acquisition and social capital in interfirm relationships")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Marketing, International Business Review and Entrepreneurship and Regional Development")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Hills Award for Best Paper, American Marketing Association; Editorial Board member, Journal of Management Studies and International Journal of Technoentrepreneurship; 1996 Finnish Champion, Ladies’ Team Championship in Golf")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Finance: Fernando Zapatero")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Mathematical and computational methods in asset pricing and corporate finance")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Accounting and Economics, Journal of Accounting Research and Review of Accounting Studies")]),_vm._v(" "),_c('h4',[_vm._v("Additional professional service/experience")]),_vm._v(" "),_c('p',[_vm._v("Associate Editor, Annals of Finance, Journal of Economic Dynamics and Control, Mathematical Finance and Mathematics and Financial Economics (all current); Chair, Department of Finance and Business Economics, USC Marshall School of Business; referee, more than 25 journals")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Marketing: Valerie Folkes")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Consumers’ responses to negative information and attributions for service and product performance")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Consumer Research, Psychology and Marketing and Journal of the Academy of Marketing Science")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Best Article on Services Award, American Marketing Association Services SIG; USC Mellon Award for Excellence in Marketing; Outstanding Reviewer Award, Journal of Consumer Research; President, Association for Consumer Research (2001)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Operations: Amy Ward ")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Approximation and the control of stochastic systems; impact of customer impatience and abandonments on service system performance")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Applied Probability, Mathematics of Operation Research and Operations Research")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Operations Research Meritorious Service Award; co-advisor, 2006 Nicholson Student Paper Competition winner; Associate Editor, IIE Transactions, Service Operations Engineering Department")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Organizational Behavior: Nathanael Fast")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("The influence of power on people and their leadership effectiveness; the facilitation of the spread of culture")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Journal of Experimental Social Psychology and Psychological Science")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Best Papers Proceedings, Academy of Management; State Farm Doctoral Dissertation Award; All-American Scholar Athlete, Baseball; Graduate Dean’s Medal, College of Science and Mathematics, CSU-Fresno")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Statistics: Yingying Fan")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("High-dimensional statistical inference, classification and variable selection, nonparametric statistics and financial econometrics")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("The Annals of Statistics, Journal of Econometrics and Journal of the American Statistical Association")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("National Science Foundation Grant; Fellowship, Princeton University; Chair, IOM Department Statistics Seminar, USC Marshall School of Business (current); Zumberge Individual Award, USC James H. Zumberge Faculty Research and Innovation Fund")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h3',[_vm._v("Strategy: Peer Fiss")]),_vm._v(" "),_c('h4',[_vm._v("Expertise")]),_vm._v(" "),_c('p',[_vm._v("Diffusion of practices, framing and decoupling, symbolic management, corporate governance, strategic management, configurational theory, fuzzy set qualitative comparative analysis (fsQCA), set-theoretic methods in management and the social sciences")]),_vm._v(" "),_c('h4',[_vm._v("Select publications")]),_vm._v(" "),_c('p',[_vm._v("Academy of Management Journal, Academy of Management Review and Strategic Management Journal")]),_vm._v(" "),_c('h4',[_vm._v("Select honors")]),_vm._v(" "),_c('p',[_vm._v("Ascendant Scholar Award, Western Academy of Management; Award for Excellence in Research, USC Marshall School of Business; Fellow, Judge Business School, University of Cambridge")])])}]
var ThoughtLeaders_esExports = { render: ThoughtLeaders_render, staticRenderFns: ThoughtLeaders_staticRenderFns }
/* harmony default export */ var academics_ThoughtLeaders = (ThoughtLeaders_esExports);
// CONCATENATED MODULE: ./src/pages/academics/ThoughtLeaders.vue
function ThoughtLeaders_injectStyle (ssrContext) {
  __webpack_require__("R0vA")
}
var ThoughtLeaders_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ThoughtLeaders___vue_template_functional__ = false
/* styles */
var ThoughtLeaders___vue_styles__ = ThoughtLeaders_injectStyle
/* scopeId */
var ThoughtLeaders___vue_scopeId__ = "data-v-08917830"
/* moduleIdentifier (server only) */
var ThoughtLeaders___vue_module_identifier__ = null
var ThoughtLeaders_Component = ThoughtLeaders_normalizeComponent(
  ThoughtLeaders,
  academics_ThoughtLeaders,
  ThoughtLeaders___vue_template_functional__,
  ThoughtLeaders___vue_styles__,
  ThoughtLeaders___vue_scopeId__,
  ThoughtLeaders___vue_module_identifier__
)

/* harmony default export */ var pages_academics_ThoughtLeaders = (ThoughtLeaders_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/ExperientialLearning.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var ExperientialLearning = ({
  name: 'ExperientialLearning',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-table': src_components_Table,
    'usc-list-img': src_components_ListImage,
    'usc-dataviz': src_components_DataViz
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Experiential Learning',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall6.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall6.jpg'
      },
      video: {
        caption: 'The Next 100 Years',
        src: 'https://player.vimeo.com/video/668392133',
        frameTitle: 'Video: The Next 100 Years'
      },
      video1: {
        caption: 'USC Marshall Experiential Learning Center',
        src: 'https://player.vimeo.com/video/210511467',
        frameTitle: 'USC Marshall Experiential Learning Center'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Experiential Learning');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44922a5d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/ExperientialLearning.vue
var ExperientialLearning_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_Experiental-Learning"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("The most beneficial learning allows you to blend what you study in class with how it will apply in the real world during your career. At Marshall, we ensure you leave our programs armed with hands-on experiences that deeply instill the critical-thinking, communications and collaborative skills you will need to launch successful careers in any field you choose. You’ll learn by doing — in the classroom, in our specialized learning centers, and through internships and student organizations.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video1.frameTitle,"caption":this.video1.caption,"videoSource":this.video1.src}}),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(1)],1)}
var ExperientialLearning_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg"},[_c('p',[_c('i',[_vm._v("Not only is our curriculum infused with meaningful experiential learning exercises, but you will also have\n        plentiful opportunities for immersive learning through our pioneering Experiential Learning Center,\n        Brittingham Social Enterprise Lab, a student investment fund and other unique programs as well as case\n        competitions.")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Experiential Learning Center")]),_c('br'),_vm._v("\n      The nation’s first applied learning program of its kind, Marshall’s Experiential Learning Center (ELC) is a\n      behavioral laboratory in which students participate in business simulations that mimic real-life work settings.\n      Considered to be one of the top training facilities in institutions of higher education, ELC employs\n      professional trainers who conduct management training workshops for Marshall classes.\n    ")]),_vm._v(" "),_c('p',[_vm._v("ELC trainers work closely with faculty from various departments to ensure that the appropriate and specific\n      educational objectives are met. Training modules at the ELC cover leadership, communication, intercultural\n      interactions, business strategy, business ethics, social responsibility, negotiation, management consulting and\n      a host of other topics relevant to business education. ELC employs both “face-to-face” and immersive and\n      interactive methods of instruction that expose every Marshall student to the concepts of “learning by doing” and\n      “learning by active engagement.”")]),_vm._v(" "),_c('p',[_vm._v("ELC consists of 18 fully equipped studios that facilitate recording and capture of training sessions and\n      presentations. More than 60 Marshall courses and hundreds of classes use ELC services each year.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg"},[_c('p'),_c('p',[_c('strong',[_vm._v("Brittingham Social Enterprise Lab")]),_c('br'),_vm._v("\n        At the forefront of pioneering education to train the next generation of social entrepreneurs, Marshall’s\n        Brittingham Social Enterprise Lab integrates the best of business and social thinking to address world\n        problems. It applies new models for social involvement to the corporate world and trains the next generation\n        of responsible business leaders while providing a base for related academic research.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        The lab incorporates a bridging program, the first of its kind at a university business school, that creates\n        new models enabling corporations to use their non-cash resources for the benefit of communities around the\n        world. It also offers coursework in social responsibility, social enterprise and ethics; coordinates USC\n        Marshall student and faculty nonprofit consulting efforts; and supports faculty research.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Undergraduate Student Investment Fund")]),_c('br'),_vm._v("\n        The Undergraduate Student Investment Fund is a primary function of Marshall’s capstone investment management\n        course, Advanced Practicum in Portfolio Management. The course offers a yearlong experiential-learning seminar\n        in applied investment management designed to give students rigorous exposure to contemporary investment and\n        portfolio theory and practice. It also enables you to learn the skills of actual money managers, presenting\n        the analytical framework and tools for valuation of stocks, bonds, options, futures, risk management and\n        portfolio optimization and performance attribution. In addition, behavioral finance is introduced. Students\n        demonstrate and refine their understanding and ability to apply analytical concepts and techniques through\n        fund management, industry reports, company research reports and stock pitching exercises.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Case Competitions")]),_c('br'),_vm._v("\n        In case competitions, undergraduate student teams from top business schools around the world compete against\n        each other under deadline conditions to develop solutions for real-life business problems.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Participation in the five-day USC Marshall International Case Competition, the largest international case\n        competition in the world, is both an honor and a supreme challenge. Students are chosen for the team on the\n        basis of their familiarity with business fundamentals, understanding of complex international business issues\n        and strong analytical-reasoning and presentation skills.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Each team has just 20 minutes to present its analysis and recommendations. Teams are judged by a panel of\n        industry experts, including CEOs, top management executives, consultants and academics.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        USC Marshall also participates in — and often wins — undergraduate case competitions around the world. We’ve recently fielded student teams at competitions in Copenhagen, Montreal and Singapore.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Supporting Budding Entrepreneurs")]),_c('br'),_vm._v("\n        Marshall is also home to the pioneering Lloyd Greif Center for Entrepreneurial Studies, featuring the mentors,\n        classes and support needed to launch new ventures in whatever field you choose. The competitive but inclusive\n        USC Marshall/Greif Incubator takes budding entrepreneurs through every step in turning fresh ideas into\n        marketable products.\n      ")]),_vm._v(" "),_c('p',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("/hGJ"),"alt":"1st: Marshall is home to the nation's first integrated entrepreneurship program. 1st: Marshall created the first social entreprise academic center. 100+: Number of startups accepted by the Marshall Incubator. 80+: Course sections on entreprenurship. $150k: Annual New Venture Seed Competition prize pool.","title":"1st: Marshall is home to the nation's first integrated entrepreneurship program. 1st: Marshall created the first social entreprise academic center. 100+: Number of startups accepted by the Marshall Incubator. 80+: Course sections on entreprenurship. $150k: Annual New Venture Seed Competition prize pool."}})])])}]
var ExperientialLearning_esExports = { render: ExperientialLearning_render, staticRenderFns: ExperientialLearning_staticRenderFns }
/* harmony default export */ var advantages_ExperientialLearning = (ExperientialLearning_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/ExperientialLearning.vue
function ExperientialLearning_injectStyle (ssrContext) {
  __webpack_require__("9JiT")
}
var ExperientialLearning_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ExperientialLearning___vue_template_functional__ = false
/* styles */
var ExperientialLearning___vue_styles__ = ExperientialLearning_injectStyle
/* scopeId */
var ExperientialLearning___vue_scopeId__ = "data-v-44922a5d"
/* moduleIdentifier (server only) */
var ExperientialLearning___vue_module_identifier__ = null
var ExperientialLearning_Component = ExperientialLearning_normalizeComponent(
  ExperientialLearning,
  advantages_ExperientialLearning,
  ExperientialLearning___vue_template_functional__,
  ExperientialLearning___vue_styles__,
  ExperientialLearning___vue_scopeId__,
  ExperientialLearning___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_ExperientialLearning = (ExperientialLearning_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TwoColumns.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TwoColumns = ({
  name: 'TwoColumns',
  props: ['copy'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066b81aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwoColumns.vue
var TwoColumns_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two-columns gutter-lg mb body"},[_vm._t("fullWidth"),_vm._v(" "),_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)])],2)}
var TwoColumns_staticRenderFns = []
var TwoColumns_esExports = { render: TwoColumns_render, staticRenderFns: TwoColumns_staticRenderFns }
/* harmony default export */ var components_TwoColumns = (TwoColumns_esExports);
// CONCATENATED MODULE: ./src/components/TwoColumns.vue
function TwoColumns_injectStyle (ssrContext) {
  __webpack_require__("sDBh")
}
var TwoColumns_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TwoColumns___vue_template_functional__ = false
/* styles */
var TwoColumns___vue_styles__ = TwoColumns_injectStyle
/* scopeId */
var TwoColumns___vue_scopeId__ = "data-v-066b81aa"
/* moduleIdentifier (server only) */
var TwoColumns___vue_module_identifier__ = null
var TwoColumns_Component = TwoColumns_normalizeComponent(
  TwoColumns,
  components_TwoColumns,
  TwoColumns___vue_template_functional__,
  TwoColumns___vue_styles__,
  TwoColumns___vue_scopeId__,
  TwoColumns___vue_module_identifier__
)

/* harmony default export */ var src_components_TwoColumns = (TwoColumns_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/Internships.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var Internships = ({
  name: 'Internships',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-table': src_components_Table,
    'usc-callout-link': src_components_CalloutLink,
    'usc-twoColumns': src_components_TwoColumns,
    'usc-dataviz': src_components_DataViz
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Internships and Career Services',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall9.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall9.jpg'
      },
      video: {
        caption: 'Career Pathways',
        src: 'https://player.vimeo.com/video/652701332',
        frameTitle: 'Career Pathways'
      },
      video1: {
        caption: 'Why Executives Choose Marshall',
        src: 'https://player.vimeo.com/video/249454520',
        frameTitle: 'Why Executives Choose Marshall'
      },
      calloutLinks: [{
        title: 'Accept my offer',
        url: 'https://you.usc.edu/login/',
        urltext: 'Count me in!'
      }],
      dataViz: [{
        color: '#ffcc00',
        labelBold: '40%',
        labelSmall: '3+ Internships'
      }, {
        color: '#990000',
        labelBold: '34%',
        labelSmall: '2 Internships'
      }, {
        color: '#cbcbcb',
        labelBold: '26%',
        labelSmall: '1 Internships'
      }],
      table: {
        title: 'Top 25 hiring companies',
        data: [{
          left: 'Adobe',
          right: 'Amazon'
        }, {
          left: 'Apple',
          right: 'Boston Consulting Group'
        }, {
          left: 'CAA',
          right: 'Deloitte'
        }, {
          left: 'Disney',
          right: 'DoorDash'
        }, {
          left: 'Goldman Sachs',
          right: 'JPMorgan Chase & Co.'
        }, {
          left: 'Lazard',
          right: 'L\'Oreal'
        }, {
          left: 'McKinsey & Company',
          right: 'NBCUniversal Media, LLC'
        }, {
          left: 'Nike',
          right: 'Northrop Grumman'
        }, {
          left: 'PwC',
          right: 'Red Bull'
        }, {
          left: 'Salesforce',
          right: 'Uber'
        }],
        disclaimer: ''
      },
      table2: {
        title: '25 top internships',
        data: [{
          left: 'Aflac',
          right: 'Bank of America'
        }, {
          left: 'Bank of America Merrill Lynch',
          right: 'Brillstein Entertainment Partners'
        }, {
          left: 'Capital Group',
          right: 'Cisco Systems, Inc.'
        }, {
          left: 'Deloitte',
          right: 'Disney'
        }, {
          left: 'Ernst & Young',
          right: 'Fox'
        }, {
          left: 'J.P.Morgan',
          right: 'KPMG'
        }, {
          left: 'Live Nation',
          right: 'Lionsgate'
        }, {
          left: 'Morgan Stanley',
          right: 'NBCUniversal'
        }, {
          left: 'Northrop Grumman',
          right: 'Northwestern Mutual'
        }, {
          left: 'PricewaterhouseCoopers',
          right: 'UBS'
        }, {
          left: 'USC',
          right: 'Viacom'
        }, {
          left: 'Warner Bros. Records',
          right: 'Wells Fargo'
        }, {
          left: 'Wilshire Financial Network',
          right: ''
        }],
        disclaimer: ''
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Careers and Internships');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21fc27bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/Internships.vue
var Internships_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_Internships"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("Nearly all Marshall undergraduates intern during their four years at the school — with 34% of all students earning three or more internships. These real-world learning opportunities are available to you on virtually every continent and field within the business world.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-dataviz',{attrs:{"data":_vm.dataViz}},[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("A majority of Marshall undergraduates pursue multiple internships")]),_vm._v(" "),_c('svg',{staticClass:"scaling-svg",attrs:{"slot":"svg","xmlns":"http://www.w3.org/2000/svg","id":"sv","width":"300","height":"300","viewBox":"0 0 300 300"},slot:"svg"},[_c('path',{attrs:{"id":"0","fill":"#fc0","d":"M150, 0 A150,150 0 0 1 238.17625963515837,271.34639358775 L150,150 A0,0 0 0 0 150,150 Z"}}),_c('path',{attrs:{"id":"1","fill":"#900","d":"M238.17625963515837, 271.34639358775 A150,150 0 0 1 0.2972084347992734,159.43791277699 L150,150 A0,0 0 0 0 150,150 Z"}}),_c('path',{attrs:{"id":"2","fill":"#cbcbcb","d":"M0.2972084347992734, 159.43791277699 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"0","fill":"#777","d":"M90, 0 A90,90 0 0 1 159.34979626067692,147.3638018144073 L90,90 A0,0 0 0 0 90,90 Z"}}),_c('path',{attrs:{"id":"1","fill":"#CCC","d":"M159.34979626067692, 147.3638018144073 A90,90 0 0 1 11.137469472510801,133.3670529180948 L90,90 A0,0 0 0 0 90,90 Z"}}),_c('path',{attrs:{"id":"2","fill":"#900","d":"M11.137469472510801, 133.3670529180948 A90,90 0 0 1 37.08789073805259,17.19678102273403 L90,90 A0,0 0 0 0 90,90 Z"}}),_c('path',{attrs:{"id":"3","fill":"#ffcc01","d":"M37.08789073805259, 17.19678102273403 A90,90 0 0 1 62.17427868583063,4.409526036210195 L90,90 A0,0 0 0 0 90,90 Z"}}),_c('path',{attrs:{"id":"4","fill":"#fff","d":"M62.17427868583063, 4.409526036210195 A90,90 0 0 1 89.98429203681187,0.0000013707783779182137 L90,90 A0,0 0 0 0 90,90 Z"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-table',{attrs:{"title":this.table.title,"data":this.table.data,"disclaimer":this.table.disclaimer}}),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video1.frameTitle,"caption":this.video1.caption,"videoSource":this.video1.src}}),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(2)],1)}
var Internships_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("Internships give you practical training, exposure to different business sectors, the opportunity to develop new skills and contacts, and personal and professional growth. You can also explore multiple industries and roles by interning, for instance, in entertainment one summer and at an investment bank the next to learn what type of career suits you best.")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("beic"),"alt":"infographic: 91% have 1+ internship and 34% have 3+ internships"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("At Marshall, our top priority is supporting student success. We employ myriad resources to facilitate your personal growth and career and leadership development. Throughout the year, we host networking opportunities and special recruitment events, connecting students, faculty and alumni with representatives from the world’s most storied companies. At Marshall, you’ll engage with prospective employers through speaker series, corporate conferences, mentoring programs and in-classroom guest lecturers. We also maintain an extensive database of job and internship opportunities.")]),_vm._v(" "),_c('p',[_vm._v("The university’s annual Career Fest centers on success in every step of your career-development journey and features panels and workshops that help you gain an inside perspective on what hiring managers look for in internship and job candidates.")]),_vm._v(" "),_c('p',[_vm._v("The extensive Trojan network is only one resource to help you find your dream job. Here are a few other resources:")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Career Advantage Program")]),_c('br'),_vm._v("\n      Designed to bring together USC Marshall undergraduates and business professionals, many of whom are Marshall alumni, the Career Advantage Program (CAP) builds supportive relationships that maximize students’ potential. Through CAP, alumni mentors offer academic and career guidance, share personal experiences, strengthen your professional network, provide a link to the business world, and help you hone interview and job skills.\n    ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("CAP participants each year:")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("lyf9"),"alt":"Infographic: 350+ Students 125+ Mentors 3 Number of years students can participate.","title":"Infographic: 350+ Students 125+ Mentors 3 Number of years students can participate."}}),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Marshall Career Source")]),_c('br'),_vm._v("The USC Marshall Career Source is a database available to all Marshall and Leventhal undergraduates. The Career Source lists internship and job postings, notes upcoming career development programs and student organization events and provides helpful career guidance for students interested in all aspects of business and accounting.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Corporate Advisory Board")]),_c('br'),_vm._v("The USC Marshall Corporate Advisory Board (CAB) is composed of senior-level executives from major corporations from around the world. Their purpose is to support the research and education mission at Marshall. CAB serves as a crucial link between the school and the international corporate business community and provides input on the strategic direction of the school.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Career Center")]),_c('br'),_vm._v("Marshall is proud to partner with the USC Career Center, which provides lifelong services including résumé-writing workshops, job search strategy sessions, on-campus interviews, recruitment fairs, an alumni database, career counseling and information about specific industry trends. The center also offers access to extraordinary domestic and international internship opportunities.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("blUE"),"alt":"Scatter plot showing post-grad average annual salaries by job function. Investment Banking/Management and Analytics show the highest averages, while Operations/Supply Chain is the lowest.","title":"Infographic for annual salary"}})])}]
var Internships_esExports = { render: Internships_render, staticRenderFns: Internships_staticRenderFns }
/* harmony default export */ var advantages_Internships = (Internships_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/Internships.vue
function Internships_injectStyle (ssrContext) {
  __webpack_require__("859I")
}
var Internships_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Internships___vue_template_functional__ = false
/* styles */
var Internships___vue_styles__ = Internships_injectStyle
/* scopeId */
var Internships___vue_scopeId__ = "data-v-21fc27bc"
/* moduleIdentifier (server only) */
var Internships___vue_module_identifier__ = null
var Internships_Component = Internships_normalizeComponent(
  Internships,
  advantages_Internships,
  Internships___vue_template_functional__,
  Internships___vue_styles__,
  Internships___vue_scopeId__,
  Internships___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_Internships = (Internships_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/ScholarPrograms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ScholarPrograms = ({
  name: 'ScholarshipPrograms',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Scholar Programs',
        loResSrc: './static/blur/Opportunities_ScholarPrograms.jpg',
        hiResSrc: './static/Opportunities_ScholarPrograms.jpg'
      },
      intro: ['USC’s scholar programs—including Discovery, Global and Renaissance Scholars—salute excellence in undergraduate education by recognizing students who have surpassed academic expectations. Interested USC students may apply for the respective scholars’ designations; recognized scholars receive a medallion to wear at graduation, have their designation noted on their final transcript from the University and may be eligible for a $10,000 prize toward graduate study or other approved post-graduate endeavors.']
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Scholar Programs');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3576bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/ScholarPrograms.vue
var ScholarPrograms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_ScholarshipPrograms"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)}
var ScholarPrograms_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Renaissance and Discovery Scholars")]),_vm._v(" "),_c('p',[_vm._v("USC—which offers more than 150 undergraduate majors and 150 minors that encompass the arts and humanities, the social and natural sciences and the professions—also offers two scholarship programs for high-achieving undergraduate students: the USC Renaissance Scholars program and the USC Discovery Scholars program. Undergraduates who pursue a major and minor (or two majors) in widely separated fields of study and maintain a minimum GPA are honored as USC Renaissance Scholars, while students who excel in the classroom and also produce exceptional scholarship or artistic works are encouraged to pursue the Discovery Scholar honor, which is offered within every major concentration at the University.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Global Scholars")]),_vm._v(" "),_c('p',[_vm._v("The Global Scholars program recognizes undergraduates who have excelled in their studies both at home and abroad. Every year, up to 10 Global Scholars receive a $10,000 prize to be applied toward graduate study. Students must have an overall USC GPA of 3.5 or higher to be considered for this distinction and must have participated in an international program administered by USC or an outside institution.")]),_vm._v(" "),_c('p',[_vm._v("Applicants must have spent a minimum of 10 weeks abroad in one or more academic, work-experience or service-learning programs as part of their undergraduate experience. For international students, the overseas experience must be outside their home country, preferably in a different region of the world.")]),_vm._v(" "),_c('p',[_vm._v("Global Scholars are expected to complete a capstone paper, project or research paper in which they reflect on their international experience. This project, for which each USC school has different criteria, is intended to validate the depth and quality of the student’s time abroad.")])])}]
var ScholarPrograms_esExports = { render: ScholarPrograms_render, staticRenderFns: ScholarPrograms_staticRenderFns }
/* harmony default export */ var advantages_ScholarPrograms = (ScholarPrograms_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/ScholarPrograms.vue
function ScholarPrograms_injectStyle (ssrContext) {
  __webpack_require__("ygCg")
}
var ScholarPrograms_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ScholarPrograms___vue_template_functional__ = false
/* styles */
var ScholarPrograms___vue_styles__ = ScholarPrograms_injectStyle
/* scopeId */
var ScholarPrograms___vue_scopeId__ = "data-v-6c3576bf"
/* moduleIdentifier (server only) */
var ScholarPrograms___vue_module_identifier__ = null
var ScholarPrograms_Component = ScholarPrograms_normalizeComponent(
  ScholarPrograms,
  advantages_ScholarPrograms,
  ScholarPrograms___vue_template_functional__,
  ScholarPrograms___vue_styles__,
  ScholarPrograms___vue_scopeId__,
  ScholarPrograms___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_ScholarPrograms = (ScholarPrograms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/StudentOrganizations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var StudentOrganizations = ({
  name: 'StudentOrganizations',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-video': src_components_videoEmbed,
    'usc-list-image': src_components_ListImage,
    'tiny-slider': dist_default.a
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Student Organizations',
        loResSrc: '../../../static/HeroImages/CampusLife-Marshall32.jpg',
        hiResSrc: '../../../static/HeroImages/CampusLife-Marshall32.jpg'
      },
      slideIndex: 1,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Opportunities_Student_Organizations_1.jpg',
        alt: 'Students gathered around a professor in front of a computer',
        id: 0
      }, {
        image: '/static/Opportunities_Student_Organizations_2.jpg',
        alt: 'Student speaking outside to a gathering of other students',
        id: 1
      }, {
        image: '/static/Opportunities_Student_Organizations_3.jpg',
        alt: 'Two USC students sitting at a table',
        id: 2
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Student Organizations');
  },

  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cab4961","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/StudentOrganizations.vue
var StudentOrganizations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Student_Organizations"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("Follow your passions, grow your network and gain invaluable experience by participating in Marshall’s numerous undergraduate student organizations.")])]),_vm._v(" "),_c('div',{staticClass:"body mb gutter-lg"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Industry-specific groups include Accounting Society, Consulting Club, Data Analytics Club, Marshall Entertainment Association, Fashion Industry Association, International Consulting Club, Marshall Real Estate Finance Association, American Marketing Association, Operations Management Association and the Sports Business Association — just to name a few. Affinity groups range from the Black Business Student Association and Korean Business Student Organization to the Latino Business Student Association and Marshall Women’s Leadership Board.")]),_vm._v(" "),_c('p',[_vm._v("The Marshall Business Student Government serves as a liaison between the school’s administration and student body, and advocates for an inclusive and resourceful community. Marshall Student Ambassadors are undergraduate representatives who support prospective and current students.")]),_vm._v(" "),_c('p',[_vm._v("In addition, Marshall students can join any of the more than 1,000 university-wide student organizations to expand your network even further. Getting involved in student groups complements your classroom activities and rounds out your Marshall education.")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('usc-cta',{attrs:{"slot":"cta-bottom","text":"Explore Campus Activities","url":"https://campusactivities.usc.edu/"},slot:"cta-bottom"})],1),_vm._v(" "),_vm._m(2)],1)}
var StudentOrganizations_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',[_vm._v("These student-led groups reflect nearly every academic area within Marshall and often engage with industry experts and alumni. You’ll interact socially and professionally with students and renowned executives as you develop business-critical skills such as leadership, teamwork and project management.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Marshall holds an involvement fair each semester where you can meet representatives from the school’s wide range of student organizations. In the meantime, take a look online at the currently "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.marshall.usc.edu/current-students/leadership-development-and-student-organizations/marshall-recognized-student-organizations"}},[_vm._v("recognized Marshall student organizations")]),_vm._v(". There’s something for everyone — and you also have the option of forming your own group!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Get Involved!")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("ESLV"),"alt":"1k USC student Organizations and 60% USC students who volunteer","title":""}})])}]
var StudentOrganizations_esExports = { render: StudentOrganizations_render, staticRenderFns: StudentOrganizations_staticRenderFns }
/* harmony default export */ var life_at_marshall_StudentOrganizations = (StudentOrganizations_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/StudentOrganizations.vue
function StudentOrganizations_injectStyle (ssrContext) {
  __webpack_require__("tv96")
}
var StudentOrganizations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var StudentOrganizations___vue_template_functional__ = false
/* styles */
var StudentOrganizations___vue_styles__ = StudentOrganizations_injectStyle
/* scopeId */
var StudentOrganizations___vue_scopeId__ = "data-v-7cab4961"
/* moduleIdentifier (server only) */
var StudentOrganizations___vue_module_identifier__ = null
var StudentOrganizations_Component = StudentOrganizations_normalizeComponent(
  StudentOrganizations,
  life_at_marshall_StudentOrganizations,
  StudentOrganizations___vue_template_functional__,
  StudentOrganizations___vue_styles__,
  StudentOrganizations___vue_scopeId__,
  StudentOrganizations___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_StudentOrganizations = (StudentOrganizations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/CommunityInvolvement.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var CommunityInvolvement = ({
  name: 'CommunityInvolvement',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Community Engagement',
        loResSrc: '../../../static/HeroImages/Marshall113.png',
        hiResSrc: '../../../static/HeroImages/Marshall113.png'
      },
      intro: ['More than 60 percent of USC students volunteer as part of the university’s community outreach programs, providing educational, social and wellness services that strengthen surrounding neighborhoods and communities worldwide while offering rewarding personal experiences.'],
      video: {
        caption: 'The Other 152 Hours',
        src: 'https://player.vimeo.com/video/393483866',
        frameTitle: 'The Other 152 Hours'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Community Engagement');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d41841c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/CommunityInvolvement.vue
var CommunityInvolvement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_CommunityInvolvement"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var CommunityInvolvement_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('i',[_vm._v("Marshall is a leader within the overall Trojan cohort, with many student-led programs that give back to the community, such as Los Angeles Community Impact, an undergraduate student-led consulting group that places teams of students in the community to assist local nonprofits and small businesses. ")])]),_vm._v(" "),_c('p',[_vm._v("Undergraduates also have organized Marshall Community Service Day, which connects Marshall students, faculty and staff with volunteer sites around Los Angeles for a day of public service supporting a variety of nonprofit organizations, including Union Rescue Mission, Heal the Bay and area schools.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Joint Educational Project (JEP)")]),_c('br'),_vm._v("Founded in 1972, JEP is one of the oldest and largest service-learning programs in the country, offering the unique opportunity to combine academic coursework with outreach in the neighborhood surrounding the University Park Campus. Each year, approximately 2,000 students receive academic credit for their participation in JEP. In addition, 400 students serve as noncredit volunteers, sharing their time and special talents.")]),_vm._v(" "),_c('div',{staticClass:"youtube-embed"},[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=CVRFZZAHdfk","target":"_blank","rel":"noopener","aria-label":"Watch JEP: 50 Years of Service Learning on YouTube (opens in a new tab)"}},[_c('img',{attrs:{"src":__webpack_require__("e5AR"),"alt":"","role":"presentation"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Volunteer Center")]),_c('br'),_vm._v("The "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://campusactivities.usc.edu/programs/volunteer/","target":"_blank"}},[_vm._v("USC Volunteer Center")]),_vm._v(" is a primarily student-run program within the Division of Student Affairs that offers opportunities for students, alumni, faculty and staff to get involved with the community. Each year, the Volunteer Center identifies and organizes numerous service projects and maintains an extensive database of more than 200 nonprofits and other agencies that offer volunteer opportunities.")]),_vm._v(" "),_c('p',[_vm._v("Programs within the Volunteer Center include Friends & Neighbors Day, SERVE L.A., Trojans Serve and Alternative Breaks.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Alternative Breaks")]),_c('br'),_vm._v("In March 1991, USC students and staff launched Alternative Breaks to engage in service learning and volunteerism in communities outside of Los Angeles. These service-learning trips help participants make tangible connections between what they learn in the classroom and what they will encounter once they have jobs and experiences outside the university. Geared to students’ interests, each project includes an introduction to the social, cultural and historical context of the specific community students will experience throughout the week. Opportunities for discussion and reflection help students gain new perspectives on social problems. Student participants pay a nominal fee to cover transportation, housing and meals for the week.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Friends & Neighbors Service Day")]),_c('br'),_vm._v("The Volunteer Center’s Friends & Neighbors Service Day program is one of the most popular USC volunteer events of the year. The initiative takes place on Saturdays throughout the school year and provides a great opportunity to meet fellow students as well as to get involved in the local community.")])])}]
var CommunityInvolvement_esExports = { render: CommunityInvolvement_render, staticRenderFns: CommunityInvolvement_staticRenderFns }
/* harmony default export */ var life_at_marshall_CommunityInvolvement = (CommunityInvolvement_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/CommunityInvolvement.vue
function CommunityInvolvement_injectStyle (ssrContext) {
  __webpack_require__("OB9g")
}
var CommunityInvolvement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CommunityInvolvement___vue_template_functional__ = false
/* styles */
var CommunityInvolvement___vue_styles__ = CommunityInvolvement_injectStyle
/* scopeId */
var CommunityInvolvement___vue_scopeId__ = "data-v-1d41841c"
/* moduleIdentifier (server only) */
var CommunityInvolvement___vue_module_identifier__ = null
var CommunityInvolvement_Component = CommunityInvolvement_normalizeComponent(
  CommunityInvolvement,
  life_at_marshall_CommunityInvolvement,
  CommunityInvolvement___vue_template_functional__,
  CommunityInvolvement___vue_styles__,
  CommunityInvolvement___vue_scopeId__,
  CommunityInvolvement___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_CommunityInvolvement = (CommunityInvolvement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/RecreationalSports.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var RecreationalSports = ({
  name: 'RecreationalSports',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-twoColumns': src_components_TwoColumns
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Recreational Sports',
        loResSrc: '../../../static/HeroImages/Marshall43.png',
        hiResSrc: '../../../static/HeroImages/Marshall43.png'
      },
      intro: [''],
      video: {
        caption: 'Combining a love of playing sports with a new passion for Sports Management',
        src: 'https://player.vimeo.com/video/249455011?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Sports Management'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Recreational Sports');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb98fcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/RecreationalSports.vue
var RecreationalSports_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_RecreationalSports"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('i',[_vm._v("Trojan athletics extends beyond our award-winning varsity athletes to include all students interested in working out, swimming laps or trying their hand at a new martial art or club sport.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-twoColumns',[_c('h3',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("Club Sports")]),_vm._v(" "),_c('p',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("The USC Club Sports consists of more than 50 student-run organizations that compete in intercollegiate events for various sports and activities. "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://recsports.usc.edu/programs-classes/competitive-sports/club-sports/","target":"_blank"}},[_vm._v("Learn more about current clubs")]),_vm._v(" and how to join. ")]),_vm._v(" "),_c('p',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("Current clubs include:")]),_vm._v(" "),_c('ul',{attrs:{"slot":"left"},slot:"left"},[_c('li',[_vm._v("Archery")]),_vm._v(" "),_c('li',[_vm._v("Badminton")]),_vm._v(" "),_c('li',[_vm._v("Ballroom/Latin Dance")]),_vm._v(" "),_c('li',[_vm._v("Barbell")]),_vm._v(" "),_c('li',[_vm._v("Basketball (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Beach volleyball")]),_vm._v(" "),_c('li',[_vm._v("Brazilian jiu jitsu")]),_vm._v(" "),_c('li',[_vm._v("Chaotic 3")]),_vm._v(" "),_c('li',[_vm._v("Cheer")]),_vm._v(" "),_c('li',[_vm._v("Chess")]),_vm._v(" "),_c('li',[_vm._v("Climbing")]),_vm._v(" "),_c('li',[_vm._v("Crew")]),_vm._v(" "),_c('li',[_vm._v("Cricket")]),_vm._v(" "),_c('li',[_vm._v("Cycling")]),_vm._v(" "),_c('li',[_vm._v("Dragon Boat")]),_vm._v(" "),_c('li',[_vm._v("Equestrian")]),_vm._v(" "),_c('li',[_vm._v("Fencing")]),_vm._v(" "),_c('li',[_vm._v("Field Hockey")]),_vm._v(" "),_c('li',[_vm._v("Figure Skating")]),_vm._v(" "),_c('li',[_vm._v("Futsal")]),_vm._v(" "),_c('li',[_vm._v("Golf")]),_vm._v(" "),_c('li',[_vm._v("Gymnastics")])]),_vm._v(" "),_c('ul',{attrs:{"slot":"right"},slot:"right"},[_c('li',[_vm._v("Ice Hockey")]),_vm._v(" "),_c('li',[_vm._v("Kendo")]),_vm._v(" "),_c('li',[_vm._v("Kung Fu")]),_vm._v(" "),_c('li',[_vm._v("Lacrosse (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Ping Pong")]),_vm._v(" "),_c('li',[_vm._v("Polo")]),_vm._v(" "),_c('li',[_vm._v("Rugby (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Shinkendo")]),_vm._v(" "),_c('li',[_vm._v("Soccer (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Softball")]),_vm._v(" "),_c('li',[_vm._v("Soul Cal Breaking")]),_vm._v(" "),_c('li',[_vm._v("Swim")]),_vm._v(" "),_c('li',[_vm._v("Taekwondo")]),_vm._v(" "),_c('li',[_vm._v("Tennis")]),_vm._v(" "),_c('li',[_vm._v("Track")]),_vm._v(" "),_c('li',[_vm._v("Triathlon")]),_vm._v(" "),_c('li',[_vm._v("Ultimate frisbee (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Underwater Torpedo")]),_vm._v(" "),_c('li',[_vm._v("Volleyball (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Water polo (men’s and women’s)")]),_vm._v(" "),_c('li',[_vm._v("Wrestling")])])]),_vm._v(" "),_c('usc-twoColumns',[_c('h3',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("Intramural Sports")]),_vm._v(" "),_c('p',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("The Intramural Sports program is one of the most popular undergraduate and graduate student activities at USC, with more than 9,600 participants. Intramural sports promote physical fitness and competition, social interaction and student involvement. Sign up as a team or individual. Groups and individuals are encouraged to participate regardless of skill level.")]),_vm._v(" "),_c('p',{attrs:{"slot":"fullWidth"},slot:"fullWidth"},[_vm._v("Sports include:")]),_vm._v(" "),_c('ul',{attrs:{"slot":"left"},slot:"left"},[_c('li',[_vm._v("3x3 Basketball")]),_vm._v(" "),_c('li',[_vm._v("Baseball")]),_vm._v(" "),_c('li',[_vm._v("Dodgeball")]),_vm._v(" "),_c('li',[_vm._v("Golf")]),_vm._v(" "),_c('li',[_vm._v("Pickleball")]),_vm._v(" "),_c('li',[_vm._v("Pac-10 Competitions")]),_vm._v(" "),_c('li',[_vm._v("Soccer")]),_vm._v(" "),_c('li',[_vm._v("Swim Meet")]),_vm._v(" "),_c('li',[_vm._v("Volleyball")])]),_vm._v(" "),_c('ul',{attrs:{"slot":"right"},slot:"right"},[_c('li',[_vm._v("5k Spring Run")]),_vm._v(" "),_c('li',[_vm._v("Basketball")]),_vm._v(" "),_c('li',[_vm._v("Flag Football")]),_vm._v(" "),_c('li',[_vm._v("Inner Tube Water Polo")]),_vm._v(" "),_c('li',[_vm._v("Racquetball")]),_vm._v(" "),_c('li',[_vm._v("Softball")]),_vm._v(" "),_c('li',[_vm._v("Tennis")]),_vm._v(" "),_c('li',[_vm._v("Community")])])]),_vm._v(" "),_vm._m(1)],1)}
var RecreationalSports_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_vm._v("Multiple fitness centers include the Lyon Recreation Center and adjacent Uytengsu Aquatics Center as well as the USC Village Fitness Center. Other recreational sports facilities include two outdoor turf fields, an indoor swimming pool, outdoor basketball court, and tennis and racquetball courts. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('strong',[_vm._v("Community Outreach")]),_c('br'),_vm._v("USC Recreational Sports is affiliated with several community outreach programs, all of which provide sports and educational opportunities for youngsters in our neighborhood. These include the:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Federally funded National Youth Sports Program, which provides summer instruction in sports for youngsters 10 to 16 years old")]),_vm._v(" "),_c('li',[_vm._v("Trojan Kids Camp, which operates in conjunction with the National Youth Sports Program during the summer to provide additional supervision and sports activities for children 10 to 16 years old")]),_vm._v(" "),_c('li',[_vm._v("After-School Sports Connection, which offers both after-school sports instruction to students in the third through fifth grades and summer swim lessons through a partnership with Kids in Sports of Los Angeles")])])])}]
var RecreationalSports_esExports = { render: RecreationalSports_render, staticRenderFns: RecreationalSports_staticRenderFns }
/* harmony default export */ var life_at_marshall_RecreationalSports = (RecreationalSports_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/RecreationalSports.vue
function RecreationalSports_injectStyle (ssrContext) {
  __webpack_require__("CWaY")
}
var RecreationalSports_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RecreationalSports___vue_template_functional__ = false
/* styles */
var RecreationalSports___vue_styles__ = RecreationalSports_injectStyle
/* scopeId */
var RecreationalSports___vue_scopeId__ = "data-v-4bb98fcc"
/* moduleIdentifier (server only) */
var RecreationalSports___vue_module_identifier__ = null
var RecreationalSports_Component = RecreationalSports_normalizeComponent(
  RecreationalSports,
  life_at_marshall_RecreationalSports,
  RecreationalSports___vue_template_functional__,
  RecreationalSports___vue_styles__,
  RecreationalSports___vue_scopeId__,
  RecreationalSports___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_RecreationalSports = (RecreationalSports_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/GlobalOpportunities.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var GlobalOpportunities = ({
  name: 'GlobalOpportunities',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Global Opportunities',
        loResSrc: '../../../static/HeroImages/Marshall101.png',
        hiResSrc: '../../../static/HeroImages/Marshall101.png'
      },
      intro: ['From day one, Marshall gives undergraduates the opportunity to gain significant real-world experience, marketable skills, unforgettable memories and an international perspective coveted by employers in every business sector. Gain a global perspective through one of our signature programs that take you to major economic hubs for unique cultural experiences and the opportunity to meet with employers from a wide range of industries and career paths.'],
      video: {
        caption: 'Learn About LINC',
        src: 'https://player.vimeo.com/video/644520557',
        frameTitle: 'Video: Learn About LINC'
      },
      video2: {
        caption: 'Undergrad International Programs',
        src: 'https://player.vimeo.com/video/655441839',
        frameTitle: 'Video: Undergrad International Programs'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Global Opportunities');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7f863a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/GlobalOpportunities.vue
var GlobalOpportunities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_GlobalOpportunities"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video2.frameTitle,"caption":this.video2.caption,"videoSource":this.video2.src}})],1)}
var GlobalOpportunities_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('i',[_vm._v("Marshall internships are available in every corner of the world, giving you invaluable business expertise as well as cultural understanding that will take you far. Our programs span more than 30 countries.")])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("J1z8"),"title":"100+ Marshall International Summer Internships and 90% Freshmen participation in Marshall international programs and global internships","alt":"100+ Marshall International Summer Internships and 90% Freshmen participation in Marshall international programs and global internships"}}),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Global Leadership Program")]),_c('br'),_vm._v("The Global Leadership Program (GLP) is a groundbreaking program open by invitation only to the most academically talented students in each incoming freshmen class. GLP consists of a fall and spring course, BUAD 101 Freshman Leadership Seminar, including regular meetings for social activities and networking. The experience is capped off with a visit to places such as Shanghai or Beijing during spring break. During the trip, students meet with executives of some of the top companies in major cities as well as local and national government officials. GLP alumni have the opportunity to plan events and mentor younger students, as well as continue to travel abroad to learn about the global impact of business.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Learning about International Commerce ")]),_c('br'),_vm._v("Marshall’s Learning about International Commerce (LINC) is the only U.S. program that focuses on exposing first-year business students to business practices outside the U.S. During the spring semester, students admitted to the program enroll in a two-unit course and spend nine days overseas. During the course, you learn about the culture, history and politics, as well as economic and business conditions, in the country you will visit. You also have the chance to meet with your counterparts from a local university and experience prominent cultural venues in their respective countries. Through LINC, students recently have traveled to such varied locations as Sydney, Istanbul and Taiwan.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("International Experiential Corporate Environment Learning Program ")]),_c('br'),_vm._v("Marshall created the International Experiential Corporate Environment Learning Program (ExCEL) to enable undergraduate students to observe global business practices, enhance their knowledge and understanding of international business, and develop an appreciation of cultural differences. ExCEL centers around a nearly 10-day trip to meet with foreign business leaders and governmental officials.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("International Summer Internships")]),_c('br'),_c('i',[_vm._v("Winslow-Maxwell Summer Internship Program")]),_c('br'),_vm._v("This program partners with hundreds of companies in locations that have included Berlin, Hong Kong, London, Madrid, Prague, Rome, Singapore, Sydney and Tokyo. Student participants choose the type of work that interests them — such as general business, marketing in entertainment, human resources, working in a startup — and then are paired with the opportunity that best fits student interests and professional goals and company needs.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Marshall International Summer Internship Program")]),_c('br'),_vm._v("The Marshall International Summer Internship Program (MISIP) provides selected sophomores, juniors and seniors with an in-depth international experience with major firms and foundations that are led by prominent Marshall alumni and friends in places such as Jakarta and Bangkok. Students who are selected for MISIP receive a stipend toward living expenses and will spend June and July gaining invaluable work and cultural experience outside of the U.S. MISIP interns are not required to enroll in a USC class during the program, nor does USC charge fees for participation.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Global Summer Internship Program")]),_c('br'),_vm._v("This program takes students to places such as Berlin, Dublin, Hong Kong, London, Madrid, Milan, Prague or Singapore for eight to 10 weeks over the summer.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("USC Global Fellows Internship Program")]),_c('br'),_vm._v("Through the Global Fellows Internship Program, USC undergraduates earn stipends to live and intern in Asia for nearly 10 weeks over the summer. Internships are typically in commercial, political and cultural centers such as Hong Kong, Shanghai and Taipei.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Global Brigades Summer Internship Program")]),_c('br'),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"http://www.globalbrigades.org/","target":"_blank"}},[_vm._v("Global Brigades Summer Internship Program")]),_vm._v(" strives to improve equality of life by igniting the largest student-led social responsibility movement on the planet. This is done by empowering volunteers to facilitate sustainable solutions in under-resourced communities while fostering local cultures. The Global Brigades Internship is a competitive four-week program that takes students to such locations as Honduras, Panama or Ghana in July. The internship offers a unique opportunity to work alongside program leads to perpetuate community development projects between brigades and conduct research initiatives to improve programming.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("International Exchange Programs")]),_c('br'),_vm._v("International Exchange Programs enable you to immerse yourself in a different culture, develop a global perspective, form friendships with students from around the world and experience stimulating new surroundings. All instruction is in English, and participating students receive full credit toward the business degree. Participants may choose to spend one semester at one of more than 30 participating exchange institutions around the world.")])])}]
var GlobalOpportunities_esExports = { render: GlobalOpportunities_render, staticRenderFns: GlobalOpportunities_staticRenderFns }
/* harmony default export */ var advantages_GlobalOpportunities = (GlobalOpportunities_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/GlobalOpportunities.vue
function GlobalOpportunities_injectStyle (ssrContext) {
  __webpack_require__("R/r1")
}
var GlobalOpportunities_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GlobalOpportunities___vue_template_functional__ = false
/* styles */
var GlobalOpportunities___vue_styles__ = GlobalOpportunities_injectStyle
/* scopeId */
var GlobalOpportunities___vue_scopeId__ = "data-v-6a7f863a"
/* moduleIdentifier (server only) */
var GlobalOpportunities___vue_module_identifier__ = null
var GlobalOpportunities_Component = GlobalOpportunities_normalizeComponent(
  GlobalOpportunities,
  advantages_GlobalOpportunities,
  GlobalOpportunities___vue_template_functional__,
  GlobalOpportunities___vue_styles__,
  GlobalOpportunities___vue_scopeId__,
  GlobalOpportunities___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_GlobalOpportunities = (GlobalOpportunities_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/Thematic.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Thematic = ({
  name: 'Thematic',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Distinctive Honors Opportunities',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall20.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall20.jpg'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Thematic');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4310ca0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/Thematic.vue
var Thematic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_Thermatics"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}},[_c('i',[_vm._v("USC offers students of all majors the opportunity to earn special honors and designations while pursuing their passions.")])]),_vm._v(" "),_vm._m(0)],1)}
var Thematic_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("USC offers students of all majors the opportunity to earn special honors and designations while pursuing their passions.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Thematic Option Program")]),_c('br'),_vm._v("Thematic Option is the university’s general education honors program, open to up to 200 freshmen from all USC majors. This interdisciplinary core curriculum offers small classes with some of the university’s best undergraduate teachers and a handpicked group of writing instructors. The program has been cited by numerous college guides as one of the nation’s best undergraduate honors programs, and student evaluations echo that assessment. Admission is very selective and based on academic achievement.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("USC’s undergraduate scholar programs salute excellence by recognizing students who surpass academic expectations. Interested students may apply for the respective scholars’ designations; recognized scholars receive a medallion to wear at graduation, have their designation noted on their final transcript and may be eligible for a $10,000 prize toward graduate study or other approved post-graduate endeavors. Seniors may earn more than one distinction but must meet the criteria for each application.")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Renaissance and Discovery Scholars")]),_c('br'),_vm._v("Undergraduates who pursue a major and minor (or two majors) in widely separated fields of study and maintain a minimum GPA may be honored as USC Renaissance Scholars, while students who excel in the classroom and also produce exceptional scholarship or artistic works are encouraged to pursue the Discovery Scholar honor, which is offered within every major concentration at the university.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Global Scholars")]),_c('br'),_vm._v("The Global Scholars program recognizes undergraduates who have exceled in their studies both at home and abroad. Every year, up to 10 Global Scholars receive a $10,000 prize to be applied toward graduate study. Students must have an overall USC GPA of 3.5 or higher to be considered for this distinction and must have participated in an international program administered by USC or an outside institution.")]),_vm._v(" "),_c('p',[_vm._v("Applicants must have spent a minimum of 10 weeks abroad in one or more academic, work-experience or service-learning programs as part of their undergraduate experience. For international students, the overseas experience must be outside their home country, preferably in a different region of the world.")]),_vm._v(" "),_c('p',[_vm._v("Global Scholars are expected to complete a capstone paper, project or research paper in which they reflect on their international experience. This project, for which each USC school has different criteria, is intended to validate the depth and quality of the student’s time abroad.")])])}]
var Thematic_esExports = { render: Thematic_render, staticRenderFns: Thematic_staticRenderFns }
/* harmony default export */ var advantages_Thematic = (Thematic_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/Thematic.vue
function Thematic_injectStyle (ssrContext) {
  __webpack_require__("BUaY")
}
var Thematic_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Thematic___vue_template_functional__ = false
/* styles */
var Thematic___vue_styles__ = Thematic_injectStyle
/* scopeId */
var Thematic___vue_scopeId__ = "data-v-a4310ca0"
/* moduleIdentifier (server only) */
var Thematic___vue_module_identifier__ = null
var Thematic_Component = Thematic_normalizeComponent(
  Thematic,
  advantages_Thematic,
  Thematic___vue_template_functional__,
  Thematic___vue_styles__,
  Thematic___vue_scopeId__,
  Thematic___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_Thematic = (Thematic_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Statement.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Statement = ({
  name: 'Statement',
  props: ['bg'],
  data: function data() {
    return {
      bgc: {
        backgroundColor: this.bg
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7768b2ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statement.vue
var Statement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statement mb",style:(_vm.bgc)},[_c('div',{staticClass:"statement__text-container gutter-lg"},[_vm._t("title"),_vm._v(" "),_vm._t("paragraph")],2)])}
var Statement_staticRenderFns = []
var Statement_esExports = { render: Statement_render, staticRenderFns: Statement_staticRenderFns }
/* harmony default export */ var components_Statement = (Statement_esExports);
// CONCATENATED MODULE: ./src/components/Statement.vue
function Statement_injectStyle (ssrContext) {
  __webpack_require__("bU5Q")
}
var Statement_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Statement___vue_template_functional__ = false
/* styles */
var Statement___vue_styles__ = Statement_injectStyle
/* scopeId */
var Statement___vue_scopeId__ = "data-v-7768b2ac"
/* moduleIdentifier (server only) */
var Statement___vue_module_identifier__ = null
var Statement_Component = Statement_normalizeComponent(
  Statement,
  components_Statement,
  Statement___vue_template_functional__,
  Statement___vue_styles__,
  Statement___vue_scopeId__,
  Statement___vue_module_identifier__
)

/* harmony default export */ var src_components_Statement = (Statement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/WhyLA.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var WhyLA = ({
  name: 'WhyLA',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-statement': src_components_Statement,
    'usc-dataviz': src_components_DataViz
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'L.A. Advantages',
        loResSrc: '../../../static/HeroImages/Advantages3.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages3.jpg'
      },
      intro: ['During our first century, Marshall and our graduates helped establish Los Angeles’ position as the world’s entertainment capitol, a major financial center and an innovator in industries ranging from aerospace and biotechnology to transportation and technology. Our alumni are leading entrepreneurs, executives and pacesetters in Southern California and in every corner of the planet. With more than 91,000 Marshall graduates, that global influence is vast! But it all started here in Los Angeles.'],
      dataViz: [{
        color: '#ffcc00',
        labelBold: '48%',
        labelSmall: 'Hispanic or Latino'
      }, {
        color: '#990000',
        labelBold: '29%',
        labelSmall: 'White, Non-Hispanic'
      }, {
        color: '#cbcbcb',
        labelBold: '12%',
        labelSmall: 'Asian / Pacific Islander'
      }, {
        color: '#464646',
        labelBold: '9%',
        labelSmall: 'African-American'
      }, {
        color: '#323233',
        labelBold: '2%',
        labelSmall: 'Indigenous / Others'
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Why Los Angeles is the Place to Be');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73159344","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/WhyLA.vue
var WhyLA_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_WhyLA"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-dataviz',{attrs:{"data":_vm.dataViz}},[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Los Angeles' Cultural Tapestry")]),_vm._v(" "),_c('svg',{staticClass:"scaling-svg",attrs:{"slot":"svg","xmlns":"http://www.w3.org/2000/svg","width":"322","height":"322","viewBox":"0 0 322 322"},slot:"svg"},[_c('path',{attrs:{"fill":"#323233","d":"M161 160.99L130.471 3.939C140.88 1.916 150.396 1 161 1v159.99z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#777","d":"M161 160.99L58.154 38.431C79.815 20.256 102.713 9.335 130.471 3.94L161 160.99z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#CBCBCB","d":"M161 160.99H1c0-49.482 19.246-90.753 57.154-122.559L161 160.99z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#96040C","d":"M161 160.99l22.268 158.433C95.762 331.72 14.855 270.757 2.557 183.256 1.573 176.256 1 168.059 1 160.99h160z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#FDCA2F","d":"M161 160.99V1c88.366 0 160 71.63 160 159.99 0 81.291-57.227 147.119-137.732 158.433L161 160.99z"}})])])],1)}
var WhyLA_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('i',[_vm._v("In L.A., fresh ideas routinely turn into transformative business ventures, from large commercial enterprises to startups, and in every field from biotech to new media. Whatever your interests, you’ll find inspiration in this dynamic city.")])]),_vm._v(" "),_c('p',[_vm._v("One of the most economically powerful cities in the world, Los Angeles County is home to 22 Fortune 500 companies, including Walt Disney and Amgen. California has 55 Fortune 500 companies. At Marshall, you’ll have the opportunity to meet with top executives from a host of business sectors — as guest speakers, as mentors, at career fairs and as part of your internships and volunteer work.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Diversity")])]),_vm._v(" "),_c('p',[_vm._v("A vibrant melting pot, Los Angeles County is also one of the most diverse metropolitan areas in the country. It also has among the largest number of foreign-born residents in the U.S. USC reflects the diversity of the greater Los Angeles area and has one of the largest international student bodies of any U.S. university. USC offers you the opportunity to learn and grow in a city that best resembles the world where you will eventually thrive as professionals.")])])}]
var WhyLA_esExports = { render: WhyLA_render, staticRenderFns: WhyLA_staticRenderFns }
/* harmony default export */ var life_at_marshall_WhyLA = (WhyLA_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/WhyLA.vue
function WhyLA_injectStyle (ssrContext) {
  __webpack_require__("UfTb")
}
var WhyLA_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WhyLA___vue_template_functional__ = false
/* styles */
var WhyLA___vue_styles__ = WhyLA_injectStyle
/* scopeId */
var WhyLA___vue_scopeId__ = "data-v-73159344"
/* moduleIdentifier (server only) */
var WhyLA___vue_module_identifier__ = null
var WhyLA_Component = WhyLA_normalizeComponent(
  WhyLA,
  life_at_marshall_WhyLA,
  WhyLA___vue_template_functional__,
  WhyLA___vue_styles__,
  WhyLA___vue_scopeId__,
  WhyLA___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_WhyLA = (WhyLA_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataVizCards.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DataVizCards = ({
  name: 'DataVizCard',
  props: ['data'],
  data: function data() {
    return {};
  },

  computed: {
    hasSVG: function hasSVG() {
      return this.$slots.svg;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e7d61fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataVizCards.vue
var DataVizCards_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-datacard gutter-lg mb body"},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"usc-datacard__cards"},_vm._l((_vm.data),function(item,index){return _c('div',{staticClass:"usc-datacard__card"},[_c('div',{staticClass:"usc-datacard__col usc-datacard__col--left"},[_c('div',{staticClass:"usc-datacard__number"},[_vm._v("\n          "+_vm._s(item.number)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"usc-datacard__subtext"},[_vm._v("\n          "+_vm._s(item.subtext)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"usc-datacard__col"},[_c('img',{attrs:{"src":item.img,"alt":""}})])])}))],2)}
var DataVizCards_staticRenderFns = []
var DataVizCards_esExports = { render: DataVizCards_render, staticRenderFns: DataVizCards_staticRenderFns }
/* harmony default export */ var components_DataVizCards = (DataVizCards_esExports);
// CONCATENATED MODULE: ./src/components/DataVizCards.vue
function DataVizCards_injectStyle (ssrContext) {
  __webpack_require__("4JDM")
}
var DataVizCards_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataVizCards___vue_template_functional__ = false
/* styles */
var DataVizCards___vue_styles__ = DataVizCards_injectStyle
/* scopeId */
var DataVizCards___vue_scopeId__ = "data-v-9e7d61fe"
/* moduleIdentifier (server only) */
var DataVizCards___vue_module_identifier__ = null
var DataVizCards_Component = DataVizCards_normalizeComponent(
  DataVizCards,
  components_DataVizCards,
  DataVizCards___vue_template_functional__,
  DataVizCards___vue_styles__,
  DataVizCards___vue_scopeId__,
  DataVizCards___vue_module_identifier__
)

/* harmony default export */ var src_components_DataVizCards = (DataVizCards_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/EnjoyingLA.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var EnjoyingLA = ({
  name: 'EnjoyingLA',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-listImage': src_components_ListImage,
    'usc-statement': src_components_Statement,
    'usc-datacard': src_components_DataVizCards,
    'tiny-slider': dist_default.a
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Enjoying Los Angeles',
        loResSrc: '../../../static/HeroImages/Marshall129.png',
        hiResSrc: '../../../static/HeroImages/Marshall129.png'
      },
      slideIndex: 1,
      vueTinySlider: dist_default.a,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Opportunities_EnjoyingLA_1.jpg',
        alt: 'Lucas Museum of Narrative Art',
        id: 0
      }, {
        image: '/static/Opportunities_EnjoyingLA_2.jpg',
        alt: 'Lucas Museum of Narrative Art',
        id: 1
      }],
      dataVizCards: [{
        number: '577',
        subtext: 'Heritage & Historical Sites',
        img: './static/enjoyLA-heritage.png'
      }, {
        number: '510',
        subtext: 'Live Music Venues',
        img: './static/enjoyLA-livemusic.png'
      }, {
        number: '474',
        subtext: 'Book Shops',
        img: './static/enjoyLA-bookshops.png'
      }, {
        number: '434',
        subtext: 'Art Galleries',
        img: './static/enjoyLA-artgalleries.png'
      }, {
        number: '240',
        subtext: 'Public Libraries',
        img: './static/enjoyLA-publiclibraries.png'
      }, {
        number: '231',
        subtext: 'Museums',
        img: './static/enjoyLA-museums.png'
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Enjoying Los Angeles');
  },

  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b297cac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/EnjoyingLA.vue
var EnjoyingLA_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Opportunities_EnjoyingLa"}},[_c('usc-hero',{staticClass:"mb",attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("With Los Angeles’ fame as the world’s entertainment capital, it should come as no surprise that Southern California has more museums, theaters and music venues than any other U.S. city.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-datacard',{attrs:{"data":this.dataVizCards}},[_c('h3',{attrs:{"slot":"title"},slot:"title"})]),_vm._v(" "),_c('usc-statement',{attrs:{"bg":this.page.color}},[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_vm._v("292 ")]),_vm._v(" "),_c('p',{attrs:{"slot":"paragraph"},slot:"paragraph"},[_vm._v("Enjoy 292 days of sunshine a year in Los Angeles, with 15 beaches, four mountain ranges, and plentiful parks and trails to explore.")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Attractions and Landmarks")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Disneyland")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Griffith Observatory")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Hollywood Walk of Fame")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Knott’s Berry Farm")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("L.A. Live")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Los Angeles Zoo")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Paramount Pictures Studio Tour")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Santa Monica Pier")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Six Flags, Magic Mountain")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Sony Pictures Studio Tour")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Universal Studios Hollywood")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Venice Beach boardwalk")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Wizarding World of Harry Potter at Universal Studios")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Walt Disney Studio Tour")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Warner Bros. Studio Tour")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("rHc2"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Museums")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Academy Museum of Motion Pictures")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Armand Hammer Museum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Autry Museum of the American West")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Broad")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Geffen Contemporary at MOCA")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Getty Villa")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("J. Paul Getty Museum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("GRAMMY Museum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Huntington Library, Art Collections and Botanical Gardens")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("La Brea Tar Pits and Museum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Los Angeles County Museum of Art")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Museum of Contemporary Art (MOCA)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Museum of Tolerance")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Natural History Museum of Los Angeles")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Norton Simon Museum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Paley Center for Media")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Petersen Automotive Museum")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("gPoh"),"alt":""},slot:"img"})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"gutter-md"},[_c('div',{staticClass:"usc-carousel__header"},[_c('div',{staticClass:"usc-carousel__title"},[_vm._v("Lucas Museum Concept Design")]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__nav"},[_c('div',{staticClass:"usc-carousel__controls",attrs:{"id":"customize-controls"}},[_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Previous Image","disabled":_vm.prevDisabled,"type":"button"},on:{"click":_vm.prevSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"}})])]),_vm._v(" "),_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Next Image","disabled":_vm.nextDisabled,"type":"button"},on:{"click":_vm.nextSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__counter"},[_vm._v("\n          "+_vm._s(this.slideIndex)+" / "+_vm._s(this.totalSlides)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb"},[_c('tiny-slider',{staticClass:"usc-carousel",attrs:{"mouse-drag":false,"loop":false,"items":"1","responsive":true,"controlsContainer":"#customize-controls"}},_vm._l((this.slides),function(slide,index){return _c('div',{staticClass:"usc-carousel__slide"},[_c('div',{staticClass:"usc-carousel__outer"},[_c('img',{staticClass:"usc-carousel__inner",attrs:{"src":slide.image,"alt":slide.alt || ''}})])])}))],1),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Cinemas")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Alamo Drafthouse Cinema (Downtown L.A.)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("AMC Century City 15")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("AMC The Grove 14")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("AMC Santa Monica")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("ArcLight Hollywood")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Cinemark Playa Vista")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Egyptian Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("El Capitan Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("IMAX at California Science Center")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Landmark Nuart Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Regal Cinemas at L.A. Live")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Rooftop Cinema Club (Downtown L.A.)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("TLC Chinese Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Universal Cinema AMC at CityWalk Hollywood")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("Afi4"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Concert Venues")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Avalon Hollywood")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Conga Room at L.A. Live")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Crypto.com Arena")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Dolby Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("El Rey Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Fonda Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Greek Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Kia Forum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Peacock Theater at L.A. Live")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Novo at L.A. Live")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Orpheum Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Roxy Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("SoFi Stadium")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Wiltern Theatre")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("k4aF"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Shopping")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Melrose Avenue: A popular place to shop and people watch, Melrose has a wide range of shops, cafés and restaurants.")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Third Street Promenade: This pedestrian-only street in Santa Monica features clothing boutiques, bookstores, movie theaters and restaurants.")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Rodeo Drive: Ground zero for designer boutiques, in famed Beverly Hills")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Malls: Among the most popular malls are Century City Shopping Center, Santa Monica Place, the Grove at Farmers Market and Universal CityWalk.")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("fDuq"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Sports")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Angel Stadium (Los Angeles Angels)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("BMO Stadium")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Crypto.com Center (Los Angeles Lakers, Clippers and Kings)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Dodger Stadium (Los Angeles Dodgers)")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Galen Center")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Kia Forum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("L.A. Memorial Coliseum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("SoFi Stadium (L.A. Rams)")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("Vm2W"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Symphony/Opera")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("LA Opera")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Music Center")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Walt Disney Concert Hall")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("2JNa"),"alt":""},slot:"img"})]),_vm._v(" "),_c('usc-listImage',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Theaters")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Actors Forum Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Actors' Gang")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Ahmanson Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Alex Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("The Broad Stage")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Dolby Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Geffen Playhouse")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Hudson Theatres")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Kirk Douglas Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Latino Theatre Co. at Los Angeles Theatre Center")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Mark Taper Forum")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Odyssey Theatre Ensemble")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Pantages Theatre")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Pasadena Playhouse")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Shakespeare Center of Los Angeles")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Wallis Annenberg Center for the Performing Arts")]),_vm._v(" "),_c('li',{attrs:{"slot":"item"},slot:"item"},[_vm._v("Will Geer Theatricum Botanicum")])])],1)}
var EnjoyingLA_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('i',[_vm._v("When you need a break from studying, you’ll enjoy countless ways to unwind and expand your cultural horizons. Whatever your interests, you’ll find it in Los Angeles.")])]),_vm._v(" "),_c('p',[_vm._v("In Expo Park alone, right across the street from Marshall, explore the California Science Center (and the Space Shuttle Endeavor), the California African American Museum, the Natural History Museum of Los Angeles, Los Angeles Memorial Coliseum, BMO Stadium (for major league soccer) and Expo Park, with its beautiful, seven-acre rose garden. In Expo Park, you can also grab a Metro train to Santa Monica for shopping, a beach day and/or a visit to the iconic Santa Monica Pier.")]),_vm._v(" "),_c('p',[_vm._v("As one of the world’s most diverse cities, Los Angeles is a haven for foodies and gives you plentiful opportunities to celebrate different cultures. Visit Chinatown, Koreatown, Little Tokyo, Little Armenia, Thai Town, Little Ethiopia, Historic Filipinotown, Olvera Street — for authentic Mexican souvenirs and food — or numerous other enclaves. ")]),_vm._v(" "),_c('p',[_vm._v("The "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://ticketoffice.usc.edu/","target":"_blank"}},[_vm._v("USC Ticket Office")]),_vm._v(" sells discounted movie, theme park and other tickets to students. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('h2',[_vm._v("Here are just some of your leisure options in Los Angeles:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("The Lucas Museum of Narrative Art")]),_c('br'),_vm._v("The pioneering Lucas Museum of Narrative Art will open in 2025 in Exposition Park, immediately south of the University Park Campus. Founded on the belief that visual storytelling can connect us and help shape a more just society, this education-focused museum will house the billion-dollar personal art collection of Founder and Chairman George Lucas, a USC alumnus. With a growing collection that encompasses artworks from across cultures, places, times and media — including paintings, sculptures, murals, photography, comic art, book and magazine illustrations and the arts of filmmaking — the Lucas Museum will explore narrative art’s potential to prompt questions, invite opinions, inspire community and move people to think about the impact of images on our world. An 11-acre campus with extensive new green space designed by Studio-MLA will embrace the museum’s 300,000-square-foot building, which will feature expansive galleries, two state-of-the-art theaters, and dedicated spaces for learning and engagement, dining, retail and events. The museum is being developed as a civic gift from Lucas and his wife, Mellody Hobson.")])])}]
var EnjoyingLA_esExports = { render: EnjoyingLA_render, staticRenderFns: EnjoyingLA_staticRenderFns }
/* harmony default export */ var advantages_EnjoyingLA = (EnjoyingLA_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/EnjoyingLA.vue
function EnjoyingLA_injectStyle (ssrContext) {
  __webpack_require__("UtOc")
}
var EnjoyingLA_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EnjoyingLA___vue_template_functional__ = false
/* styles */
var EnjoyingLA___vue_styles__ = EnjoyingLA_injectStyle
/* scopeId */
var EnjoyingLA___vue_scopeId__ = "data-v-0b297cac"
/* moduleIdentifier (server only) */
var EnjoyingLA___vue_module_identifier__ = null
var EnjoyingLA_Component = EnjoyingLA_normalizeComponent(
  EnjoyingLA,
  advantages_EnjoyingLA,
  EnjoyingLA___vue_template_functional__,
  EnjoyingLA___vue_styles__,
  EnjoyingLA___vue_scopeId__,
  EnjoyingLA___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_EnjoyingLA = (EnjoyingLA_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/advantages/VisitingSpeakers.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var VisitingSpeakers = ({
  name: 'VisitingSpeakers',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-list-image': src_components_ListImage,
    'usc-table': src_components_Table,
    'usc-videoEmbed': src_components_videoEmbed
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Visiting Speakers',
        loResSrc: '../../../static/HeroImages/Advantages2.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages2.jpg'
      },
      video: {
        caption: 'Dean’s Dialogue: A Conversation with Marc Benioff of Salesforce',
        src: 'https://player.vimeo.com/video/640024726',
        frameTitle: 'Dean’s Dialogue: A Conversation with Marc Benioff of Salesforce'
      },
      speakers: [{ 'left': 'Jessica Alba', 'right': 'Actor and founder/CEO, The Honest Company' }, { 'left': 'Dan Bane', 'right': 'Chair/CEO, Trader Joe’s' }, { 'left': 'Brandon Beck', 'right': 'Cofounder/co-chair, Riot Games' }, { 'left': 'Bedi A. Singh', 'right': 'Former chief financial officer, News Corp' }, { 'left': 'Ajay Bedi', 'right': 'Chief financial officer, News Corp' }, { 'left': 'Marc Benioff', 'right': 'Chair/cofounder/co-CEO, Salesforce; USC Trustee' }, { 'left': 'Bill Clinton', 'right': 'Former U.S. President' }, { 'left': 'Christopher Cox', 'right': 'Former chair, Securities & Exchange Commission' }, { 'left': 'Robert A. Eckert', 'right': 'Board chair, Levi Strauss & Co.; former chair/CEO, Mattel' }, { 'left': 'Mark Emmert', 'right': 'President, NCAA' }, { 'left': 'Vicente Fox', 'right': 'Former president of Mexico; founder, Centro Fox' }, { 'left': 'Rachel Glaser', 'right': 'Chief financial officer, Etsy' }, { 'left': 'Robert Iger', 'right': 'CEO, The Walt Disney Company' }, { 'left': 'Jeff Immelt', 'right': 'Former chair/CEO, General Electric' }, { 'left': 'Scott Keller', 'right': 'Senior Partner, McKinsey & Company ' }, { 'left': 'Arthur Laffer', 'right': 'Economist and Presidential Medal of Freedom awardee' }, { 'left': 'Todd Maclin', 'right': 'Former CEO, JP Morgan Chase Commercial Banking' }, { 'left': 'Ron Meyer', 'right': 'Former NBCUniversal vice chair; cofounder, CAA' }, { 'left': 'Jenny Ming', 'right': 'CEO, Charlotte Russe; former president, Old Navy' }, { 'left': 'Craig Pollard and Will Ferrell', 'right': 'Founder, Cancer for College; actor and comedian' }, { 'left': 'Edward C. Prescott', 'right': 'Nobel Prize winner in Economics' }, { 'left': 'Natalie Portman', 'right': 'Actor and social activist' }, { 'left': 'Ronald Sugar', 'right': 'Independent chair, Uber; former chair/CEO, Northrop Grumman' }, { 'left': 'Ted Turner', 'right': 'Founder, CNN' }, { 'left': 'Peter Ueberroth', 'right': 'Former Chair, U.S. Olympic Committee; former Major League Baseball commissioner; USC Trustee ' }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('Opportunities', 'Visiting Speakers');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103fba86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/advantages/VisitingSpeakers.vue
var VisitingSpeakers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Visiting_Speakers"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("Even a cursory glance at the names of speakers hosted by USC reveals a rich tradition of leadership and excellence. This list is just a sample of the major figures from commerce, politics, media and other key fields — including a Nobel laureate — who have shared their hard-won wisdom with Marshall students.")])]),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_c('usc-table',{attrs:{"data":_vm.speakers}}),_vm._v(" "),_c('usc-list-image',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Craig Pollard & Will Ferrell")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("70cR"),"alt":"Craig Pollard and Will Ferrell"},slot:"img"})]),_vm._v(" "),_c('usc-list-image',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Robert A. Iger")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("CEO, The Walt Disney Company")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("b9Z5"),"alt":"Robert A. Iger"},slot:"img"})]),_vm._v(" "),_c('usc-list-image',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Jessica Alba")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("CEO and Founder, The Honest Company")]),_vm._v(" "),_c('img',{attrs:{"slot":"img","src":__webpack_require__("pWHp"),"alt":"Jessica Alba"},slot:"img"})])],1)}
var VisitingSpeakers_staticRenderFns = []
var VisitingSpeakers_esExports = { render: VisitingSpeakers_render, staticRenderFns: VisitingSpeakers_staticRenderFns }
/* harmony default export */ var advantages_VisitingSpeakers = (VisitingSpeakers_esExports);
// CONCATENATED MODULE: ./src/pages/advantages/VisitingSpeakers.vue
function VisitingSpeakers_injectStyle (ssrContext) {
  __webpack_require__("5lM2")
}
var VisitingSpeakers_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VisitingSpeakers___vue_template_functional__ = false
/* styles */
var VisitingSpeakers___vue_styles__ = VisitingSpeakers_injectStyle
/* scopeId */
var VisitingSpeakers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VisitingSpeakers___vue_module_identifier__ = null
var VisitingSpeakers_Component = VisitingSpeakers_normalizeComponent(
  VisitingSpeakers,
  advantages_VisitingSpeakers,
  VisitingSpeakers___vue_template_functional__,
  VisitingSpeakers___vue_styles__,
  VisitingSpeakers___vue_scopeId__,
  VisitingSpeakers___vue_module_identifier__
)

/* harmony default export */ var pages_advantages_VisitingSpeakers = (VisitingSpeakers_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/Facilities.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Facilities = ({
  name: 'Facilities',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-cta': src_components_Cta,
    'tiny-slider': dist_default.a
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Facilities',
        loResSrc: '../../../static/HeroImages/Marshall35.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall35.jpg'
      },
      video: {
        caption: 'Now open: Fertitta Hall, an undergraduate business haven',
        src: 'https://player.vimeo.com/video/182418862',
        frameTitle: 'Video: Fertitta Hall'
      },
      video2: {
        caption: 'USC Village Aerial August 2017',
        src: 'https://www.youtube.com/embed/VSE2yI2IWRI',
        frameTitle: 'Video: USC Village'
      },
      slideIndex: 1,
      vueTinySlider: dist_default.a,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Life_At_Marshall_Facilities_1.jpg',
        alt: 'USC Marshall',
        id: 0
      }, {
        image: '/static/Life_At_Marshall_Facilities_2.jpg',
        alt: 'USC Village',
        id: 1
      }, {
        image: '/static/Life_At_Marshall_Facilities_3.jpg',
        alt: 'USC Cafeteria',
        id: 2
      }, {
        image: '/static/Life_At_Marshall_Facilities_4.jpg',
        alt: 'USC Swimming Pool',
        id: 3
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('LIFE@MARSHALL', 'Facilities');
  },

  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db2acf3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/Facilities.vue
var Facilities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"life_facilities"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_c('i',[_vm._v("At Marshall, you’ll benefit from the world-class facilities of a renowned international research university — from our state-of-the art, dedicated hub for undergraduate business studies to outstanding libraries, recreational venues and dining options. Here are just a few of the amenities you will enjoy as a Marshall student.")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var Facilities_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('strong',[_vm._v("Jill and Frank Fertitta Hall")]),_c('br'),_vm._v("This five-story, 102,000-square-foot building is home base for Marshall undergraduates. It fosters a sense of community while featuring key services, sophisticated technology, plentiful nooks and crannies for relaxation or study, a dedicated undergrad business library and an Asian-inspired food court with a spacious outdoor courtyard.")]),_vm._v(" "),_c('p',[_vm._v("Fertitta Hall also houses the Lloyd Greif Center for Entrepreneurial Studies and the Experiential Learning Center as well as undergraduate admission, student services and student advising. The building’s two large lecture halls accommodate all undergraduates for presentations by guest speakers and business leaders hosted by the school. Students can reserve one of the building’s 50 breakout rooms for small-group collaboration or meetings. Smart classrooms are equipped with webcams and video playback capacity—and even skateboard racks.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("7 Secrets of Fertitta Hall")])]),_vm._v(" "),_c('div',{staticClass:"youtube-embed"},[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=xM47js_r98A","target":"_blank","rel":"noopener","aria-label":"Watch 7 Secrets of Fertitta Hall on YouTube (opens in a new tab)"}},[_c('img',{attrs:{"src":__webpack_require__("kuak"),"alt":"","role":"presentation"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_c('strong',[_vm._v("USC Village")]),_c('br'),_vm._v("At 15 acres, USC Village is the largest development in the history of South Los Angeles. In addition to student housing, it includes a wide range of restaurants and retailers. Here you’ll find cocktail and dining options ranging from Korean BBQ, burgers and authentic Italian cuisine to fresh Mexican food, sandwich shops and juice bars. There’s even a late-night cookie shop. ")]),_vm._v(" "),_c('p',[_vm._v("Major retailers include Amazon and Target, but you’ll also discover trendy boutiques and a bike shop. Available service providers are also extensive, including Trader Joe’s grocery, CVS Pharmacy, USC Roski Eye Institute, shoe and computer repair shops, hair and nail salons, banking, FedEx and a yoga studio. The Village Fitness Center also offers a spacious lobby including a TV wall with lounge seating.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Video tour of USC Village")])]),_vm._v(" "),_c('div',{staticClass:"youtube-embed"},[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=eKMp-4Mmqdw","target":"_blank","rel":"noopener","aria-label":"Watch Video tour of USC Village on YouTube (opens in a new tab)"}},[_c('img',{attrs:{"src":__webpack_require__("BoYu"),"alt":"","role":"presentation"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("USC Libraries")]),_c('br'),_vm._v("The "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/","target":"_blank"}},[_vm._v("USC Libraries")]),_vm._v(" actively support the discovery, creation and preservation of knowledge. The staff develops collections and services that bolster and encourage the academic endeavors of faculty, students and staff; build a community of critical consumers of information; and help develop engaged world citizens. USC maintains 22 libraries and information centers and the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://digitallibrary.usc.edu/","target":"_blank"}},[_vm._v("USC Digital Library")]),_vm._v(". ")]),_vm._v(" "),_c('p',[_vm._v("Marshall features by two specialized libraries: the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/gaughan-tiberti-library","target":"_blank"}},[_vm._v("Gaughan & Tiberti Business Library")]),_vm._v(" in Fertitta Hall, which collects information on a broad range of business topics that support Marshall courses and research, and the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/accounting-library","target":"_blank"}},[_vm._v("Accounting Library")]),_vm._v(", which is devoted to accounting and taxation materials.")]),_vm._v(" "),_c('p',[_vm._v("Other campus libraries popular with Marshall students include the beautiful and historic Doheny Memorial Library and Leavey Library, with resources that include an Information Commons (computing facilities and collaborative workrooms), Multimedia Commons (equipment and software for graphics, audio and video projects), Learning Rooms and Video Conference Rooms. Leavey is open 24 hours a day during most weeks when classes are in session or exams are underway (except on Sundays, when the library is closed from midnight to 9 a.m.).")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Computing Centers")]),_c('br'),_vm._v("In addition to the technology services offered at USC Libraries, USC Computing Centers are available in convenient campus locations. You can even check out a laptop on loan. Learn more about "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://itservices.usc.edu/spaces/computingcenters/","target":"_blank"}},[_vm._v("USC Computing Centers")]),_vm._v(".")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Bookstore")]),_c('br'),_vm._v("The campus bookstore is adjacent to the Student Union. In addition to textbooks, the store carries school supplies, other essentials, art supplies, computers and tech accessories, sports equipment, home décor, greeting cards, gifts and plenty of USC-branded clothing and gear. Browse the selection or shop online at "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://itservices.usc.edu/spaces/computingcenters/","target":"_blank"}},[_vm._v("USC Bookstores")]),_vm._v(".")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Athletic Facilities")]),_c('br'),_vm._v("The Lyon Recreation Center provides a wide array of programming and services, various specialized fitness areas, indoor athletic courts, and cardio and strength equipment. Recreational opportunities include club sport teams, the Uytengsu Aquatics Center, a weight-training center, racquetball and squash courts, and a cardiovascular center equipped with stationary bicycles, stair climbers, rowing machines and cross-country ski machines. The Lyon Center also offers locker rentals on a semester basis, which include towel service as well as rental of recreational equipment. Certain athletic clubs and classes charge a nominal fee.")]),_vm._v(" "),_c('p',[_vm._v("The USC Village Fitness Center offers three state-of-the-art fitness studios, a weight room featuring Hammer Strength benches and racks, and an extensive selection of ellipticals, bikes and treadmills.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Dining Facilities")]),_c('br'),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://hospitality.usc.edu/","target":"_blank"}},[_vm._v("USC Hospitality")]),_vm._v(" provides a wide range of dining options at venues located throughout and near campus. You can select a meal plan for cost savings (even if you are not living in USC-owned-and-operated housing), or choose from a variety of locations using your USCard or a credit/debit card. Dining hours for USC facilities, which vary throughout the semester, are generally posted outside each location.")]),_vm._v(" "),_c('p',[_vm._v("The choices are extensive — from fast dining, takeaway meals and grocery items to gastropubs and full-service restaurants with farm-to-table cuisine. Whatever you’re craving is probably steps away — or can be delivered to you. A variety of vegan and vegetarian options and Kosher and Halal food are also available, and you can receive support from a registered dietitian for any special dietary needs.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Engemann Student Health Center")]),_c('br'),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://studenthealth.usc.edu/","target":"_blank"}},[_vm._v("The Engemann Student Health Center")]),_vm._v(" is designed to meet all student healthcare needs. With a full range of medical services in primary and specialty care, counseling services and health promotion and disease prevention, your healthcare is covered. Conveniently located on the University Park Campus near the Lyon Center, the Engemann Student Health Center serves those students who are registered for classes and who have paid the Student Health Fee.")]),_vm._v(" "),_c('p',[_vm._v("The center strives to facilitate the completion of your academic career at USC by promoting healthy lifestyles and caring for your physical and psychological illnesses and concerns.")])])}]
var Facilities_esExports = { render: Facilities_render, staticRenderFns: Facilities_staticRenderFns }
/* harmony default export */ var life_at_marshall_Facilities = (Facilities_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/Facilities.vue
function Facilities_injectStyle (ssrContext) {
  __webpack_require__("aGOz")
}
var Facilities_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Facilities___vue_template_functional__ = false
/* styles */
var Facilities___vue_styles__ = Facilities_injectStyle
/* scopeId */
var Facilities___vue_scopeId__ = "data-v-3db2acf3"
/* moduleIdentifier (server only) */
var Facilities___vue_module_identifier__ = null
var Facilities_Component = Facilities_normalizeComponent(
  Facilities,
  life_at_marshall_Facilities,
  Facilities___vue_template_functional__,
  Facilities___vue_styles__,
  Facilities___vue_scopeId__,
  Facilities___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_Facilities = (Facilities_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/ResidenceHalls.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ResidenceHalls = ({
  name: 'ResidenceHalls',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'tiny-slider': dist_default.a,
    'usc-callout-link': src_components_CalloutLink,
    'usc-twoColumns': src_components_TwoColumns
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'USC Housing',
        loResSrc: '../../../static/HeroImages/Marshall42.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall42.jpg'
      },
      slideIndex: 1,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Life_At_Marshall_Residence_Halls_1.jpg',
        alt: 'USC Campus Map',
        id: 0
      }, {
        image: '/static/Life_At_Marshall_Residence_Halls_2.jpg',
        alt: 'Dorm Interior',
        id: 1
      }, {
        image: '/static/Life_At_Marshall_Residence_Halls_3.jpg',
        alt: 'Dorm interior',
        id: 2
      }],
      calloutLinks: [{
        title: 'For more information, visit',
        url: 'https://housingapp.usc.edu/StarRezPortalX/42845DE5/1/1/Welcome_to_USC_Housi-Welcome_to_the_USC_H',
        urltext: 'Reserve my Room today'
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('LIFE@MARSHALL', 'Residence Halls, Apartments and Suites');
  },

  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95eb2f72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/ResidenceHalls.vue
var ResidenceHalls_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"life_residence-halls"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',[_c('i',[_vm._v("Numerous choices of residence halls, suites and apartments are available to freshmen and undergraduates at the university through "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/","target":"_blank"}},[_vm._v("USC Housing")]),_vm._v(". In addition, the university provides a listing service for "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://nup.och101.com/","target":"_blank"}},[_vm._v("off-campus housing")]),_vm._v(".")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-callout-link',{attrs:{"url":this.calloutLinks[0].url,"urltext":this.calloutLinks[0].urltext}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)],1)}
var ResidenceHalls_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_vm._v("Freshman housing is designed to create communities where students live and study together, socialize over meals in our residential dining facilities and adjust to college life. Numerous programs and activities keep residents involved and help you make friends. ")]),_vm._v(" "),_c('p',[_vm._v("Download the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/form_categories/application-brochures/","target":"_blank"}},[_vm._v("USC Housing “Living at USC for Freshmen” brochure")]),_vm._v(" and check out the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/interactive-map/","target":"_blank"}},[_vm._v("interactive map")]),_vm._v(" to explore your USC Housing options.")]),_vm._v(" "),_c('p',[_vm._v("It’s important to "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/the-importance-of-applying-early-3/","target":"_blank"}},[_vm._v("apply early")]),_vm._v(" as housing assignments are made on a first-come, first-served basis. Learn more about the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/how-to-apply-for-residential-colleges-and-special-interest-communities/","target":"_blank"}},[_vm._v("application process")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Freshmen Residence Halls")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Birnkrant Residential College")]),_vm._v(" "),_c('li',[_vm._v("Marks Tower")]),_vm._v(" "),_c('li',[_vm._v("New North Residential College")]),_vm._v(" "),_c('li',[_vm._v("Pardee Tower")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Freshmen Suites")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("McCarthy Honors Residential College")]),_vm._v(" "),_c('li',[_vm._v("Parkside Arts & Humanities Residential College")]),_vm._v(" "),_c('li',[_vm._v("Parkside International Residential College")])]),_vm._v(" "),_c('p',[_c('strong')]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Cale and Irani Residential College")]),_vm._v(" "),_c('li',[_vm._v("Cardinal Gardens")]),_vm._v(" "),_c('li',[_vm._v("Parkside Apartments")]),_vm._v(" "),_c('li',[_vm._v("Webb Tower")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Undergraduate Apartments")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Annenberg House")]),_vm._v(" "),_c('li',[_vm._v("Cale and Irani Residential College")]),_vm._v(" "),_c('li',[_vm._v("Cardinal ’N Gold")]),_vm._v(" "),_c('li',[_vm._v("Cardinal Gardens")]),_vm._v(" "),_c('li',[_vm._v("Century")]),_vm._v(" "),_c('li',[_vm._v("Cowlings and Ilium Residential College")]),_vm._v(" "),_c('li',[_vm._v("La Sorbonne")]),_vm._v(" "),_c('li',[_vm._v("McClintock Apartments")]),_vm._v(" "),_c('li',[_vm._v("McMorrow Residential College")]),_vm._v(" "),_c('li',[_vm._v("Nemirovsky and Bohnett Residential College")]),_vm._v(" "),_c('li',[_vm._v("Parkside Apartments")]),_vm._v(" "),_c('li',[_vm._v("Troy Hall")]),_vm._v(" "),_c('li',[_vm._v("Webb Tower")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("TyX8"),"alt":"USC Housing Map","title":"USC Housing Map"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Special-Interest Housing Communities")]),_c('br'),_vm._v("USC’s special-interest housing communities bring students and faculty together to share living and learning experiences. They feature activities and programs, both formal and informal, that enhance and expand your university life. Check out your options for "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://resed.usc.edu/residential-colleges/","target":"_blank"}},[_vm._v("special-interest communities")]),_vm._v(" and, if one or more seems right for you, be sure to indicate those communities on your housing application. Certain programs, such as Deans’ Halls, have specific eligibility requirements. Programs can fill quickly, so apply early and list the community you would like as your first choice on your housing application.")]),_vm._v(" "),_c('p',[_vm._v("All first-year commuter students are invited to join one of the freshmen residential colleges, which will help you form strong connections by participating in events organized by the resident assistants and faculty in residence. You’ll have the opportunity to become an integral member of the community through interactions with peers outside of the classroom setting. Commuter students should contact "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:resed@usc.edu","target":"_blank"}},[_vm._v("resed@usc.edu")]),_vm._v(" for more information."),_c('br')]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Gender-Inclusive Housing")]),_c('br'),_vm._v("In USC’s gender-inclusive apartments, students can live with roommates regardless of gender identity or biological sex. Traditional housing options that match roommates based on biological sex can prove unsafe and unwelcoming, particularly for LGBTQ+ individuals. The gender-inclusive housing option allows students to live in a safe and supportive environment. Gender-inclusive housing spaces are located in "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"http://housing.usc.edu/index.php/buildings/cardinal-gardens/","target":"_blank"}},[_vm._v("Cardinal Gardens")]),_vm._v(" and "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"http://housing.usc.edu/index.php/buildings/century/","target":"_blank"}},[_vm._v("Century")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("If you are interested in living in "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/section/gender-inclusive-housing/","target":"_blank"}},[_vm._v("Gender-Inclusive Housing")]),_vm._v(", indicate this in the Special Interest section of the online application.")])])}]
var ResidenceHalls_esExports = { render: ResidenceHalls_render, staticRenderFns: ResidenceHalls_staticRenderFns }
/* harmony default export */ var life_at_marshall_ResidenceHalls = (ResidenceHalls_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/ResidenceHalls.vue
function ResidenceHalls_injectStyle (ssrContext) {
  __webpack_require__("zKra")
}
var ResidenceHalls_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResidenceHalls___vue_template_functional__ = false
/* styles */
var ResidenceHalls___vue_styles__ = ResidenceHalls_injectStyle
/* scopeId */
var ResidenceHalls___vue_scopeId__ = "data-v-95eb2f72"
/* moduleIdentifier (server only) */
var ResidenceHalls___vue_module_identifier__ = null
var ResidenceHalls_Component = ResidenceHalls_normalizeComponent(
  ResidenceHalls,
  life_at_marshall_ResidenceHalls,
  ResidenceHalls___vue_template_functional__,
  ResidenceHalls___vue_styles__,
  ResidenceHalls___vue_scopeId__,
  ResidenceHalls___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_ResidenceHalls = (ResidenceHalls_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/SpecialInterestCommunities.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var SpecialInterestCommunities = ({
  name: 'SpecialInterestCommunities',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-cta': src_components_Cta,
    'tiny-slider': dist_default.a
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Special Interest Communities',
        loResSrc: './static/blur/LifeatMarshall_SpecialInterest.jpg',
        hiResSrc: './static/LifeatMarshall_SpecialInterest.jpg'
      },
      video: {
        caption: 'What does a typical USC Marshall student look like?',
        src: 'https://player.vimeo.com/video/249458067',
        frameTitle: 'Video: a typical USC Marshall student'
      },
      slideIndex: 1,
      vueTinySlider: dist_default.a,
      prevDisabled: true,
      nextDisabled: false,
      slides: [{
        image: '/static/Life_At_Marshall_Special_Interest_Communities_1.jpg',
        alt: 'College student reading her microeconomics book in the laundry room',
        id: 0
      }, {
        image: '/static/Life_At_Marshall_Special_Interest_Communities_2.jpg',
        alt: 'Students talking to each other',
        id: 1
      }, {
        image: '/static/Life_At_Marshall_Special_Interest_Communities_3.jpg',
        alt: 'Diverse group of students eating nachos',
        id: 2
      }]
    };
  },
  created: function created() {
    this.$root.setPageHeader('LIFE@MARSHALL', 'Special Interest Communities');
  },

  methods: {
    prevSlide: function prevSlide() {
      if (this.slideIndex > 1) {
        this.slideIndex--;
      } else {
        this.prevDisabled = true;
      }
    },
    nextSlide: function nextSlide() {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++;
      } else {
        this.nextDisabled = true;
      }
    }
  },

  computed: {
    totalSlides: function totalSlides() {
      return this.slides.length;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99cfd4de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/SpecialInterestCommunities.vue
var SpecialInterestCommunities_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"life_special_interest"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("As a resident of USC’s special interest housing, you can experience University life with students and faculty who share your special interests, academic achievements or cultural background. Special interest communities feature organized and informal activities and programs.")]),_vm._v(" "),_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("If one or more of these special interest communities seem right for you, please be sure to indicate those communities on the Housing Application. Certain programs, such as Deans’ Halls, have specific eligibility requirements. Programs can fill quickly, so apply early.")]),_vm._v(" "),_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("Applicants to the Arts & Humanities College or International Residential College should list the community you would like as your first choice on your USC Housing Application.")]),_vm._v(" "),_c('usc-cta',{attrs:{"slot":"cta-bottom","text":"Complete the supplemental application here","url":"http://housing.usc.edu/index.php/how-to-apply-for-residential-colleges-and-special-interest-communities/"},slot:"cta-bottom"})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video.frameTitle,"caption":this.video.caption,"videoSource":this.video.src}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"gutter-md"},[_c('div',{staticClass:"usc-carousel__header"},[_c('div',{staticClass:"usc-carousel__title"},[_vm._v("Life@Marshall")]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__nav"},[_c('div',{staticClass:"usc-carousel__controls",attrs:{"id":"customize-controls"}},[_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Previous Image","disabled":_vm.prevDisabled,"type":"button"},on:{"click":_vm.prevSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M6 .5c0 .1 0 .2-.1.3L1.3 6.5l4.6 5.7c.1.3.1.6-.1.7-.3.1-.5.1-.7-.1L0 6.5 5.1.2c.2-.2.5-.2.7-.1.1.1.2.3.2.4z"}})])]),_vm._v(" "),_c('button',{staticClass:"usc-carousel__button",attrs:{"role":"button","aria-label":"Next Image","disabled":_vm.nextDisabled,"type":"button"},on:{"click":_vm.nextSlide}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"usc-carousel__counter"},[_vm._v("\n          "+_vm._s(this.slideIndex)+" / "+_vm._s(this.totalSlides)+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"mb"},[_c('tiny-slider',{staticClass:"usc-carousel",attrs:{"mouse-drag":false,"loop":false,"items":"1","responsive":true,"controlsContainer":"#customize-controls"}},_vm._l((this.slides),function(slide,index){return _c('div',{staticClass:"usc-carousel__slide"},[_c('div',{staticClass:"usc-carousel__outer"},[_c('img',{staticClass:"usc-carousel__inner",attrs:{"src":slide.image,"alt":slide.alt}})])])}))],1)],1)}
var SpecialInterestCommunities_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Business Floor: North Residential College")]),_vm._v(" "),_c('p',[_vm._v("A community geared toward students with majors and career goals related to Business Administration as well as non-business majors who want to explore business applications in their respective fields, Business Floor: North Residential College offers on-site course-scheduling assistance from Marshall advisors, who visit the floor each semester. The Office of Student Services staff also sponsors special activities involving the Los Angeles business community, and faculty and senior administrators often attend weekly Business Floor dinners.")]),_vm._v(" "),_c('p',[_vm._v("Residents report that it is easier to work on group assignments in business classes with people who are already their neighbors. Another academic advantage of the Business Floor is the individual and group study rooms, renovations that demonstrate USC Marshall’s commitment to helping students succeed.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Arts & Humanities: New Residential College")]),_vm._v(" "),_c('p',[_vm._v("These floors are dedicated to architecture, music and the visual arts. They connect students with the cultural offerings of greater Los Angeles as well as the arts and humanities community at USC.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Cinema Floor: New Residential College")]),_vm._v(" "),_c('p',[_vm._v("For students who have an interest in cinema or hope for a career in the industry, the walls of this hallway are decorated with a mural, designed and painted by students, depicting cinema history. Faculty and alumni of the USC School of Cinema Arts are invited to weekly dinners, programs and other activities, including trips to Hollywood and film studios. The floor also sponsors an Ed Wood Film Competition, in which individuals and teams from the entire USC student body are given 24 hours to produce a 10-minute film on a designated topic.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("University Residential College: Birnkrant")]),_vm._v(" "),_c('p',[_vm._v("Home to more USC campus senators, student government officers, members of honor societies, club leaders, Resident Advisors and award recipients than any other residence hall, this space is reserved for Trustee/Presidential scholars only. Activities include Deans’ Halls Forum, a welcome reception and special dinners.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("International Residential College: Parkside Apartments")]),_vm._v(" "),_c('p',[_vm._v("The International Residential College is geared toward students interested in intellectual and social exchanges with faculty and students from all over the world, and offers a regular program of guest speakers, social and cultural events and the opportunity to practice language skills.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Latino Floors: Fluor Tower")]),_vm._v(" "),_c('p',[_vm._v("These floors promote cultural awareness, community involvement and academic success by facilitating a smooth transition to University life and creating an unforgettable first-year experience for residents from all around the world. The space is open to all students who have an interest in the Latino culture and those who want to experience their first year at USC in a supportive and close-knit multicultural community. For more information, visit: usc.edu/student-affairs/elcentro.")]),_vm._v(" "),_c('p',[_vm._v("If you want to live on the Latino Floors, an online application is required. To apply, or for additional information, contact El Centro Chicano at (213) 740-1480 or visit "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"https://elcentro.usc.edu/","target":"_blank"}},[_vm._v("USC El Centro Chicano")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Muslim Floor: Parkside Apartments")]),_vm._v(" "),_c('p',[_vm._v("Providing a venue for the exploration of the Muslim culture and way of life, this floor is designated as substance-free, with individual kitchens that allow residents to prepare halal food and share Islamic holidays with friends. Through social activities held with USC Muslim organizations, students can learn how Islam relates to other faiths. For more information, contact the "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"http://orl.usc.edu/","target":"_blank"}},[_vm._v("USC office of Religious Life")]),_vm._v(".")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Quiet Community Floor: Fluor Tower")]),_vm._v(" "),_c('p',[_vm._v("Designed to be a tranquil haven for undergraduate men and women, this space’s residents create a supportive environment designed to help each other focus on academic goals.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Rainbow Floor: Century Apartments")]),_vm._v(" "),_c('p',[_vm._v("This floor provides lesbian, gay, bisexual and transgender (LGBTQ+) students and their allies with the opportunity to create a safe and affirming living environment through educational, academic and social programming, in cooperation with the LGBT Resource Center and Student Services’ Residential Education staff. Programs include LGBTQ+ and ally mentoring, social justice initiatives, career and academic support and networking with local Los Angeles resources. For more information, visit the "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"http://lgbtrc.usc.edu/","target":"_blank"}},[_vm._v("USC LGBT Resource Center")]),_vm._v(" online.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Shalom Floor: Parkside Apartments")]),_vm._v(" "),_c('p',[_vm._v("Giving students the opportunity to live with Jewish students, explore Jewish culture and connect with the Jewish community, this floor provides individual kitchens in the apartments that make it easier for students who keep kosher to do so. Rabbi Jonathan Klein, director of the USC Hillel Jewish Center, serves as a faculty/staff mentor and brings activities and programs to the floor. For more information, contact the "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"http://orl.usc.edu/","target":"_blank"}},[_vm._v("USC office of Religious Life")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Somerville Place: Fluor Tower")]),_vm._v(" "),_c('p',[_vm._v("Named after John and Vada Somerville, the first two African-American graduates of the USC Dental School, this living space was established to foster understanding of and respect for the African-American culture while developing a sense of family and community. The environment nurtures academic success, leadership, self-direction and personal growth, and its residents strive to achieve spirituality, respect, retention, successful transitions and an understanding and display of positive social values. For more information on Somerville Place and its co-sponsoring office, the Center for Black Cultural and Student Affairs, visit: usc.edu/student-affairs/black_cultural_center.")]),_vm._v(" "),_c('p',[_vm._v("Prospective Somerville Place residents must complete a supplemental application. Contact the Center for Black Cultural and Student Affairs at (213) 740-8257, send an "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"mailto:cbcsa@usc.edu"}},[_vm._v("email")]),_vm._v(" or "),_c('a',{staticClass:"usc-hyperlink",attrs:{"href":"https://cbcsa.usc.edu/","target":"_blank"}},[_vm._v("visit")]),_vm._v(" us online.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Substance-Free Floor: New Residential College")]),_vm._v(" "),_c('p',[_vm._v("Here, students are committed to healthy habits and avoid tobacco products, alcohol and other drugs—not just on the floor but also in their daily lives. The floor sponsors activities geared to a substance-free lifestyle, while residents participate in Health Center programs and community service projects, and serve as role models for at-risk youth.")])])}]
var SpecialInterestCommunities_esExports = { render: SpecialInterestCommunities_render, staticRenderFns: SpecialInterestCommunities_staticRenderFns }
/* harmony default export */ var life_at_marshall_SpecialInterestCommunities = (SpecialInterestCommunities_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/SpecialInterestCommunities.vue
function SpecialInterestCommunities_injectStyle (ssrContext) {
  __webpack_require__("Up7m")
}
var SpecialInterestCommunities_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SpecialInterestCommunities___vue_template_functional__ = false
/* styles */
var SpecialInterestCommunities___vue_styles__ = SpecialInterestCommunities_injectStyle
/* scopeId */
var SpecialInterestCommunities___vue_scopeId__ = "data-v-99cfd4de"
/* moduleIdentifier (server only) */
var SpecialInterestCommunities___vue_module_identifier__ = null
var SpecialInterestCommunities_Component = SpecialInterestCommunities_normalizeComponent(
  SpecialInterestCommunities,
  life_at_marshall_SpecialInterestCommunities,
  SpecialInterestCommunities___vue_template_functional__,
  SpecialInterestCommunities___vue_styles__,
  SpecialInterestCommunities___vue_scopeId__,
  SpecialInterestCommunities___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_SpecialInterestCommunities = (SpecialInterestCommunities_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/life-at-marshall/Transportation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Transportation = ({
  name: 'Facilities',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Transportation',
        loResSrc: '../../../static/Marshall13.png',
        hiResSrc: '../../../static/Marshall13.png'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('LIFE@MARSHALL', 'Transportation');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aee3277","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/life-at-marshall/Transportation.vue
var Transportation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"life_transportation"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',[_c('p',{attrs:{"slot":"p"},slot:"p"},[_vm._v("USC offers myriad resources to assist students in navigating the University Park Campus and the Greater Los Angeles area efficiently and safely, in addition to facilitating more extended excursions for students, both at home and abroad.")])]),_vm._v(" "),_vm._m(0)],1)}
var Transportation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("The university’s new "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://gettraveling.usc.edu/#/","target":"_blank"}},[_vm._v("Traveler dashboard")]),_vm._v(" helps you compare and create customized journey plans, whether you’re using USC buses, carpool and rideshare, or public transportation. The platform saves you time and money as well as helping you go green!")]),_vm._v(" "),_c('p',[_vm._v("Here are a few of the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu/","target":"_blank"}},[_vm._v("transportation options")]),_vm._v(" available to you at Marshall.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Buses")]),_c('br'),_vm._v("USC Transportation includes an extensive network of free buses throughout the year, with multiple routes connecting the University Park Campus, North University Park neighborhood, USC Parking Center and farther-flung USC locations — such as the Health Sciences Campus, Marina Del Rey offices and Keck USC of Alhambra — as well as Union Station in Downtown Los Angeles.")]),_vm._v(" "),_c('p',[_vm._v("To request an escort, use the usc.ridecell.com web-request interface, download and use the free "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://play.google.com/store/apps/details?id=com.ridecell.platform.leonidas.usc&pli=1","target":"_blank"}},[_vm._v("Campus Cruiser app")]),_vm._v(" or call (213) 740-4911 when you are ready to leave. An escort will arrive in approximately 15 minutes. The service runs from 6 p.m. to midnight every day except university holidays. Summer hours vary slightly. ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("USC Lyft Rides Program")]),_c('br'),_vm._v("As the university population has grown, so has the reliance on ride share. We partner with Lyft to offer free Lyft rides to students within the free-ride zone.  Learn more about the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu/index.php/how-to-use-lyft/","target":"_blank"}},[_vm._v("USC Lyft Ride Program")]),_vm._v(" and how to use it.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Personal Bicycle")]),_c('br'),_vm._v("Many USC students find bicycling to and from campus both convenient and economical. University policy requires the formal registration of all bicycles ridden or parked on campus. Bicycles should be registered with the USC Department of Safety; registration is free of charge and can assist you with the recovery of lost or impounded bicycles. For more information, visit our "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://dps.usc.edu/services/bikes/","target":"_blank"}},[_vm._v("Department of Public Safety")]),_vm._v(" page. You may also register scooters and skateboards.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Carpool")]),_c('br'),_vm._v("Students can use USC’s carpool program to share rides and expenses. You’ll save money on gasoline, parking, vehicle maintenance and insurance while helping eliminate traffic congestion and pollution. You can even get to campus faster by using carpool lanes on L.A.’s freeways. Learn more about "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu/index.php/carpool/","target":"_blank"}},[_vm._v("USC’s carpool program")]),_vm._v(".")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Metro")]),_c('br'),_vm._v("The Los Angeles Metropolitan Transit Authority (Metro) operates buses and rail lines throughout the Greater Los Angeles area, including several stops near USC. Metro bus schedules are available at the Office of Transportation Services in Parking Structure A and in Topping Student Center. Students can apply for a discount Metro pass at Topping Student Center. For more information, call 1-800-COMMUTE (1-800-266- 6883) or visit the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.metro.net/","target":"_blank"}},[_vm._v("Metro website")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("The Expo line runs from Downtown L.A.’s 7th street/Metro Center to Santa Monica. Four stations along the way serve USC students, faculty and staff: 23rd Street; Jefferson Boulevard/USC (near Galen Center); Expo Park/USC; and Exposition Boulevard.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("DASH")]),_c('br'),_vm._v("Operated by the Los Angeles Department of Transportation (LADOT), DASH is another bus option for Downtown Los Angeles. DASH shuttles stop along Figueroa Street and Exposition Boulevard next to the USC campus. Maps and schedules are available at Topping Student Center. For schedules and more information, call (213) 808-2273 or visit the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://ladottransit.com/","target":"_blank"}},[_vm._v("LADOT")]),_vm._v(" website.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Big Blue Bus")]),_c('br'),_vm._v("The Big Blue Bus services the westside of Los Angeles and is operated by the City of Santa Monica. For maps and schedules, call (310) 451-5444 or visit the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.bigbluebus.com/","target":"_blank"}},[_vm._v("Big Blue Bus")]),_vm._v(" website.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Amtrak")]),_c('br'),_vm._v("For long-distance train travel between cities in California or to other states, board Amtrak at Union Station in Downtown Los Angeles. The USC shuttle between the University Park Campus and Health Sciences Campus makes regular stops at Union Station. For ticket information, call 1-800-USA-RAIL or visit the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.amtrak.com/home.html","target":"_blank"}},[_vm._v("Amtrak")]),_vm._v(" website.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Airport Shuttle")]),_c('br'),_vm._v("The USC Department of Public Safety offers "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://dps.usc.edu/services/shuttles/","target":"_blank"}},[_vm._v("airport shuttle reservations")]),_vm._v(" from campus to Los Angeles International Airport (LAX). Learn about additional "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://ois.usc.edu/new-students/arrivingintheus/transportation/","target":"_blank"}},[_vm._v("airport transportation options")]),_vm._v(" from the Office of International Students.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Car Rentals")]),_c('br'),_vm._v("USC has partnered with "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu/index.php/zipcar/","target":"_blank"}},[_vm._v("Zipcar")]),_vm._v(" to bring on-demand car sharing and 24/7 access to vehicles parked right on campus. Once you join the service (with a USC discount), simply reserve online, let yourself in with your Zipcard and drive. Discounted hourly and daily rates include gas and insurance. You need to be 18+ to join. USC also has partnered with "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu/index.php/enterprise-car-rentals/","target":"_blank"}},[_vm._v("Enterprise Car Rentals")]),_vm._v(", which has a nearby office and will pick you up on campus to take you to your rental vehicle.")])])}]
var Transportation_esExports = { render: Transportation_render, staticRenderFns: Transportation_staticRenderFns }
/* harmony default export */ var life_at_marshall_Transportation = (Transportation_esExports);
// CONCATENATED MODULE: ./src/pages/life-at-marshall/Transportation.vue
function Transportation_injectStyle (ssrContext) {
  __webpack_require__("U3Z0")
}
var Transportation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Transportation___vue_template_functional__ = false
/* styles */
var Transportation___vue_styles__ = Transportation_injectStyle
/* scopeId */
var Transportation___vue_scopeId__ = "data-v-5aee3277"
/* moduleIdentifier (server only) */
var Transportation___vue_module_identifier__ = null
var Transportation_Component = Transportation_normalizeComponent(
  Transportation,
  life_at_marshall_Transportation,
  Transportation___vue_template_functional__,
  Transportation___vue_styles__,
  Transportation___vue_scopeId__,
  Transportation___vue_module_identifier__
)

/* harmony default export */ var pages_life_at_marshall_Transportation = (Transportation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/NextSteps.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NextSteps = ({
  name: 'NextSteps',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-callout-link': src_components_CalloutLink
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'NextSteps',
        loResSrc: '../../static/HeroImages/Marshall39.jpg',
        hiResSrc: '../../static/HeroImages/Marshall39.jpg'
      },
      intro: ['Congratulations again on your admission to USC Marshall. We can’t wait to welcome you into the Trojan Family!'],
      video1: {
        caption: 'Dean Ellis answers common parent\'s questions',
        src: 'https://player.vimeo.com/video/249455589?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      video2: {
        caption: 'Why parents choose Marshall',
        src: 'https://player.vimeo.com/video/249455704?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Why parents choose Marshall'
      },
      video3: {
        caption: 'What students discover at Explore USC',
        src: 'https://player.vimeo.com/video/249455984?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Explore USC'
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Next Steps', '');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d262a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NextSteps.vue
var NextSteps_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NextSteps"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('usc-videoEmbed',{attrs:{"frameTitle":this.video2.frameTitle,"caption":this.video2.caption,"videoSource":this.video2.src}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Orientation")]),_vm._v(" "),_c('p',[_vm._v("USC’s Orientation Programs team helps ensure a smooth transition and warm welcome to the USC community for all new students. We believe Orientation is a process, not just an event, so we host programs and activities throughout the academic year to facilitate your transition to life as a Trojan.")]),_vm._v(" "),_c('usc-cta',{attrs:{"text":"Sign up for Orientation","url":"https://orientation.usc.edu/sign-up/"}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('usc-callout-link',{attrs:{"urltext":"Count me in!","url":"https://applyto.usc.edu/apply/status"}})],1)}
var NextSteps_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('p',[_vm._v("Following is a guide to a few of the lingering questions you may have and final steps to take to enroll at Marshall.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Still Undecided?")])]),_vm._v(" "),_c('p',[_vm._v("Explore the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.marshall.usc.edu/programs/undergraduate-programs","target":"_blank"}},[_vm._v("degree of difference")]),_vm._v(" USC Marshall offers or contact "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:busadm@marshall.usc.edu","target":"_blank"}},[_vm._v("Marshall undergraduate admissions")]),_vm._v(" or call us at (213) 740-8885 with any remaining questions you have or information you need. ")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body gutter-lg mb"},[_c('p',[_c('strong',[_vm._v("Exam Credits")]),_c('br'),_c('i',[_vm._v("Advanced Placement Exam Scores")]),_c('br'),_vm._v("If you are taking advanced placement examinations this spring, be sure to list USC as your college choice so that your scores will be sent to the University Admissions Office. To submit previous AP exam results, contact "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.collegeboard.org/","target":"_blank"}},[_vm._v("College Board")]),_vm._v(" to have your scores delivered directly to USC. USC’s CEEB code is 4852.")]),_vm._v(" "),_c('p',[_vm._v("Students receive four USC units for most AP exams passed with a minimum score of 4. A maximum of 32 units can be awarded for AP exams.")]),_vm._v(" "),_c('p',[_vm._v("For advising purposes, bring copies of your AP scores to Orientation.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("International Baccalaureate Diplomas")]),_c('br'),_vm._v("USC awards a maximum of 24 credits for the International Baccalaureate (IB) exams. For each IB Higher Level exam with a score of 5, 6, or 7, USC awards 6 semester units, up to a maximum of 4 subject exams. Alternatively, USC awards 20 semester units for students who earn the International Baccalaureate Diploma with a score of 30 or above.")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("A-Level Exam Credit")]),_c('br'),_vm._v("USC awards 8 elective semester units for A-level exams earning scores of A*, A or B. "),_c('br'),_vm._v(" Students may receive General Education (GE) or USC Marshall prerequisite subject credit. The USC Articulation Office determines whether courses transfer for degree credit, fulfill any GE or diversity categories or receive USC course equivalencies.")]),_vm._v(" "),_c('p',[_vm._v("Learn more about "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://arr.usc.edu/students/transfer-credit-services/exam-credit/","target":"_blank"}},[_vm._v("AP, IB and A-Level exam credits")]),_vm._v(".")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Enrollment Commitment Deposit")]),_c('br'),_vm._v("Admitted freshmen must submit the "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://fallwelcome.usc.edu/next-steps/","target":"_blank"}},[_vm._v("Enrollment Commitment Deposit")]),_vm._v(" by May 1 to reserve a place in the fall class. The deposit must be received and processed before you can register for Orientation.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Housing and Meal Plan Application")]),_c('br'),_vm._v("Admitted students should submit a Housing Application as early as possible because they are processed in the order received. Learn more about the process of "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu/index.php/application-4/","target":"_blank"}},[_vm._v("choosing your housing options")]),_vm._v(". You can submit your Housing Application before the Enrollment Commitment Deposit. You have numerous "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://hospitality.usc.edu/residential-dining-meal-plans/","target":"_blank"}},[_vm._v("options for meal plans")]),_vm._v(" as well.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Final Transcript")]),_c('br'),_vm._v("Submit a final transcript after completing your last semester.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("At Orientation, you will:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Receive academic advisement")]),_vm._v(" "),_c('li',[_vm._v("Complete class registration")]),_vm._v(" "),_c('li',[_vm._v("Get a USCard")]),_vm._v(" "),_c('li',[_vm._v("Sign up for health insurance (or provide proof of existing insurance)")]),_vm._v(" "),_c('li',[_vm._v("Purchase a USC Parking Permit (if needed)")]),_vm._v(" "),_c('li',[_vm._v("Register your bicycle (if needed)")]),_vm._v(" "),_c('li',[_vm._v("Meet faculty, staff and fellow students")]),_vm._v(" "),_c('li',[_vm._v("Learn important facts about life on campus")])])])}]
var NextSteps_esExports = { render: NextSteps_render, staticRenderFns: NextSteps_staticRenderFns }
/* harmony default export */ var pages_NextSteps = (NextSteps_esExports);
// CONCATENATED MODULE: ./src/pages/NextSteps.vue
function NextSteps_injectStyle (ssrContext) {
  __webpack_require__("SbFc")
}
var NextSteps_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NextSteps___vue_template_functional__ = false
/* styles */
var NextSteps___vue_styles__ = NextSteps_injectStyle
/* scopeId */
var NextSteps___vue_scopeId__ = "data-v-63d262a2"
/* moduleIdentifier (server only) */
var NextSteps___vue_module_identifier__ = null
var NextSteps_Component = NextSteps_normalizeComponent(
  NextSteps,
  pages_NextSteps,
  NextSteps___vue_template_functional__,
  NextSteps___vue_styles__,
  NextSteps___vue_scopeId__,
  NextSteps___vue_module_identifier__
)

/* harmony default export */ var src_pages_NextSteps = (NextSteps_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LinkGroup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LinkGroup = ({
  name: 'LinkGroup',
  props: ['links', 'title'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f5923bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkGroup.vue
var LinkGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-linkGroup gutter-lg"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('ul',_vm._l((_vm.links),function(link,index){return _c('li',[_c('a',{attrs:{"href":link.url,"target":"_blank"}},[_c('div',{staticClass:"usc-linkGroup__link-text"},[_vm._v("\n          "+_vm._s(link.text)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"usc-linkGroup__arrow"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 13"}},[_c('path',{attrs:{"fill":"#231F20","d":"M0 12.5c0-.1 0-.2.1-.3l4.6-5.7L.1.8C0 .6 0 .3.2.1c.3-.1.5-.1.7.1L6 6.5.9 12.8c-.2.2-.5.3-.7.1-.1-.1-.2-.2-.2-.4z"}})])])])])}))])}
var LinkGroup_staticRenderFns = []
var LinkGroup_esExports = { render: LinkGroup_render, staticRenderFns: LinkGroup_staticRenderFns }
/* harmony default export */ var components_LinkGroup = (LinkGroup_esExports);
// CONCATENATED MODULE: ./src/components/LinkGroup.vue
function LinkGroup_injectStyle (ssrContext) {
  __webpack_require__("PZMn")
}
var LinkGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LinkGroup___vue_template_functional__ = false
/* styles */
var LinkGroup___vue_styles__ = LinkGroup_injectStyle
/* scopeId */
var LinkGroup___vue_scopeId__ = "data-v-4f5923bb"
/* moduleIdentifier (server only) */
var LinkGroup___vue_module_identifier__ = null
var LinkGroup_Component = LinkGroup_normalizeComponent(
  LinkGroup,
  components_LinkGroup,
  LinkGroup___vue_template_functional__,
  LinkGroup___vue_styles__,
  LinkGroup___vue_scopeId__,
  LinkGroup___vue_module_identifier__
)

/* harmony default export */ var src_components_LinkGroup = (LinkGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/MarshallUndergraduatePrograms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var MarshallUndergraduatePrograms = ({
  name: 'MarshallUndergraduatePrograms',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Marshall Undergraduate Programs',
        loResSrc: '../../../static/HeroImages/Marshall7.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall7.jpg'
      },
      intro: ['USC and Marshall are here to support you every step of the way. Following is a quick reference guide to some of the key resources available to you.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Marshall Undergraduate Programs');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b884fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/MarshallUndergraduatePrograms.vue
var MarshallUndergraduatePrograms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MarshallUndergraduatePrograms"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var MarshallUndergraduatePrograms_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Marshall Undergraduate Programs")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Undergraduate Admissions")]),_c('br'),_vm._v("\n      Fertitta Hall 227"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:busadm@marshall.usc.edu"}},[_vm._v("busadm@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-8885\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Undergraduate Student Advising")]),_c('br'),_vm._v("\n      Fertitta Hall 201"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:undergrad.advising@marshall.usc.edu"}},[_vm._v("undergrad.advising@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-0690\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Undergraduate Career Services")]),_c('br'),_vm._v("\n      Fertitta Hall 201"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:ugcareers@marshall.usc.edu"}},[_vm._v("ugcareers@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-5705\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Undergraduate International Programs")]),_c('br'),_vm._v("\n      Fertitta Hall 201"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:uginternational@marshall.usc.edu"}},[_vm._v("uginternational@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-5705\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Dean, Marshall School of Business")]),_c('br'),_vm._v("\n      Bridge Hall 100"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:dean@marshall.usc.edu"}},[_vm._v("dean@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-6422\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Dean, Leventhal School of Accounting")]),_c('br'),_vm._v("\n      Accounting 101"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:lsoa_ugrad@marshall.usc.edu"}},[_vm._v("lsoa_ugrad@marshall.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-4838\n    ")])])}]
var MarshallUndergraduatePrograms_esExports = { render: MarshallUndergraduatePrograms_render, staticRenderFns: MarshallUndergraduatePrograms_staticRenderFns }
/* harmony default export */ var resources_MarshallUndergraduatePrograms = (MarshallUndergraduatePrograms_esExports);
// CONCATENATED MODULE: ./src/pages/resources/MarshallUndergraduatePrograms.vue
function MarshallUndergraduatePrograms_injectStyle (ssrContext) {
  __webpack_require__("3yjQ")
}
var MarshallUndergraduatePrograms_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MarshallUndergraduatePrograms___vue_template_functional__ = false
/* styles */
var MarshallUndergraduatePrograms___vue_styles__ = MarshallUndergraduatePrograms_injectStyle
/* scopeId */
var MarshallUndergraduatePrograms___vue_scopeId__ = "data-v-73b884fe"
/* moduleIdentifier (server only) */
var MarshallUndergraduatePrograms___vue_module_identifier__ = null
var MarshallUndergraduatePrograms_Component = MarshallUndergraduatePrograms_normalizeComponent(
  MarshallUndergraduatePrograms,
  resources_MarshallUndergraduatePrograms,
  MarshallUndergraduatePrograms___vue_template_functional__,
  MarshallUndergraduatePrograms___vue_styles__,
  MarshallUndergraduatePrograms___vue_scopeId__,
  MarshallUndergraduatePrograms___vue_module_identifier__
)

/* harmony default export */ var pages_resources_MarshallUndergraduatePrograms = (MarshallUndergraduatePrograms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/USCAdmissions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var USCAdmissions = ({
  name: 'USCAdmissions',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'USC Admissions, Financial Aid and Student Accounts',
        loResSrc: '../../../static/HeroImages/Marshall46.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall46.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'USC Admissions, Financial Aid and Student Accounts');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f5a4566","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/USCAdmissions.vue
var USCAdmissions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"USCAdmissions"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var USCAdmissions_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("USC Admissions, Financial Aid and Student Accounts")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Undergraduate Admissions")]),_c('br'),_vm._v("\n        Hubbard Hall Lobby"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://admission.usc.edu","target":"_blank"}},[_vm._v("https://admission.usc.edu")]),_c('br'),_vm._v("\n        (213) 740-1111\n      ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Financial Aid")]),_c('br'),_vm._v("\n        Hubbard Hall Lobby"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://financialaid.usc.edu","target":"_blank"}},[_vm._v("https://financialaid.usc.edu")]),_c('br'),_vm._v("\n        (213) 740-4444\n      ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Student Financial Services")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://sfs.usc.edu/","target":"_blank"}},[_vm._v("https://sfs.usc.edu/")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Cashier’s Office")]),_c('br'),_vm._v("\n        Student Union 106"),_c('br')])])}]
var USCAdmissions_esExports = { render: USCAdmissions_render, staticRenderFns: USCAdmissions_staticRenderFns }
/* harmony default export */ var resources_USCAdmissions = (USCAdmissions_esExports);
// CONCATENATED MODULE: ./src/pages/resources/USCAdmissions.vue
function USCAdmissions_injectStyle (ssrContext) {
  __webpack_require__("R97x")
}
var USCAdmissions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var USCAdmissions___vue_template_functional__ = false
/* styles */
var USCAdmissions___vue_styles__ = USCAdmissions_injectStyle
/* scopeId */
var USCAdmissions___vue_scopeId__ = "data-v-9f5a4566"
/* moduleIdentifier (server only) */
var USCAdmissions___vue_module_identifier__ = null
var USCAdmissions_Component = USCAdmissions_normalizeComponent(
  USCAdmissions,
  resources_USCAdmissions,
  USCAdmissions___vue_template_functional__,
  USCAdmissions___vue_styles__,
  USCAdmissions___vue_scopeId__,
  USCAdmissions___vue_module_identifier__
)

/* harmony default export */ var pages_resources_USCAdmissions = (USCAdmissions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/HousingTransportation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var HousingTransportation = ({
  name: 'HousingTransportations',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Housing and Transportation',
        loResSrc: '../../../static/HeroImages/Marshall73.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall73.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Housing and Transportation');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7da1014","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/HousingTransportation.vue
var HousingTransportation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HousingTransportation"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var HousingTransportation_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Housing and Transportation")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Housing")]),_c('br'),_vm._v("\n      McCarthy Structure"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://housing.usc.edu","target":"_blank"}},[_vm._v("https://housing.usc.edu")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:housing@usc.edu"}},[_vm._v("housing@usc.edu")]),_c('br'),_vm._v("\n      (800) 872-4632\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Transportation")]),_c('br'),_vm._v("\n      McCarthy Structure"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://transnet.usc.edu","target":"_blank"}},[_vm._v("https://transnet.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-3575\n    ")])])}]
var HousingTransportation_esExports = { render: HousingTransportation_render, staticRenderFns: HousingTransportation_staticRenderFns }
/* harmony default export */ var resources_HousingTransportation = (HousingTransportation_esExports);
// CONCATENATED MODULE: ./src/pages/resources/HousingTransportation.vue
function HousingTransportation_injectStyle (ssrContext) {
  __webpack_require__("4BQs")
}
var HousingTransportation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HousingTransportation___vue_template_functional__ = false
/* styles */
var HousingTransportation___vue_styles__ = HousingTransportation_injectStyle
/* scopeId */
var HousingTransportation___vue_scopeId__ = "data-v-b7da1014"
/* moduleIdentifier (server only) */
var HousingTransportation___vue_module_identifier__ = null
var HousingTransportation_Component = HousingTransportation_normalizeComponent(
  HousingTransportation,
  resources_HousingTransportation,
  HousingTransportation___vue_template_functional__,
  HousingTransportation___vue_styles__,
  HousingTransportation___vue_scopeId__,
  HousingTransportation___vue_module_identifier__
)

/* harmony default export */ var pages_resources_HousingTransportation = (HousingTransportation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/InternationalStudents.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var InternationalStudents = ({
  name: 'InternationalStudents',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'International Students',
        loResSrc: '../../../static/HeroImages/Resources6.jpg',
        hiResSrc: '../../../static/HeroImages/Resources6.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'International Students');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf433ac8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/InternationalStudents.vue
var InternationalStudents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"InternationalStudents"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var InternationalStudents_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('address',[_c('strong',[_vm._v("International Admissions")]),_c('br'),_vm._v("\n      Hubbard Hall Lobby"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://admission.usc.edu/apply/international-students/","target":"_blank"}},[_vm._v("https://admission.usc.edu/apply/international-students/")]),_c('br'),_vm._v("\n      (213) 740-1111\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Office of International Services")]),_c('br'),_vm._v("\n      Royal Street Parking Structure, Suite 101"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://ois.usc.edu","target":"_blank"}},[_vm._v("https://ois.usc.edu")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:ois@usc.edu"}},[_vm._v("ois@usc.edu")])])])}]
var InternationalStudents_esExports = { render: InternationalStudents_render, staticRenderFns: InternationalStudents_staticRenderFns }
/* harmony default export */ var resources_InternationalStudents = (InternationalStudents_esExports);
// CONCATENATED MODULE: ./src/pages/resources/InternationalStudents.vue
function InternationalStudents_injectStyle (ssrContext) {
  __webpack_require__("UE4i")
}
var InternationalStudents_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InternationalStudents___vue_template_functional__ = false
/* styles */
var InternationalStudents___vue_styles__ = InternationalStudents_injectStyle
/* scopeId */
var InternationalStudents___vue_scopeId__ = "data-v-cf433ac8"
/* moduleIdentifier (server only) */
var InternationalStudents___vue_module_identifier__ = null
var InternationalStudents_Component = InternationalStudents_normalizeComponent(
  InternationalStudents,
  resources_InternationalStudents,
  InternationalStudents___vue_template_functional__,
  InternationalStudents___vue_styles__,
  InternationalStudents___vue_scopeId__,
  InternationalStudents___vue_module_identifier__
)

/* harmony default export */ var pages_resources_InternationalStudents = (InternationalStudents_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/OrientationTours.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var OrientationTours = ({
  name: 'OrientationTours',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Orientation and Tours',
        loResSrc: '../../../static/HeroImages/Resources7.jpg',
        hiResSrc: '../../../static/HeroImages/Resources7.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Orientation and Tours');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eba82a7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/OrientationTours.vue
var OrientationTours_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"OrientationTours"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var OrientationTours_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Orientation and Tours")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Office of Orientation")]),_c('br'),_vm._v("\n      Student Union B-7"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://orientation.usc.edu","target":"_blank"}},[_vm._v("https://orientation.usc.edu")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Campus Tours")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://admission.usc.edu/meet-us/tours/","target":"_blank"}},[_vm._v("https://admission.usc.edu/meet-us/tours/")]),_c('br'),_vm._v("\n      (213) 740-1111"),_c('br')]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("SCampus")]),_c('br'),_vm._v("This guidebook for USC students contains a wealth of important information about the many services, facilities, special programs and other resources available to you on campus. It also outlines official policies, procedures, and rights and responsibilities that govern the USC community. You will receive a copy of SCampus during orientation.")])])}]
var OrientationTours_esExports = { render: OrientationTours_render, staticRenderFns: OrientationTours_staticRenderFns }
/* harmony default export */ var resources_OrientationTours = (OrientationTours_esExports);
// CONCATENATED MODULE: ./src/pages/resources/OrientationTours.vue
function OrientationTours_injectStyle (ssrContext) {
  __webpack_require__("xR9E")
}
var OrientationTours_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var OrientationTours___vue_template_functional__ = false
/* styles */
var OrientationTours___vue_styles__ = OrientationTours_injectStyle
/* scopeId */
var OrientationTours___vue_scopeId__ = "data-v-2eba82a7"
/* moduleIdentifier (server only) */
var OrientationTours___vue_module_identifier__ = null
var OrientationTours_Component = OrientationTours_normalizeComponent(
  OrientationTours,
  resources_OrientationTours,
  OrientationTours___vue_template_functional__,
  OrientationTours___vue_styles__,
  OrientationTours___vue_scopeId__,
  OrientationTours___vue_module_identifier__
)

/* harmony default export */ var pages_resources_OrientationTours = (OrientationTours_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/AcademicResources.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var AcademicResources = ({
  name: 'AcademicResources',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Academic Resources',
        loResSrc: '../../../static/HeroImages/Marshall118.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall118.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Academic Resources');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aac3c0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/AcademicResources.vue
var AcademicResources_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AcademicResources"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_c('div',{staticClass:"body gutter-lg mb"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('usc-cta',{attrs:{"text":"Log in to OASIS","url":"https://usc.edu/OASIS"}}),_vm._v(" "),_c('p',[_vm._v("Use your USC ID number and six-digit birth date (“mmddyy” format).")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)],1)],1)}
var AcademicResources_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',[_c('strong',[_vm._v("Academic Calendar")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www.usc.edu/academic-calendar/","target":"_blank"}},[_vm._v("https://www.usc.edu/academic-calendar/")]),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',[_c('strong',[_vm._v("USC Bookstore")]),_c('br'),_vm._v("\n      840 Childs Way"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://uscbookstore.com","target":"_blank"}},[_vm._v("https://uscbookstore.com")]),_c('br'),_vm._v("\n      (800) 447-8620\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Catalogue")]),_c('br'),_vm._v("The "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://catalogue.usc.edu/","target":"_blank"}},[_vm._v("USC Catalogue")]),_vm._v(" in effect for the semester of your admission is the authoritative reference for ensuring you meet all Marshall and university requirements for graduation. Degree requirements listed in the USC Catalogue supersede information in any other university or school publication. ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("OASIS")]),_c('br'),_vm._v("This powerful online student-information tool lets you check your completed course list, grades, enrollment status, payment status (including balance due and specific charges) and change your address for all USC departments.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Schedule of Classes")]),_c('br'),_vm._v("USC’s Schedule of Classes provides semester-specific registration instructions, tuition and fees, course listings and more."),_c('br'),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://classes.usc.edu","target":"_blank"}},[_vm._v("https://classes.usc.edu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',[_c('strong',[_vm._v("Transcripts")]),_c('br'),_vm._v("\n      Hubbard Hall Lobby"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://arr.usc.edu/records-transcripts/transcripts/","target":"_blank"}},[_vm._v("https://arr.usc.edu/records-transcripts/transcripts/")]),_c('br'),_vm._v("\n      (213) 740-7445\n    ")])}]
var AcademicResources_esExports = { render: AcademicResources_render, staticRenderFns: AcademicResources_staticRenderFns }
/* harmony default export */ var resources_AcademicResources = (AcademicResources_esExports);
// CONCATENATED MODULE: ./src/pages/resources/AcademicResources.vue
function AcademicResources_injectStyle (ssrContext) {
  __webpack_require__("fgit")
}
var AcademicResources_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AcademicResources___vue_template_functional__ = false
/* styles */
var AcademicResources___vue_styles__ = AcademicResources_injectStyle
/* scopeId */
var AcademicResources___vue_scopeId__ = "data-v-3aac3c0c"
/* moduleIdentifier (server only) */
var AcademicResources___vue_module_identifier__ = null
var AcademicResources_Component = AcademicResources_normalizeComponent(
  AcademicResources,
  resources_AcademicResources,
  AcademicResources___vue_template_functional__,
  AcademicResources___vue_styles__,
  AcademicResources___vue_scopeId__,
  AcademicResources___vue_module_identifier__
)

/* harmony default export */ var pages_resources_AcademicResources = (AcademicResources_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/Libraries.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Libraries = ({
  name: 'Libraries',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Libraries',
        loResSrc: '../../../static/HeroImages/Resources3.jpg',
        hiResSrc: '../../../static/HeroImages/Resources3.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Libraries');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dae22a62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/Libraries.vue
var Libraries_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Libraries"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var Libraries_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Libraries")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Accounting Library")]),_c('br'),_vm._v("\n      Accounting 105"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/accounting-library","target":"_blank"}},[_vm._v("https://libraries.usc.edu/locations/accounting-library")]),_c('br'),_vm._v("\n      (213) 740-5027\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Gaughan & Tiberti Business Library")]),_c('br'),_vm._v("\n      Fertitta Hall 101"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/gaughan-tiberti-library","target":"_blank"}},[_vm._v("https://libraries.usc.edu/locations/gaughan-tiberti-library")]),_c('br'),_vm._v("\n      (213) 740-8520\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Doheny Memorial Library")]),_c('br'),_vm._v("\n      3550 Trousdale Parkway"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/doheny-memorial-library","target":"_blank"}},[_vm._v("https://libraries.usc.edu/locations/doheny-memorial-library")]),_c('br'),_vm._v("\n      (213) 740-2924\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Leavey Library")]),_c('br'),_vm._v("\n      651 West 35th Street"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"mailto:lvy@usc.edu"}},[_vm._v("lvy@usc.edu")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://libraries.usc.edu/locations/leavey-library","target":"_blank"}},[_vm._v("https://libraries.usc.edu/locations/leavey-library")]),_c('br')])])}]
var Libraries_esExports = { render: Libraries_render, staticRenderFns: Libraries_staticRenderFns }
/* harmony default export */ var resources_Libraries = (Libraries_esExports);
// CONCATENATED MODULE: ./src/pages/resources/Libraries.vue
function Libraries_injectStyle (ssrContext) {
  __webpack_require__("pmbp")
}
var Libraries_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Libraries___vue_template_functional__ = false
/* styles */
var Libraries___vue_styles__ = Libraries_injectStyle
/* scopeId */
var Libraries___vue_scopeId__ = "data-v-dae22a62"
/* moduleIdentifier (server only) */
var Libraries___vue_module_identifier__ = null
var Libraries_Component = Libraries_normalizeComponent(
  Libraries,
  resources_Libraries,
  Libraries___vue_template_functional__,
  Libraries___vue_styles__,
  Libraries___vue_scopeId__,
  Libraries___vue_module_identifier__
)

/* harmony default export */ var pages_resources_Libraries = (Libraries_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/AdministrativeServices.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var AdministrativeServices = ({
  name: 'AdministrativeServices',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Administrative Services',
        loResSrc: '../../../static/HeroImages/Resources5.jpg',
        hiResSrc: '../../../static/HeroImages/Resources5.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Administrative Services');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c874441","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/AdministrativeServices.vue
var AdministrativeServices_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AdministrativeServices"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var AdministrativeServices_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Administrative Services")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Lost and Found")]),_c('br'),_vm._v("\n      Parking Structure A"),_c('br'),_vm._v("\n      (213) 740-9759\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USCard Services (university ID)")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://mycard.usc.edu","target":"_blank"}},[_vm._v("https://mycard.usc.edu")])]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Mailing Services")]),_c('br'),_vm._v("\n      McCarthy Structure"),_c('br'),_vm._v("\n      (213) 821-1200"),_c('br'),_vm._v("\n      (213) 740-2467 (Mail Stop)\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Office of Sustainability")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://green.usc.edu","target":"_blank"}},[_vm._v("https://green.usc.edu")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Ticket Office")]),_c('br'),_vm._v("\n      Galen Center Box Office"),_c('br'),_vm._v("\n      (213) 740-4672\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("University Operator")]),_c('br'),_vm._v("\n      (213) 740-2311\n    ")])])}]
var AdministrativeServices_esExports = { render: AdministrativeServices_render, staticRenderFns: AdministrativeServices_staticRenderFns }
/* harmony default export */ var resources_AdministrativeServices = (AdministrativeServices_esExports);
// CONCATENATED MODULE: ./src/pages/resources/AdministrativeServices.vue
function AdministrativeServices_injectStyle (ssrContext) {
  __webpack_require__("64tm")
}
var AdministrativeServices_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AdministrativeServices___vue_template_functional__ = false
/* styles */
var AdministrativeServices___vue_styles__ = AdministrativeServices_injectStyle
/* scopeId */
var AdministrativeServices___vue_scopeId__ = "data-v-6c874441"
/* moduleIdentifier (server only) */
var AdministrativeServices___vue_module_identifier__ = null
var AdministrativeServices_Component = AdministrativeServices_normalizeComponent(
  AdministrativeServices,
  resources_AdministrativeServices,
  AdministrativeServices___vue_template_functional__,
  AdministrativeServices___vue_styles__,
  AdministrativeServices___vue_scopeId__,
  AdministrativeServices___vue_module_identifier__
)

/* harmony default export */ var pages_resources_AdministrativeServices = (AdministrativeServices_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/WellnessSafety.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var WellnessSafety = ({
  name: 'WellnessSafety',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Wellness and Safety',
        loResSrc: '../../../static/Wellness-Safety_Hdr.jpeg',
        hiResSrc: '../../../static/Wellness-Safety_Hdr.jpeg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'WellnessSafety');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c81a1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/WellnessSafety.vue
var WellnessSafety_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"WellnessSafety"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var WellnessSafety_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Wellness and Safety")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Counseling and Mental Health")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://sites.usc.edu/counselingandmentalhealth/","target":"_blank"}},[_vm._v("https://sites.usc.edu/counselingandmentalhealth/")]),_c('br'),_vm._v("\n      Crisis support 24/7\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Department of Public Safety")]),_c('br'),_vm._v("\n      Parking Structure A"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://dps.usc.edu","target":"_blank"}},[_vm._v("https://dps.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-4321 (emergencies)"),_c('br'),_vm._v("\n      (213) 740-6000 (general)\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Engemann Student Health Center")]),_c('br'),_vm._v("\n      1031 W. 34th Street "),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://studenthealth.usc.edu","target":"_blank"}},[_vm._v("https://studenthealth.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-9355\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Health Center Pharmacy")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://pharmacies.usc.edu/pharmacies/usc-health-center-pharmacy/","target":"_blank"}},[_vm._v("https://pharmacies.usc.edu/pharmacies/usc-health-center-pharmacy/")]),_c('br'),_vm._v("\n      1150 West Jefferson Blvd., Suite 150"),_c('br'),_vm._v("\n      (213) 821-6100\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Health Center Pharmacy vending machine")]),_c('br'),_vm._v("\n      King Hall lobby (wellness-to-go 24/7)\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Dental Plan Option")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://www1.deltadentalins.com/group-sites/usc.html","target":"_blank"}},[_vm._v("https://www1.deltadentalins.com/group-sites/usc.html")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Student Health")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://studenthealth.usc.edu","target":"_blank"}},[_vm._v("https://studenthealth.usc.edu")]),_c('br'),_vm._v("\n      (213) 740-WELL (9355)\n    ")])])}]
var WellnessSafety_esExports = { render: WellnessSafety_render, staticRenderFns: WellnessSafety_staticRenderFns }
/* harmony default export */ var resources_WellnessSafety = (WellnessSafety_esExports);
// CONCATENATED MODULE: ./src/pages/resources/WellnessSafety.vue
function WellnessSafety_injectStyle (ssrContext) {
  __webpack_require__("ljeg")
}
var WellnessSafety_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WellnessSafety___vue_template_functional__ = false
/* styles */
var WellnessSafety___vue_styles__ = WellnessSafety_injectStyle
/* scopeId */
var WellnessSafety___vue_scopeId__ = "data-v-e2c81a1a"
/* moduleIdentifier (server only) */
var WellnessSafety___vue_module_identifier__ = null
var WellnessSafety_Component = WellnessSafety_normalizeComponent(
  WellnessSafety,
  resources_WellnessSafety,
  WellnessSafety___vue_template_functional__,
  WellnessSafety___vue_styles__,
  WellnessSafety___vue_scopeId__,
  WellnessSafety___vue_module_identifier__
)

/* harmony default export */ var pages_resources_WellnessSafety = (WellnessSafety_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/ResourceStudentOrganizations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var ResourceStudentOrganizations = ({
  name: 'ResourceStudentOrganizations',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Student Organizations and Affinity Groups',
        loResSrc: '../../../static/HeroImages/Resources2.jpg',
        hiResSrc: '../../../static/HeroImages/Resources2.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Student Organizations and Affinity Groups');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7243e3f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/ResourceStudentOrganizations.vue
var ResourceStudentOrganizations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ResourceStudentOrganizations"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var ResourceStudentOrganizations_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Student Organizations and Affinity Groups")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Student Organizations")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://campusactivities.usc.edu/programs/recognized-student-organizations/","target":"_blank"}},[_vm._v("https://campusactivities.usc.edu/programs/recognized-student-organizations/")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Volunteer Center")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://campusactivities.usc.edu/programs/volunteer/","target":"_blank"}},[_vm._v("https://campusactivities.usc.edu/programs/volunteer/")])])])}]
var ResourceStudentOrganizations_esExports = { render: ResourceStudentOrganizations_render, staticRenderFns: ResourceStudentOrganizations_staticRenderFns }
/* harmony default export */ var resources_ResourceStudentOrganizations = (ResourceStudentOrganizations_esExports);
// CONCATENATED MODULE: ./src/pages/resources/ResourceStudentOrganizations.vue
function ResourceStudentOrganizations_injectStyle (ssrContext) {
  __webpack_require__("log1")
}
var ResourceStudentOrganizations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResourceStudentOrganizations___vue_template_functional__ = false
/* styles */
var ResourceStudentOrganizations___vue_styles__ = ResourceStudentOrganizations_injectStyle
/* scopeId */
var ResourceStudentOrganizations___vue_scopeId__ = "data-v-7243e3f2"
/* moduleIdentifier (server only) */
var ResourceStudentOrganizations___vue_module_identifier__ = null
var ResourceStudentOrganizations_Component = ResourceStudentOrganizations_normalizeComponent(
  ResourceStudentOrganizations,
  resources_ResourceStudentOrganizations,
  ResourceStudentOrganizations___vue_template_functional__,
  ResourceStudentOrganizations___vue_styles__,
  ResourceStudentOrganizations___vue_scopeId__,
  ResourceStudentOrganizations___vue_module_identifier__
)

/* harmony default export */ var pages_resources_ResourceStudentOrganizations = (ResourceStudentOrganizations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/resources/AthleticsRecreations.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var AthleticsRecreations = ({
  name: 'AthleticsRecreations',
  components: {
    'usc-hero': src_components_Hero,
    'usc-intro': src_components_Intro,
    'usc-cta': src_components_Cta,
    'usc-videoEmbed': src_components_videoEmbed,
    'usc-linkGroup': src_components_LinkGroup
  },
  data: function data() {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Athletics and Recreations',
        loResSrc: '../../../static/HeroImages/Resources1.jpg',
        hiResSrc: '../../../static/HeroImages/Resources1.jpg'
      },
      intro: ['There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [{
            text: 'USC',
            url: 'https://www.usc.edu/'
          }, {
            text: 'USC Marshall',
            url: 'https://www.marshall.usc.edu/'
          }]
        },
        1: {
          title: 'Helpful Web Links',
          links: [{
            text: 'Academic Calendar',
            url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
          }, {
            text: 'Athletics',
            url: 'http://usctrojans.com/'
          }, {
            text: 'Bookstore',
            url: 'https://www.uscbookstore.com/'
          }, {
            text: 'Catalogue',
            url: 'http://catalogue.usc.edu/'
          }, {
            text: 'Class Schedule',
            url: 'http://classes.usc.edu/'
          }, {
            text: 'Center for Black Cultural and Student Affairs',
            url: 'https://cbcsa.usc.edu/'
          }, {
            text: 'El Centro Chicano',
            url: 'http://sait.usc.edu/elcentro/'
          }, {
            text: 'Financial Aid',
            url: 'https://financialaid.usc.edu/'
          }, {
            text: 'Housing',
            url: 'http://housing.usc.edu/'
          }, {
            text: 'Marshall Mashup (Current Student Blogs)',
            url: 'http://marshallmashup.usc.edu'
          }, {
            text: 'OASIS',
            url: 'https://usc.edu/OASIS'
          }, {
            text: 'Orientation',
            url: 'https://orientation.usc.edu/'
          }, {
            text: 'Recreational Sports',
            url: 'https://sait.usc.edu/recsports/'
          }, {
            text: 'Student Health Center',
            url: 'http://engemannshc.usc.edu/'
          }, {
            text: 'Student Organizations',
            url: 'http://campusactivities.usc.edu/'
          }, {
            text: 'Transportation Services',
            url: 'http://transnet.usc.edu/'
          }, {
            text: 'Undergraduate Admissions',
            url: 'http://admit.usc.edu/'
          }, {
            text: 'Volunteer Center',
            url: 'http://campusactivities.usc.edu/'
          }]
        }
      }
    };
  },
  created: function created() {
    this.$root.setPageHeader('Resources', 'Athletics and Recreations');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608aeee4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources/AthleticsRecreations.vue
var AthleticsRecreations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AthleticsRecreations"}},[_c('usc-hero',{attrs:{"title":this.hero.title,"loResSrc":this.hero.loResSrc,"hiResSrc":this.hero.hiResSrc,"color":this.page.color}}),_vm._v(" "),_c('usc-intro',{attrs:{"copy":this.intro}}),_vm._v(" "),_vm._m(0)],1)}
var AthleticsRecreations_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body mb gutter-lg"},[_c('h2',[_vm._v("Athletics and Recreation")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Intercollegiate Athletics")]),_c('br'),_vm._v("\n      Galen Box Office (tickets)"),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://usctrojans.com","target":"_blank"}},[_vm._v("https://usctrojans.com (schedule)")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Recreational Sports")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"inline-hyperlink",attrs:{"href":"https://recsports.usc.edu","target":"_blank"}},[_vm._v("https://recsports.usc.edu")]),_c('br')]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("Lyon Recreational Center")]),_c('br'),_vm._v("\n      1026 W. 34th Street\n      "),_c('br'),_vm._v("\n      (213) 740-5127\n    ")]),_vm._v(" "),_c('address',[_c('strong',[_vm._v("USC Village Fitness Center")]),_c('br'),_vm._v("\n      929 W. Jefferson Blvd., Suite 1665"),_c('br'),_vm._v("\n      (213) 764-7940\n    ")])])}]
var AthleticsRecreations_esExports = { render: AthleticsRecreations_render, staticRenderFns: AthleticsRecreations_staticRenderFns }
/* harmony default export */ var resources_AthleticsRecreations = (AthleticsRecreations_esExports);
// CONCATENATED MODULE: ./src/pages/resources/AthleticsRecreations.vue
function AthleticsRecreations_injectStyle (ssrContext) {
  __webpack_require__("0RC3")
}
var AthleticsRecreations_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AthleticsRecreations___vue_template_functional__ = false
/* styles */
var AthleticsRecreations___vue_styles__ = AthleticsRecreations_injectStyle
/* scopeId */
var AthleticsRecreations___vue_scopeId__ = "data-v-608aeee4"
/* moduleIdentifier (server only) */
var AthleticsRecreations___vue_module_identifier__ = null
var AthleticsRecreations_Component = AthleticsRecreations_normalizeComponent(
  AthleticsRecreations,
  resources_AthleticsRecreations,
  AthleticsRecreations___vue_template_functional__,
  AthleticsRecreations___vue_styles__,
  AthleticsRecreations___vue_scopeId__,
  AthleticsRecreations___vue_module_identifier__
)

/* harmony default export */ var pages_resources_AthleticsRecreations = (AthleticsRecreations_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/SiteMap.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SiteMap = ({
  name: 'Sitemap'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77698b7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SiteMap.vue
var SiteMap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sitemap"}},[_c('div',{staticClass:"body gutter-lg mb"},[_c('h1',{staticClass:"sitemaptitle"},[_vm._v("Site Map")]),_vm._v(" "),_c('h2',[_vm._v("Homepage")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/","aria-label":"Link to Sitemap"}},[_vm._v("Welcome")])],1),_vm._v(" "),_c('h2',[_vm._v("Academics")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/academics/overview","aria-label":"Overview"}},[_vm._v("Overview")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/undergraduate-business","aria-label":"Undergraduate Business Administration"}},[_vm._v("Undergraduate Business Administration")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/world-bachelor-business","aria-label":"World Bachelor in Business"}},[_vm._v("World Bachelor in Business")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/undergraduate-accounting","aria-label":"Undergraduate Accounting"}},[_vm._v("Undergraduate Accounting")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/business-cinematic-arts","aria-label":"Business Cinematic Arts"}},[_vm._v("Business Cinematic Arts")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/realestate","aria-label":"Real Estate Finance + Development (REFD)"}},[_vm._v("Real Estate Finance + Development (REFD)")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/artificial-intelligence-for-business","aria-label":"Artificial Intelligence for Business"}},[_vm._v("Artificial Intelligence for Business")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/double-majors-minors","aria-label":"Double Majors and Minors"}},[_vm._v("Double Majors and Minors")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/academics/electives","aria-label":"Electives"}},[_vm._v("Electives")])],1)]),_vm._v(" "),_c('h2',[_vm._v("Advantages")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/advantages/experiential-learning","aria-label":"Experiential Learning"}},[_vm._v("Experiential Learning")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/global-opportunities","aria-label":"Global Opportunities"}},[_vm._v("Global Opportunities")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/careers-internships","aria-label":"Internships and Career Services"}},[_vm._v("Internships and Career Services")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/thematic-option-program-and-scholar-distinctions","aria-label":"Scholar Distinction"}},[_vm._v("Scholar Distinction")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/faculty","aria-label":"Faculty"}},[_vm._v("Faculty")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/visiting-speakers","aria-label":"Visiting Speakers"}},[_vm._v("Visiting Speakers")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/advantages/la-advantages","aria-label":"L.A. Advantages"}},[_vm._v("L.A. Advantages")])],1)]),_vm._v(" "),_c('h2',[_vm._v("Campus Life")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/campus-life/student-organizations","aria-label":"Student Organizations"}},[_vm._v("Student Organizations")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/community-involvement","aria-label":"Community Engagement"}},[_vm._v("Community Engagement")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/recreational-sports","aria-label":"Recreational Sports"}},[_vm._v("Recreational Sports")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/enjoying-la","aria-label":"Enjoying Los Angeles"}},[_vm._v("Enjoying Los Angeles")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/facilities","aria-label":"Facilities"}},[_vm._v("Facilities")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/usc-housing","aria-label":"USC Housing"}},[_vm._v("USC Housing")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/campus-life/transportation","aria-label":"Transportation"}},[_vm._v("Transportation")])],1)]),_vm._v(" "),_c('h2',[_vm._v("Next Step")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/next-steps","aria-label":"Next Steps"}},[_vm._v("Next Steps")])],1),_vm._v(" "),_c('h2',[_vm._v("Resources")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/resources/marshall-undergraduate-programs","aria-label":"Marshall Undergraduate Programs"}},[_vm._v("Marshall Undergraduate Programs")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/usc-admissions-finaid-students-accounts","aria-label":"USC Admissions, Financial Aid and Student Accounts"}},[_vm._v("USC Admissions, Financial Aid and Student Accounts")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/housing-transportation","aria-label":"Housing and Transportation"}},[_vm._v("Housing and Transportation")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/international-students","aria-label":"International Students"}},[_vm._v("International Students")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/orientation-and-tours","aria-label":"Orientation and Tours"}},[_vm._v("Orientation and Tours")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/academic-resources","aria-label":"Academic Resources"}},[_vm._v("Academic Resources")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/libraries","aria-label":"Libraries"}},[_vm._v("Libraries")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/administrative-services","aria-label":"Administrative Services"}},[_vm._v("Administrative Services")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/wellness-safety","aria-label":"Wellness and Safety"}},[_vm._v("Wellness and Safety")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/student-organizations","aria-label":"Student Organizations and Affinity Groups"}},[_vm._v("Student Organizations and Affinity Groups")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/resources/athletics-recreation","aria-label":"Athletics and Recreations"}},[_vm._v("Athletics and Recreations")])],1)])])])}
var SiteMap_staticRenderFns = []
var SiteMap_esExports = { render: SiteMap_render, staticRenderFns: SiteMap_staticRenderFns }
/* harmony default export */ var pages_SiteMap = (SiteMap_esExports);
// CONCATENATED MODULE: ./src/pages/SiteMap.vue
function SiteMap_injectStyle (ssrContext) {
  __webpack_require__("vKHC")
}
var SiteMap_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SiteMap___vue_template_functional__ = false
/* styles */
var SiteMap___vue_styles__ = SiteMap_injectStyle
/* scopeId */
var SiteMap___vue_scopeId__ = "data-v-77698b7e"
/* moduleIdentifier (server only) */
var SiteMap___vue_module_identifier__ = null
var SiteMap_Component = SiteMap_normalizeComponent(
  SiteMap,
  pages_SiteMap,
  SiteMap___vue_template_functional__,
  SiteMap___vue_styles__,
  SiteMap___vue_scopeId__,
  SiteMap___vue_module_identifier__
)

/* harmony default export */ var src_pages_SiteMap = (SiteMap_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js










































// import NotFound from '@/pages/NotFound'

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

// NOTE: These routes must match the sidenav var in App.vue
// TODO: Should have used meta for the titles, suffixes, and whatnot... oops
// TODO: Should try to get the routes to mimic the nav structure (nested)
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/sitemap',
    name: 'sitemap',
    component: src_pages_SiteMap
  }, {
    path: '/',
    name: 'welcome-congrats',
    component: src_pages_Welcome
  }, {
    path: '/academics/overview',
    name: 'academics-overview',
    component: pages_academics_Overview
  }, {
    path: '/academics/undergraduate-business',
    name: 'academics-undergrad-ba',
    component: pages_academics_UndergradBA
  }, {
    path: '/academics/undergraduate-accounting',
    name: 'academics-undergrad-accounting',
    component: pages_academics_UndergradAccounting
  }, {
    path: '/academics/world-bachelor-business',
    name: 'academics-wbb',
    component: pages_academics_Wbb
  }, {
    path: '/academics/business-cinematic-arts',
    name: 'academics-business-cinematic-arts',
    component: pages_academics_BusinessCinematicArts
  }, {
    path: '/academics/realestate',
    name: 'academics-realestate',
    component: pages_academics_RealEstate
  }, {
    path: '/academics/artificial-intelligence-for-business',
    name: 'academics-aib',
    component: pages_academics_AiForBusiness
  }, {
    path: '/academics/double-majors-minors',
    name: 'academics-double-majors',
    component: pages_academics_DoubleMajors
  }, {
    path: '/academics/electives',
    name: 'academics-electives',
    component: pages_academics_Electives
  }, {
    path: '/advantages/thematic-option-program-and-scholar-distinctions',
    name: 'advantages-thematic',
    component: pages_advantages_Thematic
  }, {
    path: '/advantages/faculty',
    name: 'academics-faculty',
    component: pages_advantages_Faculty
  }, {
    path: '/academics/thought-leaders',
    name: 'academics-thought-leaders',
    component: pages_academics_ThoughtLeaders
  }, {
    path: '/advantages/experiential-learning',
    name: 'opportunities-experiential-learning',
    component: pages_advantages_ExperientialLearning
  }, {
    path: '/advantages/careers-internships',
    name: 'opportunities-internships',
    component: pages_advantages_Internships
  }, {
    path: '/advantages/scholar-programs',
    name: 'opportunities-scholar-programs',
    component: pages_advantages_ScholarPrograms
  }, {
    path: '/campus-life/student-organizations',
    name: 'opportunities-student-organizations',
    component: pages_life_at_marshall_StudentOrganizations
  }, {
    path: '/campus-life/community-involvement',
    name: 'opportunities-community-involvement',
    component: pages_life_at_marshall_CommunityInvolvement
  }, {
    path: '/campus-life/recreational-sports',
    name: 'opportunities-recreational-sports',
    component: pages_life_at_marshall_RecreationalSports
  }, {
    path: '/advantages/visiting-speakers',
    name: 'opportunities-visiting-speakers',
    component: pages_advantages_VisitingSpeakers
  }, {
    path: '/advantages/la-advantages',
    name: 'opportunities-why-la',
    component: pages_life_at_marshall_WhyLA
  }, {
    path: '/advantages/global-opportunities',
    name: 'opportunities-global-opportunities',
    component: pages_advantages_GlobalOpportunities
  }, {
    path: '/campus-life/enjoying-la',
    name: 'opportunities-enjoying-la',
    component: pages_advantages_EnjoyingLA
  }, {
    path: '/campus-life/facilities',
    name: 'life-facilities',
    component: pages_life_at_marshall_Facilities
  }, {
    path: '/campus-life/usc-housing',
    name: 'life-residence-halls',
    component: pages_life_at_marshall_ResidenceHalls
  }, {
    path: '/campus-life/special-interest-communities',
    name: 'life-special-interest-communities',
    component: pages_life_at_marshall_SpecialInterestCommunities
  }, {
    path: '/campus-life/transportation',
    name: 'life-transportation',
    component: pages_life_at_marshall_Transportation
  }, {
    path: '/next-steps',
    name: 'next-steps',
    component: src_pages_NextSteps
  }, {
    path: '/resources/marshall-undergraduate-programs',
    name: 'resources-marshall-undergraduate-programs',
    component: pages_resources_MarshallUndergraduatePrograms
  }, {
    path: '/resources/usc-admissions-finaid-students-accounts',
    name: 'resources-usc-admissions-financial-aid-student-accounts',
    component: pages_resources_USCAdmissions
  }, {
    path: '/resources/housing-transportation',
    name: 'resources-housing-transportation',
    component: pages_resources_HousingTransportation
  }, {
    path: '/resources/international-students',
    name: 'resources-international-students',
    component: pages_resources_InternationalStudents
  }, {
    path: '/resources/orientation-and-tours',
    name: 'resources-oreintation-tours',
    component: pages_resources_OrientationTours
  }, {
    path: '/resources/academic-resources',
    name: 'resources-academic-resources',
    component: pages_resources_AcademicResources
  }, {
    path: '/resources/libraries',
    name: 'resources-libraries',
    component: pages_resources_Libraries
  }, {
    path: '/resources/administrative-services',
    name: 'resources-administrative-services',
    component: pages_resources_AdministrativeServices
  }, {
    path: '/resources/wellness-safety',
    name: 'resources-wellness-safety',
    component: pages_resources_WellnessSafety
  }, {
    path: '/resources/student-organizations',
    name: 'resources-student-organizations',
    component: pages_resources_ResourceStudentOrganizations
  }, {
    path: '/resources/athletics-recreation',
    name: 'resources-athletics-recreations',
    component: pages_resources_AthleticsRecreations
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["a" /* default */].use(vuetify_default.a, { theme: {
    primary: '#1A0DAB',
    secondary: '#000',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  } });

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  data: function data() {
    return {
      pageHeader: {
        section: null,
        title: null
      },
      // NOTE: Sidenav routes are the names of the routes from routes/index.js
      // TODO: Should have used route meta for the titles, suffixes, and whatnot... oops
      // Would have reduced duplication
      sidenav: [{
        title: 'Welcome',
        classSuffix: 'intro',
        route: 'welcome-congrats'
      }, {
        title: 'Academics',
        classSuffix: 'academics',
        items: [{
          title: 'Overview',
          route: 'academics-overview'
        }, {
          title: 'Undergraduate Business Administration',
          route: 'academics-undergrad-ba'
        }, {
          title: 'World Bachelor in Business',
          route: 'academics-wbb'
        }, {
          title: 'Undergraduate Accounting',
          route: 'academics-undergrad-accounting'
        }, {
          title: 'Business Cinematic Arts',
          route: 'academics-business-cinematic-arts'
        }, {
          title: 'Real Estate Finance + Development',
          route: 'academics-realestate'
        }, {
          title: 'Artificial Intelligence for Business',
          route: 'academics-aib'
        }, {
          title: 'Double Majors and Minors',
          route: 'academics-double-majors'
        }, {
          title: 'Electives',
          route: 'academics-electives'
        }]
      }, {
        title: 'Advantages',
        classSuffix: 'opportunities',
        items: [{
          title: 'Experiential Learning',
          route: 'opportunities-experiential-learning'
        }, {
          title: 'Global Opportunities',
          route: 'opportunities-global-opportunities'
        }, {
          title: 'Interships and Career Services',
          route: 'opportunities-internships'
        }, {
          title: 'Scholar Distinction',
          route: 'advantages-thematic'
        }, {
          title: 'Faculty',
          route: 'academics-faculty'
        }, {
          title: 'Visiting Speakers',
          route: 'opportunities-visiting-speakers'
        }, {
          title: 'L.A. Advantages',
          route: 'opportunities-why-la'
        }]
      }, {
        title: 'Campus Life',
        classSuffix: 'life',
        items: [{
          title: 'Student Organizations',
          route: 'opportunities-student-organizations'
        }, {
          title: 'Community Engagement',
          route: 'opportunities-community-involvement'
        }, {
          title: 'Recreational Sports',
          route: 'opportunities-recreational-sports'
        }, {
          title: 'Enjoying Los Angeles',
          route: 'opportunities-enjoying-la'
        }, {
          title: 'Facilities',
          route: 'life-facilities'
        }, {
          title: 'USC Housing',
          route: 'life-residence-halls'
        }, {
          title: 'Transportation',
          route: 'life-transportation'
        }]
      }, {
        title: 'Next Steps',
        route: 'next-steps',
        classSuffix: 'next_steps'
      }, {
        title: 'Resources',
        classSuffix: 'resources',
        items: [{
          title: 'Marshall Undergraduate Programs',
          route: 'resources-marshall-undergraduate-programs'
        }, {
          title: 'USC Admissions, Financial Aid, and Student Accounts',
          route: 'resources-usc-admissions-financial-aid-student-accounts'
        }, {
          title: 'Housing and Transportation',
          route: 'resources-housing-transportation'
        }, {
          title: 'International Students',
          route: 'resources-international-students'
        }, {
          title: 'Orientation and Tours',
          route: 'resources-oreintation-tours'
        }, {
          title: 'Academic Resources',
          route: 'resources-academic-resources'
        }, {
          title: 'Libraries',
          route: 'resources-libraries'
        }, {
          title: 'Administrative Services',
          route: 'resources-administrative-services'
        }, {
          title: 'Wellness and Safety',
          route: 'resources-wellness-safety'
        }, {
          title: 'Student Organizations and Affinity Groups',
          route: 'resources-student-organizations'
        }, {
          title: 'Athletics and Recreation',
          route: 'resources-athletics-recreations'
        }]
      }]
    };
  },

  methods: {
    setPageHeader: function setPageHeader(section, title) {
      this.pageHeader.section = section;
      this.pageHeader.title = title;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // Wipe the page header properties and let the pages re-populate them
      this.$root.pageHeader.section = null;
      this.$root.pageHeader.title = null;
    }
  },
  created: function created() {
    /* Hack to put the section class suffix on the route information
    so it can colorize the section nav */
    this.sidenav.forEach(function (n) {
      if (n.items) {
        n.items.forEach(function (i) {
          i.classSuffix = n.classSuffix;
        });
      }
    });
  },

  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NZJK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-realestatefinance.ff008ab.png";

/***/ }),

/***/ "Nxd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/leventhal-No4_USNews.43efcd4.png";

/***/ }),

/***/ "OB9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PZMn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PeyX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-business-admin.0c4b179.png";

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QbaH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/r1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R0vA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R97x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "REfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RkOG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA2LjYgMTQuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNi42IDE0LjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPHBvbHlsaW5lIGNsYXNzPSJzdDAiIHBvaW50cz0iMC44LDEuMSA1LjYsNy4xIDAuOCwxMy4xICIvPgo8L3N2Zz4K"

/***/ }),

/***/ "SbFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sf/X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T8k0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ti9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TyX8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/living-at-usc-housing.93070b9.jpg";

/***/ }),

/***/ "U3Z0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UE4i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UfTb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Up7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uqfa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-riskmanagement.758caa4.png";

/***/ }),

/***/ "UtOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VPos":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/usc_mobile_badge.f6498ce.svg";

/***/ }),

/***/ "Vm2W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Sports.97d8657.jpg";

/***/ }),

/***/ "WYVp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi4yIDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzIzMWYyMDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmxhcmdlX2Fycm93PC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsMjNhMSwxLDAsMCwxLC4yNi0uNjdMOS41MSwxMiwuMjYsMS42N0ExLDEsMCwwLDEsLjMzLjI2LDEsMSwwLDAsMSwxLjc1LjMzTDEyLjIsMTIsMS43NSwyMy42N2ExLDEsMCwwLDEtMS40Mi4wOEExLDEsMCwwLDEsMCwyM1oiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "X+KW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/welcome-lifelong-worldwide-24.4443bd3.png";

/***/ }),

/***/ "XBFn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YMuF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/academics-WBB-misc.a467d80.png";

/***/ }),

/***/ "YrLr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YrMk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_BCA_R3.17be5c1.png";

/***/ }),

/***/ "Z6vt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/customize-your-degree-24.913a28e.png";

/***/ }),

/***/ "aGOz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b3wA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b9Z5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_Visiting_Speakers_2.6547f37.jpg";

/***/ }),

/***/ "bU5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "beic":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/internships-24.5c4f852.png";

/***/ }),

/***/ "blUE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/post-grad-salaries.18d0124.jpg";

/***/ }),

/***/ "dFWp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e5AR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/community-and-service-learning-thumbnail.a8690f1.jpg";

/***/ }),

/***/ "eApo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_BUAI_R3.68c34d3.png";

/***/ }),

/***/ "eHl1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_WBB_R2.c240f5d.png";

/***/ }),

/***/ "eNHY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-ai-business.c658788.png";

/***/ }),

/***/ "fDuq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Shopping.c6703fd.jpg";

/***/ }),

/***/ "fYaB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "feuz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-accounting.dea0c86.png";

/***/ }),

/***/ "fgit":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gPoh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Museums.2fa65e3.jpg";

/***/ }),

/***/ "goj5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/USC_Marshall_CurriculumMap_2023_REFD_R2.5232c03.png";

/***/ }),

/***/ "hGbN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/welcome-infinite-possibility-24.683b433.png";

/***/ }),

/***/ "hLXr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hW/J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hodW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jOvh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k4aF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Pop_Venues.b3fa705.jpg";

/***/ }),

/***/ "kZP/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-marketing.f3c43aa.png";

/***/ }),

/***/ "kuak":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7-Secrets-of-Fertitta-Hall-at-USC-Marshall-thumbnail.90a0aa3.jpg";

/***/ }),

/***/ "ljeg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "log1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpJo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lyf9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/info-ADVANTAGES-internships-career-services.5b99cf9.png";

/***/ }),

/***/ "mFQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mHj9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/usc_marshall_footer_logo.c24a552.svg";

/***/ }),

/***/ "nSxd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pWHp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_Visiting_Speakers_5.790f15e.jpg";

/***/ }),

/***/ "pmbp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q0eN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/explore-your-interests-24.db1520d.png";

/***/ }),

/***/ "qumo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "qv8h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/academics-curriculum-structure-24.c8588d6.png";

/***/ }),

/***/ "rHc2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Opportunities_EnjoyingLA_Attractions.72c7c35.jpg";

/***/ }),

/***/ "sDBh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sG2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tv96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKHC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xR9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yG8X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23-businessanalytics.ed33439.png";

/***/ }),

/***/ "yclz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yzTS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zKra":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.5b0fb985c964b2dbbe77.js